import { useMutation, useQuery, UseMutationOptions, UseQueryOptions } from '@tanstack/react-query';
import { fetcher } from 'src/graphql/api/graphql-client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  AboutUsBlocksDynamicZoneInput: { input: any; output: any; }
  ArticleDynamicBlocksDynamicZoneInput: { input: any; output: any; }
  CaseStudyContentBlocksDynamicZoneInput: { input: any; output: any; }
  Date: { input: DateLike; output: DateLike; }
  DateTime: { input: DateLike; output: DateLike; }
  HomeBlocksDynamicZoneInput: { input: any; output: any; }
  I18NLocaleCode: { input: any; output: any; }
  JSON: { input: any; output: any; }
  Long: { input: any; output: any; }
  PageBlocksDynamicZoneInput: { input: any; output: any; }
  Upload: { input: File; output: File; }
};

export type AboutUs = {
  __typename?: 'AboutUs';
  blocks: Array<Maybe<AboutUsBlocksDynamicZone>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  leaderships: LeadershipRelationResponseCollection;
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<AboutUsRelationResponseCollection>;
  metadata: ComponentMetaMetadata;
  partners: PartnerRelationResponseCollection;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  statistics: Array<Maybe<ComponentAboutUsStatistics>>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type AboutUsLeadershipsArgs = {
  filters?: InputMaybe<LeadershipFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type AboutUsLocalizationsArgs = {
  publicationState?: InputMaybe<PublicationState>;
};


export type AboutUsPartnersArgs = {
  filters?: InputMaybe<PartnerFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type AboutUsStatisticsArgs = {
  filters?: InputMaybe<ComponentAboutUsStatisticsFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type AboutUsBlocksDynamicZone = ComponentDynamicBlocksBannerSection | ComponentDynamicBlocksCaseStudiesShowcase | ComponentDynamicBlocksDynamicCaseStudiesPreview | ComponentDynamicBlocksDynamicChartSection | ComponentDynamicBlocksDynamicClientOpinions | ComponentDynamicBlocksDynamicConstantBlock | ComponentDynamicBlocksDynamicDarkInfoDividerBlock | ComponentDynamicBlocksDynamicDividerWithPhotosBlock | ComponentDynamicBlocksDynamicFaces | ComponentDynamicBlocksDynamicFaqBlock | ComponentDynamicBlocksDynamicFeatureListBlock | ComponentDynamicBlocksDynamicGallerySection | ComponentDynamicBlocksDynamicHeroBlock | ComponentDynamicBlocksDynamicHeroWithContactBlock | ComponentDynamicBlocksDynamicHistorySection | ComponentDynamicBlocksDynamicInfoGridBlock | ComponentDynamicBlocksDynamicInfoWithPhotoBlock | ComponentDynamicBlocksDynamicLeadership | ComponentDynamicBlocksDynamicLogosBlock | ComponentDynamicBlocksDynamicMedia | ComponentDynamicBlocksDynamicPartners | ComponentDynamicBlocksDynamicPointsWithPhotosBlock | ComponentDynamicBlocksDynamicRichTextBlock | ComponentDynamicBlocksDynamicScrollSlider | ComponentDynamicBlocksDynamicSeeMoreBlock | ComponentDynamicBlocksDynamicSliderPointsBlock | ComponentDynamicBlocksDynamicStatistics | ComponentDynamicBlocksDynamicTeamInvolved | ComponentDynamicBlocksDynamicTeamInvolvedWithHover | ComponentDynamicBlocksDynamicTestimonialBlock | ComponentDynamicBlocksDynamicTextWithPhotos | ComponentDynamicBlocksDynamicVideoBanner | ComponentDynamicBlocksHowWeWork | ComponentDynamicBlocksLetsBuildBlock | ComponentDynamicBlocksNewsletterBlock | ComponentDynamicBlocksRecommendedArticles | ComponentDynamicBlocksStandaloneContactForm | Error;

export type AboutUsEntity = {
  __typename?: 'AboutUsEntity';
  attributes?: Maybe<AboutUs>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type AboutUsEntityResponse = {
  __typename?: 'AboutUsEntityResponse';
  data?: Maybe<AboutUsEntity>;
};

export type AboutUsInput = {
  blocks?: InputMaybe<Array<Scalars['AboutUsBlocksDynamicZoneInput']['input']>>;
  leaderships?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  metadata?: InputMaybe<ComponentMetaMetadataInput>;
  partners?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  statistics?: InputMaybe<Array<InputMaybe<ComponentAboutUsStatisticsInput>>>;
};

export type AboutUsRelationResponseCollection = {
  __typename?: 'AboutUsRelationResponseCollection';
  data: Array<AboutUsEntity>;
};

export type AddContactInput = {
  captchaToken: Scalars['String']['input'];
  email: Scalars['String']['input'];
};

export type Article = {
  __typename?: 'Article';
  authors: UsersPermissionsUserRelationResponseCollection;
  category: ArticleCategoryEntityResponse;
  content: Scalars['String']['output'];
  coverImage: UploadFileEntityResponse;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  creationDate: Scalars['Date']['output'];
  dynamicBlocks?: Maybe<Array<Maybe<ArticleDynamicBlocksDynamicZone>>>;
  isFeatured: Scalars['Boolean']['output'];
  lead: Scalars['String']['output'];
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<ArticleRelationResponseCollection>;
  metadata: ComponentMetaMetadata;
  minutesOfRead?: Maybe<Scalars['Int']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  slug: Scalars['String']['output'];
  stickyCta?: Maybe<ComponentCommonComponentsStickyCta>;
  tags: ArticleTagRelationResponseCollection;
  title: Scalars['String']['output'];
  titleMarkdown?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type ArticleAuthorsArgs = {
  filters?: InputMaybe<UsersPermissionsUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ArticleLocalizationsArgs = {
  filters?: InputMaybe<ArticleFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ArticleTagsArgs = {
  filters?: InputMaybe<ArticleTagFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ArticleCategory = {
  __typename?: 'ArticleCategory';
  articles?: Maybe<ArticleRelationResponseCollection>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<ArticleCategoryRelationResponseCollection>;
  name: Scalars['String']['output'];
  topCategory: Scalars['Boolean']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type ArticleCategoryArticlesArgs = {
  filters?: InputMaybe<ArticleFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ArticleCategoryLocalizationsArgs = {
  filters?: InputMaybe<ArticleCategoryFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ArticleCategoryEntity = {
  __typename?: 'ArticleCategoryEntity';
  attributes?: Maybe<ArticleCategory>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type ArticleCategoryEntityResponse = {
  __typename?: 'ArticleCategoryEntityResponse';
  data?: Maybe<ArticleCategoryEntity>;
};

export type ArticleCategoryEntityResponseCollection = {
  __typename?: 'ArticleCategoryEntityResponseCollection';
  data: Array<ArticleCategoryEntity>;
  meta: ResponseCollectionMeta;
};

export type ArticleCategoryFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ArticleCategoryFiltersInput>>>;
  articles?: InputMaybe<ArticleFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  locale?: InputMaybe<StringFilterInput>;
  localizations?: InputMaybe<ArticleCategoryFiltersInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ArticleCategoryFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ArticleCategoryFiltersInput>>>;
  topCategory?: InputMaybe<BooleanFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type ArticleCategoryInput = {
  articles?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  topCategory?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ArticleCategoryRelationResponseCollection = {
  __typename?: 'ArticleCategoryRelationResponseCollection';
  data: Array<ArticleCategoryEntity>;
};

export type ArticleDynamicBlocksDynamicZone = ComponentDynamicBlocksBannerSection | ComponentDynamicBlocksCaseStudiesShowcase | ComponentDynamicBlocksDynamicCaseStudiesPreview | ComponentDynamicBlocksDynamicChartSection | ComponentDynamicBlocksDynamicClientOpinions | ComponentDynamicBlocksDynamicConstantBlock | ComponentDynamicBlocksDynamicDarkInfoDividerBlock | ComponentDynamicBlocksDynamicDividerWithPhotosBlock | ComponentDynamicBlocksDynamicFaces | ComponentDynamicBlocksDynamicFaqBlock | ComponentDynamicBlocksDynamicFeatureListBlock | ComponentDynamicBlocksDynamicGallerySection | ComponentDynamicBlocksDynamicHeroBlock | ComponentDynamicBlocksDynamicHeroWithContactBlock | ComponentDynamicBlocksDynamicHistorySection | ComponentDynamicBlocksDynamicInfoGridBlock | ComponentDynamicBlocksDynamicInfoWithPhotoBlock | ComponentDynamicBlocksDynamicLeadership | ComponentDynamicBlocksDynamicLogosBlock | ComponentDynamicBlocksDynamicMedia | ComponentDynamicBlocksDynamicPartners | ComponentDynamicBlocksDynamicPointsWithPhotosBlock | ComponentDynamicBlocksDynamicRichTextBlock | ComponentDynamicBlocksDynamicScrollSlider | ComponentDynamicBlocksDynamicSeeMoreBlock | ComponentDynamicBlocksDynamicSliderPointsBlock | ComponentDynamicBlocksDynamicStatistics | ComponentDynamicBlocksDynamicTeamInvolved | ComponentDynamicBlocksDynamicTeamInvolvedWithHover | ComponentDynamicBlocksDynamicTestimonialBlock | ComponentDynamicBlocksDynamicTextWithPhotos | ComponentDynamicBlocksDynamicVideoBanner | ComponentDynamicBlocksHowWeWork | ComponentDynamicBlocksLetsBuildBlock | ComponentDynamicBlocksNewsletterBlock | ComponentDynamicBlocksRecommendedArticles | ComponentDynamicBlocksStandaloneContactForm | Error;

export type ArticleEntity = {
  __typename?: 'ArticleEntity';
  attributes?: Maybe<Article>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type ArticleEntityResponse = {
  __typename?: 'ArticleEntityResponse';
  data?: Maybe<ArticleEntity>;
};

export type ArticleEntityResponseCollection = {
  __typename?: 'ArticleEntityResponseCollection';
  data: Array<ArticleEntity>;
  meta: ResponseCollectionMeta;
};

export type ArticleFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ArticleFiltersInput>>>;
  authors?: InputMaybe<UsersPermissionsUserFiltersInput>;
  category?: InputMaybe<ArticleCategoryFiltersInput>;
  content?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  creationDate?: InputMaybe<DateFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  isFeatured?: InputMaybe<BooleanFilterInput>;
  lead?: InputMaybe<StringFilterInput>;
  locale?: InputMaybe<StringFilterInput>;
  localizations?: InputMaybe<ArticleFiltersInput>;
  metadata?: InputMaybe<ComponentMetaMetadataFiltersInput>;
  minutesOfRead?: InputMaybe<IntFilterInput>;
  not?: InputMaybe<ArticleFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ArticleFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  slug?: InputMaybe<StringFilterInput>;
  stickyCta?: InputMaybe<ComponentCommonComponentsStickyCtaFiltersInput>;
  tags?: InputMaybe<ArticleTagFiltersInput>;
  title?: InputMaybe<StringFilterInput>;
  titleMarkdown?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  views?: InputMaybe<LongFilterInput>;
};

export type ArticleInput = {
  authors?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  category?: InputMaybe<Scalars['ID']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  coverImage?: InputMaybe<Scalars['ID']['input']>;
  creationDate?: InputMaybe<Scalars['Date']['input']>;
  dynamicBlocks?: InputMaybe<Array<Scalars['ArticleDynamicBlocksDynamicZoneInput']['input']>>;
  isFeatured?: InputMaybe<Scalars['Boolean']['input']>;
  lead?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<ComponentMetaMetadataInput>;
  minutesOfRead?: InputMaybe<Scalars['Int']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  stickyCta?: InputMaybe<ComponentCommonComponentsStickyCtaInput>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  title?: InputMaybe<Scalars['String']['input']>;
  titleMarkdown?: InputMaybe<Scalars['String']['input']>;
  views?: InputMaybe<Scalars['Long']['input']>;
};

export type ArticleRelationResponseCollection = {
  __typename?: 'ArticleRelationResponseCollection';
  data: Array<ArticleEntity>;
};

export type ArticleTag = {
  __typename?: 'ArticleTag';
  articles?: Maybe<ArticleRelationResponseCollection>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<ArticleTagRelationResponseCollection>;
  name: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type ArticleTagArticlesArgs = {
  filters?: InputMaybe<ArticleFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ArticleTagLocalizationsArgs = {
  filters?: InputMaybe<ArticleTagFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ArticleTagEntity = {
  __typename?: 'ArticleTagEntity';
  attributes?: Maybe<ArticleTag>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type ArticleTagEntityResponse = {
  __typename?: 'ArticleTagEntityResponse';
  data?: Maybe<ArticleTagEntity>;
};

export type ArticleTagEntityResponseCollection = {
  __typename?: 'ArticleTagEntityResponseCollection';
  data: Array<ArticleTagEntity>;
  meta: ResponseCollectionMeta;
};

export type ArticleTagFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ArticleTagFiltersInput>>>;
  articles?: InputMaybe<ArticleFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  locale?: InputMaybe<StringFilterInput>;
  localizations?: InputMaybe<ArticleTagFiltersInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ArticleTagFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ArticleTagFiltersInput>>>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type ArticleTagInput = {
  articles?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type ArticleTagRelationResponseCollection = {
  __typename?: 'ArticleTagRelationResponseCollection';
  data: Array<ArticleTagEntity>;
};

export type BooleanFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  contains?: InputMaybe<Scalars['Boolean']['input']>;
  containsi?: InputMaybe<Scalars['Boolean']['input']>;
  endsWith?: InputMaybe<Scalars['Boolean']['input']>;
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  eqi?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  nei?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<BooleanFilterInput>;
  notContains?: InputMaybe<Scalars['Boolean']['input']>;
  notContainsi?: InputMaybe<Scalars['Boolean']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  startsWith?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CaseStudy = {
  __typename?: 'CaseStudy';
  caseStudyCategory?: Maybe<CaseStudyCategoryEntityResponse>;
  caseStudyTags?: Maybe<CaseStudyTagRelationResponseCollection>;
  client: Scalars['String']['output'];
  clientTooltip?: Maybe<Scalars['String']['output']>;
  contentBlocks: Array<Maybe<CaseStudyContentBlocksDynamicZone>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  descriptionMarkdown?: Maybe<Scalars['String']['output']>;
  doodleText?: Maybe<Scalars['String']['output']>;
  image: UploadFileEntityResponse;
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<CaseStudyRelationResponseCollection>;
  location: Scalars['String']['output'];
  metadata: ComponentMetaMetadata;
  position: Scalars['Int']['output'];
  projectStartDate?: Maybe<Scalars['String']['output']>;
  projectStatus?: Maybe<Scalars['String']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
  titleMarkdown?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};


export type CaseStudyCaseStudyTagsArgs = {
  filters?: InputMaybe<CaseStudyTagFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type CaseStudyLocalizationsArgs = {
  filters?: InputMaybe<CaseStudyFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CaseStudyAll = {
  __typename?: 'CaseStudyAll';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  featured: ComponentCaseStudyAllSectionsFeatured;
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<CaseStudyAllRelationResponseCollection>;
  metadata: ComponentMetaMetadata;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CaseStudyAllEntity = {
  __typename?: 'CaseStudyAllEntity';
  attributes?: Maybe<CaseStudyAll>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type CaseStudyAllEntityResponse = {
  __typename?: 'CaseStudyAllEntityResponse';
  data?: Maybe<CaseStudyAllEntity>;
};

export type CaseStudyAllInput = {
  featured?: InputMaybe<ComponentCaseStudyAllSectionsFeaturedInput>;
  metadata?: InputMaybe<ComponentMetaMetadataInput>;
};

export type CaseStudyAllRelationResponseCollection = {
  __typename?: 'CaseStudyAllRelationResponseCollection';
  data: Array<CaseStudyAllEntity>;
};

export type CaseStudyCategory = {
  __typename?: 'CaseStudyCategory';
  caseStudies?: Maybe<CaseStudyRelationResponseCollection>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<CaseStudyCategoryRelationResponseCollection>;
  name: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type CaseStudyCategoryCaseStudiesArgs = {
  filters?: InputMaybe<CaseStudyFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type CaseStudyCategoryLocalizationsArgs = {
  filters?: InputMaybe<CaseStudyCategoryFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CaseStudyCategoryEntity = {
  __typename?: 'CaseStudyCategoryEntity';
  attributes?: Maybe<CaseStudyCategory>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type CaseStudyCategoryEntityResponse = {
  __typename?: 'CaseStudyCategoryEntityResponse';
  data?: Maybe<CaseStudyCategoryEntity>;
};

export type CaseStudyCategoryEntityResponseCollection = {
  __typename?: 'CaseStudyCategoryEntityResponseCollection';
  data: Array<CaseStudyCategoryEntity>;
  meta: ResponseCollectionMeta;
};

export type CaseStudyCategoryFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<CaseStudyCategoryFiltersInput>>>;
  caseStudies?: InputMaybe<CaseStudyFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  locale?: InputMaybe<StringFilterInput>;
  localizations?: InputMaybe<CaseStudyCategoryFiltersInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<CaseStudyCategoryFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<CaseStudyCategoryFiltersInput>>>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type CaseStudyCategoryInput = {
  caseStudies?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type CaseStudyCategoryRelationResponseCollection = {
  __typename?: 'CaseStudyCategoryRelationResponseCollection';
  data: Array<CaseStudyCategoryEntity>;
};

export type CaseStudyContentBlocksDynamicZone = ComponentCommonComponentsCkEditor | ComponentDynamicBlocksBannerSection | ComponentDynamicBlocksCaseStudiesShowcase | ComponentDynamicBlocksDynamicCaseStudiesPreview | ComponentDynamicBlocksDynamicChartSection | ComponentDynamicBlocksDynamicClientOpinions | ComponentDynamicBlocksDynamicConstantBlock | ComponentDynamicBlocksDynamicDarkInfoDividerBlock | ComponentDynamicBlocksDynamicDividerWithPhotosBlock | ComponentDynamicBlocksDynamicFaces | ComponentDynamicBlocksDynamicFaqBlock | ComponentDynamicBlocksDynamicFeatureListBlock | ComponentDynamicBlocksDynamicGallerySection | ComponentDynamicBlocksDynamicHeroBlock | ComponentDynamicBlocksDynamicHeroWithContactBlock | ComponentDynamicBlocksDynamicHistorySection | ComponentDynamicBlocksDynamicInfoGridBlock | ComponentDynamicBlocksDynamicInfoWithPhotoBlock | ComponentDynamicBlocksDynamicLeadership | ComponentDynamicBlocksDynamicLogosBlock | ComponentDynamicBlocksDynamicMedia | ComponentDynamicBlocksDynamicPartners | ComponentDynamicBlocksDynamicPointsWithPhotosBlock | ComponentDynamicBlocksDynamicRichTextBlock | ComponentDynamicBlocksDynamicScrollSlider | ComponentDynamicBlocksDynamicSeeMoreBlock | ComponentDynamicBlocksDynamicSliderPointsBlock | ComponentDynamicBlocksDynamicStatistics | ComponentDynamicBlocksDynamicTeamInvolved | ComponentDynamicBlocksDynamicTeamInvolvedWithHover | ComponentDynamicBlocksDynamicTestimonialBlock | ComponentDynamicBlocksDynamicTextWithPhotos | ComponentDynamicBlocksDynamicVideoBanner | ComponentDynamicBlocksHowWeWork | ComponentDynamicBlocksLetsBuildBlock | ComponentDynamicBlocksNewsletterBlock | ComponentDynamicBlocksRecommendedArticles | ComponentDynamicBlocksStandaloneContactForm | Error;

export type CaseStudyEntity = {
  __typename?: 'CaseStudyEntity';
  attributes?: Maybe<CaseStudy>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type CaseStudyEntityResponse = {
  __typename?: 'CaseStudyEntityResponse';
  data?: Maybe<CaseStudyEntity>;
};

export type CaseStudyEntityResponseCollection = {
  __typename?: 'CaseStudyEntityResponseCollection';
  data: Array<CaseStudyEntity>;
  meta: ResponseCollectionMeta;
};

export type CaseStudyFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<CaseStudyFiltersInput>>>;
  caseStudyCategory?: InputMaybe<CaseStudyCategoryFiltersInput>;
  caseStudyTags?: InputMaybe<CaseStudyTagFiltersInput>;
  client?: InputMaybe<StringFilterInput>;
  clientTooltip?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  descriptionMarkdown?: InputMaybe<StringFilterInput>;
  doodleText?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  locale?: InputMaybe<StringFilterInput>;
  localizations?: InputMaybe<CaseStudyFiltersInput>;
  location?: InputMaybe<StringFilterInput>;
  metadata?: InputMaybe<ComponentMetaMetadataFiltersInput>;
  not?: InputMaybe<CaseStudyFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<CaseStudyFiltersInput>>>;
  position?: InputMaybe<IntFilterInput>;
  projectStartDate?: InputMaybe<StringFilterInput>;
  projectStatus?: InputMaybe<StringFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  shortTitle?: InputMaybe<StringFilterInput>;
  slug?: InputMaybe<StringFilterInput>;
  title?: InputMaybe<StringFilterInput>;
  titleMarkdown?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  website?: InputMaybe<StringFilterInput>;
};

export type CaseStudyInput = {
  caseStudyCategory?: InputMaybe<Scalars['ID']['input']>;
  caseStudyTags?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  client?: InputMaybe<Scalars['String']['input']>;
  clientTooltip?: InputMaybe<Scalars['String']['input']>;
  contentBlocks?: InputMaybe<Array<Scalars['CaseStudyContentBlocksDynamicZoneInput']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionMarkdown?: InputMaybe<Scalars['String']['input']>;
  doodleText?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['ID']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<ComponentMetaMetadataInput>;
  position?: InputMaybe<Scalars['Int']['input']>;
  projectStartDate?: InputMaybe<Scalars['String']['input']>;
  projectStatus?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  shortTitle?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  titleMarkdown?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type CaseStudyRelationResponseCollection = {
  __typename?: 'CaseStudyRelationResponseCollection';
  data: Array<CaseStudyEntity>;
};

export type CaseStudyTag = {
  __typename?: 'CaseStudyTag';
  caseStudies?: Maybe<CaseStudyRelationResponseCollection>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<CaseStudyTagRelationResponseCollection>;
  name: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type CaseStudyTagCaseStudiesArgs = {
  filters?: InputMaybe<CaseStudyFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type CaseStudyTagLocalizationsArgs = {
  filters?: InputMaybe<CaseStudyTagFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CaseStudyTagEntity = {
  __typename?: 'CaseStudyTagEntity';
  attributes?: Maybe<CaseStudyTag>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type CaseStudyTagEntityResponse = {
  __typename?: 'CaseStudyTagEntityResponse';
  data?: Maybe<CaseStudyTagEntity>;
};

export type CaseStudyTagEntityResponseCollection = {
  __typename?: 'CaseStudyTagEntityResponseCollection';
  data: Array<CaseStudyTagEntity>;
  meta: ResponseCollectionMeta;
};

export type CaseStudyTagFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<CaseStudyTagFiltersInput>>>;
  caseStudies?: InputMaybe<CaseStudyFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  locale?: InputMaybe<StringFilterInput>;
  localizations?: InputMaybe<CaseStudyTagFiltersInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<CaseStudyTagFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<CaseStudyTagFiltersInput>>>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type CaseStudyTagInput = {
  caseStudies?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type CaseStudyTagRelationResponseCollection = {
  __typename?: 'CaseStudyTagRelationResponseCollection';
  data: Array<CaseStudyTagEntity>;
};

export type ComponentAboutUsStatistics = {
  __typename?: 'ComponentAboutUsStatistics';
  description: Scalars['String']['output'];
  descriptionAdd?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  value: Scalars['String']['output'];
};

export type ComponentAboutUsStatisticsFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentAboutUsStatisticsFiltersInput>>>;
  description?: InputMaybe<StringFilterInput>;
  descriptionAdd?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentAboutUsStatisticsFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentAboutUsStatisticsFiltersInput>>>;
  value?: InputMaybe<StringFilterInput>;
};

export type ComponentAboutUsStatisticsInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionAdd?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentAboutUsValues = {
  __typename?: 'ComponentAboutUsValues';
  coverImageFallback: UploadFileEntityResponse;
  coverVideo?: Maybe<UploadFileEntityResponse>;
  description: Scalars['String']['output'];
  header: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type ComponentCaseStudyAllSectionsFeatured = {
  __typename?: 'ComponentCaseStudyAllSectionsFeatured';
  caseStudy?: Maybe<CaseStudyEntityResponse>;
  descriptionOne: Scalars['String']['output'];
  descriptionTwo?: Maybe<Scalars['String']['output']>;
  heading: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type ComponentCaseStudyAllSectionsFeaturedInput = {
  caseStudy?: InputMaybe<Scalars['ID']['input']>;
  descriptionOne?: InputMaybe<Scalars['String']['input']>;
  descriptionTwo?: InputMaybe<Scalars['String']['input']>;
  heading?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ComponentCommonComponentsBreadcrumbs = {
  __typename?: 'ComponentCommonComponentsBreadcrumbs';
  id: Scalars['ID']['output'];
  modeColor: Enum_Componentcommoncomponentsbreadcrumbs_Modecolor;
  position: Enum_Componentcommoncomponentsbreadcrumbs_Position;
};

export type ComponentCommonComponentsBreadcrumbsFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentCommonComponentsBreadcrumbsFiltersInput>>>;
  modeColor?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentCommonComponentsBreadcrumbsFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentCommonComponentsBreadcrumbsFiltersInput>>>;
  position?: InputMaybe<StringFilterInput>;
};

export type ComponentCommonComponentsBreadcrumbsInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  modeColor?: InputMaybe<Enum_Componentcommoncomponentsbreadcrumbs_Modecolor>;
  position?: InputMaybe<Enum_Componentcommoncomponentsbreadcrumbs_Position>;
};

export type ComponentCommonComponentsButton = {
  __typename?: 'ComponentCommonComponentsButton';
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  url: Scalars['String']['output'];
  variant: Enum_Componentcommoncomponentsbutton_Variant;
};

export type ComponentCommonComponentsChartPoint = {
  __typename?: 'ComponentCommonComponentsChartPoint';
  heading: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  list: Array<Maybe<ComponentCommonComponentsTextListItem>>;
};


export type ComponentCommonComponentsChartPointListArgs = {
  filters?: InputMaybe<ComponentCommonComponentsTextListItemFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentCommonComponentsChartPointFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentCommonComponentsChartPointFiltersInput>>>;
  heading?: InputMaybe<StringFilterInput>;
  list?: InputMaybe<ComponentCommonComponentsTextListItemFiltersInput>;
  not?: InputMaybe<ComponentCommonComponentsChartPointFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentCommonComponentsChartPointFiltersInput>>>;
};

export type ComponentCommonComponentsCkEditor = {
  __typename?: 'ComponentCommonComponentsCkEditor';
  id: Scalars['ID']['output'];
  richText: Scalars['String']['output'];
};

export type ComponentCommonComponentsClutchReviewCard = {
  __typename?: 'ComponentCommonComponentsClutchReviewCard';
  content: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  rating: Scalars['Float']['output'];
  reviewerAvatar: UploadFileEntityResponse;
  reviewerDescription: Scalars['String']['output'];
  reviewerName: Scalars['String']['output'];
};

export type ComponentCommonComponentsClutchReviewCardInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  rating?: InputMaybe<Scalars['Float']['input']>;
  reviewerAvatar?: InputMaybe<Scalars['ID']['input']>;
  reviewerDescription?: InputMaybe<Scalars['String']['input']>;
  reviewerName?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentCommonComponentsDateWithLabel = {
  __typename?: 'ComponentCommonComponentsDateWithLabel';
  date: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
};

export type ComponentCommonComponentsDateWithLabelInput = {
  date?: InputMaybe<Scalars['Date']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentCommonComponentsDecoratedTextImage = {
  __typename?: 'ComponentCommonComponentsDecoratedTextImage';
  circle?: Maybe<Enum_Componentcommoncomponentsdecoratedtextimage_Circle>;
  exclaim?: Maybe<Enum_Componentcommoncomponentsdecoratedtextimage_Exclaim>;
  highlight?: Maybe<Enum_Componentcommoncomponentsdecoratedtextimage_Highlight>;
  id: Scalars['ID']['output'];
  isCircleDarkMode?: Maybe<Scalars['Boolean']['output']>;
  underline?: Maybe<Enum_Componentcommoncomponentsdecoratedtextimage_Underline>;
};

export type ComponentCommonComponentsFaceItem = {
  __typename?: 'ComponentCommonComponentsFaceItem';
  comment: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  image1: UploadFileEntityResponse;
  image2: UploadFileEntityResponse;
  name: Scalars['String']['output'];
  position: Scalars['String']['output'];
};

export type ComponentCommonComponentsFaceItemFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentCommonComponentsFaceItemFiltersInput>>>;
  comment?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentCommonComponentsFaceItemFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentCommonComponentsFaceItemFiltersInput>>>;
  position?: InputMaybe<StringFilterInput>;
};

export type ComponentCommonComponentsFaqItem = {
  __typename?: 'ComponentCommonComponentsFaqItem';
  answer: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  question: Scalars['String']['output'];
};

export type ComponentCommonComponentsFaqItemFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentCommonComponentsFaqItemFiltersInput>>>;
  answer?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentCommonComponentsFaqItemFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentCommonComponentsFaqItemFiltersInput>>>;
  question?: InputMaybe<StringFilterInput>;
};

export type ComponentCommonComponentsFeatureWithDoodle = {
  __typename?: 'ComponentCommonComponentsFeatureWithDoodle';
  id: Scalars['ID']['output'];
  image?: Maybe<UploadFileEntityResponse>;
  paragraph?: Maybe<Scalars['String']['output']>;
  text: Scalars['String']['output'];
};

export type ComponentCommonComponentsFeatureWithDoodleFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentCommonComponentsFeatureWithDoodleFiltersInput>>>;
  not?: InputMaybe<ComponentCommonComponentsFeatureWithDoodleFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentCommonComponentsFeatureWithDoodleFiltersInput>>>;
  paragraph?: InputMaybe<StringFilterInput>;
  text?: InputMaybe<StringFilterInput>;
};

export type ComponentCommonComponentsGridListItem = {
  __typename?: 'ComponentCommonComponentsGridListItem';
  buttonLabel?: Maybe<Scalars['String']['output']>;
  buttonLink?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  heading: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  image?: Maybe<UploadFileEntityResponse>;
};

export type ComponentCommonComponentsGridListItemFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentCommonComponentsGridListItemFiltersInput>>>;
  buttonLabel?: InputMaybe<StringFilterInput>;
  buttonLink?: InputMaybe<StringFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  heading?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentCommonComponentsGridListItemFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentCommonComponentsGridListItemFiltersInput>>>;
};

export type ComponentCommonComponentsHeadingWithRichText = {
  __typename?: 'ComponentCommonComponentsHeadingWithRichText';
  content: Scalars['String']['output'];
  heading: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type ComponentCommonComponentsHeadingWithRichTextFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentCommonComponentsHeadingWithRichTextFiltersInput>>>;
  content?: InputMaybe<StringFilterInput>;
  heading?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentCommonComponentsHeadingWithRichTextFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentCommonComponentsHeadingWithRichTextFiltersInput>>>;
};

export type ComponentCommonComponentsHeadingWithRichTextInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  heading?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ComponentCommonComponentsHistory = {
  __typename?: 'ComponentCommonComponentsHistory';
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  year: Scalars['String']['output'];
};

export type ComponentCommonComponentsHistoryFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentCommonComponentsHistoryFiltersInput>>>;
  description?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentCommonComponentsHistoryFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentCommonComponentsHistoryFiltersInput>>>;
  year?: InputMaybe<StringFilterInput>;
};

export type ComponentCommonComponentsHoverAvatar = {
  __typename?: 'ComponentCommonComponentsHoverAvatar';
  hoverText: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  image: UploadFileEntityResponse;
  name?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
};

export type ComponentCommonComponentsHoverImageWithCaption = {
  __typename?: 'ComponentCommonComponentsHoverImageWithCaption';
  comment: Scalars['String']['output'];
  hoverImage: UploadFileEntityResponse;
  id: Scalars['ID']['output'];
  image: UploadFileEntityResponse;
  imageCaptionFirstLine: Scalars['String']['output'];
  imageCaptionSecondLine?: Maybe<Scalars['String']['output']>;
};

export type ComponentCommonComponentsHoverImageWithCaptionFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentCommonComponentsHoverImageWithCaptionFiltersInput>>>;
  comment?: InputMaybe<StringFilterInput>;
  imageCaptionFirstLine?: InputMaybe<StringFilterInput>;
  imageCaptionSecondLine?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentCommonComponentsHoverImageWithCaptionFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentCommonComponentsHoverImageWithCaptionFiltersInput>>>;
};

export type ComponentCommonComponentsImageWithCaption = {
  __typename?: 'ComponentCommonComponentsImageWithCaption';
  caption: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  image: UploadFileEntityResponse;
};

export type ComponentCommonComponentsImageWithCaptionFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentCommonComponentsImageWithCaptionFiltersInput>>>;
  caption?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentCommonComponentsImageWithCaptionFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentCommonComponentsImageWithCaptionFiltersInput>>>;
};

export type ComponentCommonComponentsImageWithCaptionInput = {
  caption?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<Scalars['ID']['input']>;
};

export type ComponentCommonComponentsItems = {
  __typename?: 'ComponentCommonComponentsItems';
  id: Scalars['ID']['output'];
  image: UploadFileEntityResponse;
  text: Scalars['String']['output'];
};

export type ComponentCommonComponentsItemsFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentCommonComponentsItemsFiltersInput>>>;
  not?: InputMaybe<ComponentCommonComponentsItemsFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentCommonComponentsItemsFiltersInput>>>;
  text?: InputMaybe<StringFilterInput>;
};

export type ComponentCommonComponentsLink = {
  __typename?: 'ComponentCommonComponentsLink';
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type ComponentCommonComponentsMediaItem = {
  __typename?: 'ComponentCommonComponentsMediaItem';
  coverImageFallback: UploadFileEntityResponse;
  coverVideo: UploadFileEntityResponse;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type ComponentCommonComponentsMediaItemFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentCommonComponentsMediaItemFiltersInput>>>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentCommonComponentsMediaItemFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentCommonComponentsMediaItemFiltersInput>>>;
};

export type ComponentCommonComponentsPointWithPhoto = {
  __typename?: 'ComponentCommonComponentsPointWithPhoto';
  id: Scalars['ID']['output'];
  photo: UploadFileEntityResponse;
  text: Scalars['String']['output'];
};

export type ComponentCommonComponentsPointWithPhotoFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentCommonComponentsPointWithPhotoFiltersInput>>>;
  not?: InputMaybe<ComponentCommonComponentsPointWithPhotoFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentCommonComponentsPointWithPhotoFiltersInput>>>;
  text?: InputMaybe<StringFilterInput>;
};

export type ComponentCommonComponentsRichListItem = {
  __typename?: 'ComponentCommonComponentsRichListItem';
  description: Scalars['String']['output'];
  emoji?: Maybe<Scalars['String']['output']>;
  heading?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type ComponentCommonComponentsRichListItemFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentCommonComponentsRichListItemFiltersInput>>>;
  description?: InputMaybe<StringFilterInput>;
  emoji?: InputMaybe<StringFilterInput>;
  heading?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentCommonComponentsRichListItemFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentCommonComponentsRichListItemFiltersInput>>>;
};

export type ComponentCommonComponentsShowcaseCaseStudySlugs = {
  __typename?: 'ComponentCommonComponentsShowcaseCaseStudySlugs';
  caseStudySlug: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type ComponentCommonComponentsShowcaseCaseStudySlugsFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentCommonComponentsShowcaseCaseStudySlugsFiltersInput>>>;
  caseStudySlug?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentCommonComponentsShowcaseCaseStudySlugsFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentCommonComponentsShowcaseCaseStudySlugsFiltersInput>>>;
};

export type ComponentCommonComponentsSliderItem = {
  __typename?: 'ComponentCommonComponentsSliderItem';
  id: Scalars['ID']['output'];
  imageAlt: Scalars['String']['output'];
  slideImage: UploadFileEntityResponse;
  url: Scalars['String']['output'];
};

export type ComponentCommonComponentsSliderItemFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentCommonComponentsSliderItemFiltersInput>>>;
  imageAlt?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentCommonComponentsSliderItemFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentCommonComponentsSliderItemFiltersInput>>>;
  url?: InputMaybe<StringFilterInput>;
};

export type ComponentCommonComponentsSliderPointsItem = {
  __typename?: 'ComponentCommonComponentsSliderPointsItem';
  buttonLabel?: Maybe<Scalars['String']['output']>;
  buttonLink?: Maybe<Scalars['String']['output']>;
  header: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  image?: Maybe<UploadFileEntityResponse>;
  paragraphOneDescription: Scalars['String']['output'];
  paragraphOneTitle: Scalars['String']['output'];
  paragraphThreeDescription?: Maybe<Scalars['String']['output']>;
  paragraphThreeTitle?: Maybe<Scalars['String']['output']>;
  paragraphTwoDescription?: Maybe<Scalars['String']['output']>;
  paragraphTwoTitle?: Maybe<Scalars['String']['output']>;
};

export type ComponentCommonComponentsSliderPointsItemFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentCommonComponentsSliderPointsItemFiltersInput>>>;
  buttonLabel?: InputMaybe<StringFilterInput>;
  buttonLink?: InputMaybe<StringFilterInput>;
  header?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentCommonComponentsSliderPointsItemFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentCommonComponentsSliderPointsItemFiltersInput>>>;
  paragraphOneDescription?: InputMaybe<StringFilterInput>;
  paragraphOneTitle?: InputMaybe<StringFilterInput>;
  paragraphThreeDescription?: InputMaybe<StringFilterInput>;
  paragraphThreeTitle?: InputMaybe<StringFilterInput>;
  paragraphTwoDescription?: InputMaybe<StringFilterInput>;
  paragraphTwoTitle?: InputMaybe<StringFilterInput>;
};

export type ComponentCommonComponentsSocialItem = {
  __typename?: 'ComponentCommonComponentsSocialItem';
  icon: UploadFileEntityResponse;
  id: Scalars['ID']['output'];
  url: Scalars['String']['output'];
};

export type ComponentCommonComponentsStickyCta = {
  __typename?: 'ComponentCommonComponentsStickyCta';
  buttonCaption?: Maybe<Scalars['String']['output']>;
  buttonLink?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  subttitle: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type ComponentCommonComponentsStickyCtaFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentCommonComponentsStickyCtaFiltersInput>>>;
  buttonCaption?: InputMaybe<StringFilterInput>;
  buttonLink?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentCommonComponentsStickyCtaFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentCommonComponentsStickyCtaFiltersInput>>>;
  subttitle?: InputMaybe<StringFilterInput>;
  title?: InputMaybe<StringFilterInput>;
};

export type ComponentCommonComponentsStickyCtaInput = {
  buttonCaption?: InputMaybe<Scalars['String']['input']>;
  buttonLink?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  subttitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentCommonComponentsTag = {
  __typename?: 'ComponentCommonComponentsTag';
  content: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type ComponentCommonComponentsTextList = {
  __typename?: 'ComponentCommonComponentsTextList';
  id: Scalars['ID']['output'];
  textListItems: Array<Maybe<ComponentCommonComponentsTextListItem>>;
};


export type ComponentCommonComponentsTextListTextListItemsArgs = {
  filters?: InputMaybe<ComponentCommonComponentsTextListItemFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentCommonComponentsTextListItem = {
  __typename?: 'ComponentCommonComponentsTextListItem';
  id: Scalars['ID']['output'];
  textListItem: Scalars['String']['output'];
};

export type ComponentCommonComponentsTextListItemFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentCommonComponentsTextListItemFiltersInput>>>;
  not?: InputMaybe<ComponentCommonComponentsTextListItemFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentCommonComponentsTextListItemFiltersInput>>>;
  textListItem?: InputMaybe<StringFilterInput>;
};

export type ComponentDynamicBlocksBannerSection = {
  __typename?: 'ComponentDynamicBlocksBannerSection';
  bannerDesc: Scalars['String']['output'];
  bannerTitle: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type ComponentDynamicBlocksCaseStudiesShowcase = {
  __typename?: 'ComponentDynamicBlocksCaseStudiesShowcase';
  buttonText: Scalars['String']['output'];
  caseStudySlugs: Array<Maybe<ComponentCommonComponentsShowcaseCaseStudySlugs>>;
  id: Scalars['ID']['output'];
  subtitle: Scalars['String']['output'];
  title: Scalars['String']['output'];
};


export type ComponentDynamicBlocksCaseStudiesShowcaseCaseStudySlugsArgs = {
  filters?: InputMaybe<ComponentCommonComponentsShowcaseCaseStudySlugsFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentDynamicBlocksDynamicCaseStudiesPreview = {
  __typename?: 'ComponentDynamicBlocksDynamicCaseStudiesPreview';
  bigBoxBackgroundImage?: Maybe<UploadFileEntityResponse>;
  bigBoxButtonLabel: Scalars['String']['output'];
  bigBoxButtonLink: Scalars['String']['output'];
  bigBoxHeader: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  middleBoxBackgroundImage?: Maybe<UploadFileEntityResponse>;
  middleBoxCaption: Scalars['String']['output'];
  rightBoxBackgroundImage?: Maybe<UploadFileEntityResponse>;
  rightBoxCaption: Scalars['String']['output'];
};

export type ComponentDynamicBlocksDynamicChartSection = {
  __typename?: 'ComponentDynamicBlocksDynamicChartSection';
  header: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  items: Array<Maybe<ComponentCommonComponentsChartPoint>>;
};


export type ComponentDynamicBlocksDynamicChartSectionItemsArgs = {
  filters?: InputMaybe<ComponentCommonComponentsChartPointFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentDynamicBlocksDynamicClientOpinions = {
  __typename?: 'ComponentDynamicBlocksDynamicClientOpinions';
  decoratedTextImages?: Maybe<ComponentCommonComponentsDecoratedTextImage>;
  id: Scalars['ID']['output'];
  opinions: ComponentHomeSectionsClientOpinions;
  subtitle: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type ComponentDynamicBlocksDynamicConstantBlock = {
  __typename?: 'ComponentDynamicBlocksDynamicConstantBlock';
  id: Scalars['ID']['output'];
  name: Enum_Componentdynamicblocksdynamicconstantblock_Name;
};

export type ComponentDynamicBlocksDynamicDarkInfoDividerBlock = {
  __typename?: 'ComponentDynamicBlocksDynamicDarkInfoDividerBlock';
  buttonCaption?: Maybe<Scalars['String']['output']>;
  buttonLink?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  header: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type ComponentDynamicBlocksDynamicDividerWithPhotosBlock = {
  __typename?: 'ComponentDynamicBlocksDynamicDividerWithPhotosBlock';
  id: Scalars['ID']['output'];
  multipleImages: UploadFileRelationResponseCollection;
};


export type ComponentDynamicBlocksDynamicDividerWithPhotosBlockMultipleImagesArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentDynamicBlocksDynamicFaces = {
  __typename?: 'ComponentDynamicBlocksDynamicFaces';
  decoratedTextImages?: Maybe<ComponentCommonComponentsDecoratedTextImage>;
  header: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  items: Array<Maybe<ComponentCommonComponentsFaceItem>>;
};


export type ComponentDynamicBlocksDynamicFacesItemsArgs = {
  filters?: InputMaybe<ComponentCommonComponentsFaceItemFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentDynamicBlocksDynamicFaqBlock = {
  __typename?: 'ComponentDynamicBlocksDynamicFaqBlock';
  decoratedTextImages?: Maybe<ComponentCommonComponentsDecoratedTextImage>;
  header: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  items: Array<Maybe<ComponentCommonComponentsFaqItem>>;
};


export type ComponentDynamicBlocksDynamicFaqBlockItemsArgs = {
  filters?: InputMaybe<ComponentCommonComponentsFaqItemFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentDynamicBlocksDynamicFeatureListBlock = {
  __typename?: 'ComponentDynamicBlocksDynamicFeatureListBlock';
  buttonLabel?: Maybe<Scalars['String']['output']>;
  buttonLink?: Maybe<Scalars['String']['output']>;
  cta: Scalars['String']['output'];
  ctaImage: UploadFileEntityResponse;
  ctaImageMobile?: Maybe<UploadFileEntityResponse>;
  displayDigits: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  imagePosition: Enum_Componentdynamicblocksdynamicfeaturelistblock_Imageposition;
  items: Array<Maybe<ComponentCommonComponentsFeatureWithDoodle>>;
  largeImage: Scalars['Boolean']['output'];
};


export type ComponentDynamicBlocksDynamicFeatureListBlockItemsArgs = {
  filters?: InputMaybe<ComponentCommonComponentsFeatureWithDoodleFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentDynamicBlocksDynamicGallerySection = {
  __typename?: 'ComponentDynamicBlocksDynamicGallerySection';
  bottomText?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  middleText?: Maybe<Scalars['String']['output']>;
  topText?: Maybe<Scalars['String']['output']>;
};

export type ComponentDynamicBlocksDynamicHeroBlock = {
  __typename?: 'ComponentDynamicBlocksDynamicHeroBlock';
  buttonCaption?: Maybe<Scalars['String']['output']>;
  buttonLink?: Maybe<Scalars['String']['output']>;
  decoratedTextImages?: Maybe<ComponentCommonComponentsDecoratedTextImage>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export type ComponentDynamicBlocksDynamicHeroDescription = {
  __typename?: 'ComponentDynamicBlocksDynamicHeroDescription';
  buttonCaption?: Maybe<Scalars['String']['output']>;
  buttonLink?: Maybe<Scalars['String']['output']>;
  decoratedTextImages?: Maybe<ComponentCommonComponentsDecoratedTextImage>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export type ComponentDynamicBlocksDynamicHeroWithContactBlock = {
  __typename?: 'ComponentDynamicBlocksDynamicHeroWithContactBlock';
  backgroundImage?: Maybe<UploadFileEntityResponse>;
  contactCardAdditionalLabelText?: Maybe<Scalars['String']['output']>;
  contactCardImage?: Maybe<UploadFileEntityResponse>;
  contactCardLabel: Scalars['String']['output'];
  contactCardTitle: Scalars['String']['output'];
  ctaBottom?: Maybe<Scalars['String']['output']>;
  ctaTop: Scalars['String']['output'];
  formCompanyLabel: Scalars['String']['output'];
  formEmailLabel: Scalars['String']['output'];
  formNameLabel: Scalars['String']['output'];
  formPhoneLabel: Scalars['String']['output'];
  formPrivacyPolicyLabel: Scalars['String']['output'];
  formPrivacyPolicyLink?: Maybe<Scalars['String']['output']>;
  formSubmitLabel: Scalars['String']['output'];
  hideMobileButton?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  thanksInPolish?: Maybe<Scalars['Boolean']['output']>;
  withDoodleInBackground?: Maybe<Scalars['Boolean']['output']>;
};

export type ComponentDynamicBlocksDynamicHistorySection = {
  __typename?: 'ComponentDynamicBlocksDynamicHistorySection';
  header: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  items: Array<Maybe<ComponentCommonComponentsHistory>>;
};


export type ComponentDynamicBlocksDynamicHistorySectionItemsArgs = {
  filters?: InputMaybe<ComponentCommonComponentsHistoryFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentDynamicBlocksDynamicInfoGridBlock = {
  __typename?: 'ComponentDynamicBlocksDynamicInfoGridBlock';
  decoratedTextImages?: Maybe<ComponentCommonComponentsDecoratedTextImage>;
  header: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  items: Array<Maybe<ComponentCommonComponentsGridListItem>>;
  mode: Enum_Componentdynamicblocksdynamicinfogridblock_Mode;
};


export type ComponentDynamicBlocksDynamicInfoGridBlockItemsArgs = {
  filters?: InputMaybe<ComponentCommonComponentsGridListItemFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentDynamicBlocksDynamicInfoWithPhotoBlock = {
  __typename?: 'ComponentDynamicBlocksDynamicInfoWithPhotoBlock';
  buttonCaption?: Maybe<Scalars['String']['output']>;
  buttonLink?: Maybe<Scalars['String']['output']>;
  header: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  photo: UploadFileEntityResponse;
};

export type ComponentDynamicBlocksDynamicLeadership = {
  __typename?: 'ComponentDynamicBlocksDynamicLeadership';
  header: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  leaders: LeadershipRelationResponseCollection;
};


export type ComponentDynamicBlocksDynamicLeadershipLeadersArgs = {
  filters?: InputMaybe<LeadershipFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentDynamicBlocksDynamicLogosBlock = {
  __typename?: 'ComponentDynamicBlocksDynamicLogosBlock';
  header: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  logos: UploadFileRelationResponseCollection;
};


export type ComponentDynamicBlocksDynamicLogosBlockLogosArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentDynamicBlocksDynamicMedia = {
  __typename?: 'ComponentDynamicBlocksDynamicMedia';
  id: Scalars['ID']['output'];
  items: Array<Maybe<ComponentCommonComponentsMediaItem>>;
};


export type ComponentDynamicBlocksDynamicMediaItemsArgs = {
  filters?: InputMaybe<ComponentCommonComponentsMediaItemFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentDynamicBlocksDynamicPartners = {
  __typename?: 'ComponentDynamicBlocksDynamicPartners';
  header: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  partners: PartnerRelationResponseCollection;
};


export type ComponentDynamicBlocksDynamicPartnersPartnersArgs = {
  filters?: InputMaybe<PartnerFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentDynamicBlocksDynamicPointsWithPhotosBlock = {
  __typename?: 'ComponentDynamicBlocksDynamicPointsWithPhotosBlock';
  elements: Array<Maybe<ComponentCommonComponentsPointWithPhoto>>;
  header: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};


export type ComponentDynamicBlocksDynamicPointsWithPhotosBlockElementsArgs = {
  filters?: InputMaybe<ComponentCommonComponentsPointWithPhotoFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentDynamicBlocksDynamicRichTextBlock = {
  __typename?: 'ComponentDynamicBlocksDynamicRichTextBlock';
  id: Scalars['ID']['output'];
  text: ComponentCommonComponentsCkEditor;
};

export type ComponentDynamicBlocksDynamicScrollSlider = {
  __typename?: 'ComponentDynamicBlocksDynamicScrollSlider';
  badgeImage: UploadFileEntityResponse;
  badgeText: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  items: Array<Maybe<ComponentCommonComponentsSliderItem>>;
};


export type ComponentDynamicBlocksDynamicScrollSliderItemsArgs = {
  filters?: InputMaybe<ComponentCommonComponentsSliderItemFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentDynamicBlocksDynamicSeeMoreBlock = {
  __typename?: 'ComponentDynamicBlocksDynamicSeeMoreBlock';
  buttonLabel?: Maybe<Scalars['String']['output']>;
  buttonLink?: Maybe<Scalars['String']['output']>;
  header: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  image?: Maybe<UploadFileEntityResponse>;
};

export type ComponentDynamicBlocksDynamicSliderPointsBlock = {
  __typename?: 'ComponentDynamicBlocksDynamicSliderPointsBlock';
  header: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  items: Array<Maybe<ComponentCommonComponentsSliderPointsItem>>;
  subheader: Scalars['String']['output'];
};


export type ComponentDynamicBlocksDynamicSliderPointsBlockItemsArgs = {
  filters?: InputMaybe<ComponentCommonComponentsSliderPointsItemFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentDynamicBlocksDynamicStatistics = {
  __typename?: 'ComponentDynamicBlocksDynamicStatistics';
  darkBackground?: Maybe<Scalars['Boolean']['output']>;
  header?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  statistics: Array<Maybe<ComponentAboutUsStatistics>>;
  underlinedValues?: Maybe<Scalars['Boolean']['output']>;
};


export type ComponentDynamicBlocksDynamicStatisticsStatisticsArgs = {
  filters?: InputMaybe<ComponentAboutUsStatisticsFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentDynamicBlocksDynamicTeamInvolved = {
  __typename?: 'ComponentDynamicBlocksDynamicTeamInvolved';
  header: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  items: Array<Maybe<ComponentCommonComponentsImageWithCaption>>;
  subheader: Scalars['String']['output'];
};


export type ComponentDynamicBlocksDynamicTeamInvolvedItemsArgs = {
  filters?: InputMaybe<ComponentCommonComponentsImageWithCaptionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentDynamicBlocksDynamicTeamInvolvedWithHover = {
  __typename?: 'ComponentDynamicBlocksDynamicTeamInvolvedWithHover';
  header: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  items: Array<Maybe<ComponentCommonComponentsHoverImageWithCaption>>;
};


export type ComponentDynamicBlocksDynamicTeamInvolvedWithHoverItemsArgs = {
  filters?: InputMaybe<ComponentCommonComponentsHoverImageWithCaptionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentDynamicBlocksDynamicTestimonialBlock = {
  __typename?: 'ComponentDynamicBlocksDynamicTestimonialBlock';
  decoratedTextImages?: Maybe<ComponentCommonComponentsDecoratedTextImage>;
  id: Scalars['ID']['output'];
  person: Scalars['String']['output'];
  photo: UploadFileEntityResponse;
  position: Scalars['String']['output'];
  quote: Scalars['String']['output'];
};

export type ComponentDynamicBlocksDynamicTextWithPhotos = {
  __typename?: 'ComponentDynamicBlocksDynamicTextWithPhotos';
  button?: Maybe<ComponentCommonComponentsButton>;
  desc?: Maybe<Scalars['String']['output']>;
  firstAvatar?: Maybe<ComponentCommonComponentsHoverAvatar>;
  headerEndText?: Maybe<Scalars['String']['output']>;
  headerMiddleText?: Maybe<Scalars['String']['output']>;
  headerStartText?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  secondAvatar?: Maybe<ComponentCommonComponentsHoverAvatar>;
};

export type ComponentDynamicBlocksDynamicVideoBanner = {
  __typename?: 'ComponentDynamicBlocksDynamicVideoBanner';
  buttonLabel?: Maybe<Scalars['String']['output']>;
  buttonLink?: Maybe<Scalars['String']['output']>;
  coverImageFallback: UploadFileEntityResponse;
  coverVideoUrl: UploadFileEntityResponse;
  decoratedTextImages?: Maybe<ComponentCommonComponentsDecoratedTextImage>;
  header: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type ComponentDynamicBlocksDynamicYourTurnSection = {
  __typename?: 'ComponentDynamicBlocksDynamicYourTurnSection';
  buttonCaption?: Maybe<Scalars['String']['output']>;
  buttonLink?: Maybe<Scalars['String']['output']>;
  header: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  leaders: LeadershipRelationResponseCollection;
  paragraph: Scalars['String']['output'];
  person: Scalars['String']['output'];
  photo: UploadFileEntityResponse;
  position: Scalars['String']['output'];
  quote: Scalars['String']['output'];
  subheader: Scalars['String']['output'];
};


export type ComponentDynamicBlocksDynamicYourTurnSectionLeadersArgs = {
  filters?: InputMaybe<LeadershipFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentDynamicBlocksHowWeWork = {
  __typename?: 'ComponentDynamicBlocksHowWeWork';
  heading: Scalars['String']['output'];
  howWeWorkItem: Array<Maybe<ComponentCommonComponentsItems>>;
  id: Scalars['ID']['output'];
};


export type ComponentDynamicBlocksHowWeWorkHowWeWorkItemArgs = {
  filters?: InputMaybe<ComponentCommonComponentsItemsFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentDynamicBlocksLetsBuildBlock = {
  __typename?: 'ComponentDynamicBlocksLetsBuildBlock';
  ctaText: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type ComponentDynamicBlocksNewsletterBlock = {
  __typename?: 'ComponentDynamicBlocksNewsletterBlock';
  emailPlaceholder: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  info: Scalars['String']['output'];
  marketingPrivacyLinkLabel: Scalars['String']['output'];
  marketingText: Scalars['String']['output'];
  subscribe: Scalars['String']['output'];
  successLabel: Scalars['String']['output'];
};

export type ComponentDynamicBlocksRecommendedArticles = {
  __typename?: 'ComponentDynamicBlocksRecommendedArticles';
  decoratedTextImages?: Maybe<ComponentCommonComponentsDecoratedTextImage>;
  header: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  tags: ArticleTagRelationResponseCollection;
};


export type ComponentDynamicBlocksRecommendedArticlesTagsArgs = {
  filters?: InputMaybe<ArticleTagFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentDynamicBlocksStandaloneContactForm = {
  __typename?: 'ComponentDynamicBlocksStandaloneContactForm';
  contactCardAdditionalLabelText?: Maybe<Scalars['String']['output']>;
  contactCardImage?: Maybe<UploadFileEntityResponse>;
  contactCardLabel: Scalars['String']['output'];
  contactCardTitle: Scalars['String']['output'];
  formCompanyLabel: Scalars['String']['output'];
  formEmailLabel: Scalars['String']['output'];
  formNameLabel: Scalars['String']['output'];
  formPhoneLabel: Scalars['String']['output'];
  formPrivacyPolicyLabel: Scalars['String']['output'];
  formPrivacyPolicyLink?: Maybe<Scalars['String']['output']>;
  formSubmitLabel: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  thanksInPolish?: Maybe<Scalars['Boolean']['output']>;
};

export type ComponentHomeComponentsClientOpinionsCard = {
  __typename?: 'ComponentHomeComponentsClientOpinionsCard';
  clientAvatar: UploadFileEntityResponse;
  clientDescription: Scalars['String']['output'];
  clientDescriptionSecondLine?: Maybe<Scalars['String']['output']>;
  clientLogo: UploadFileEntityResponse;
  clientName: Scalars['String']['output'];
  content: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type ComponentHomeComponentsClientOpinionsCardFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentHomeComponentsClientOpinionsCardFiltersInput>>>;
  clientDescription?: InputMaybe<StringFilterInput>;
  clientDescriptionSecondLine?: InputMaybe<StringFilterInput>;
  clientName?: InputMaybe<StringFilterInput>;
  content?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentHomeComponentsClientOpinionsCardFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentHomeComponentsClientOpinionsCardFiltersInput>>>;
};

export type ComponentHomeComponentsCompanyStatisticsCard = {
  __typename?: 'ComponentHomeComponentsCompanyStatisticsCard';
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  showBadge: Scalars['Boolean']['output'];
  value: Scalars['String']['output'];
};

export type ComponentHomeComponentsCompanyStatisticsCardFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentHomeComponentsCompanyStatisticsCardFiltersInput>>>;
  label?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentHomeComponentsCompanyStatisticsCardFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentHomeComponentsCompanyStatisticsCardFiltersInput>>>;
  showBadge?: InputMaybe<BooleanFilterInput>;
  value?: InputMaybe<StringFilterInput>;
};

export type ComponentHomeComponentsCompanyStatisticsCardInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  showBadge?: InputMaybe<Scalars['Boolean']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentHomeComponentsLetsMeetChatBubble = {
  __typename?: 'ComponentHomeComponentsLetsMeetChatBubble';
  id: Scalars['ID']['output'];
  memberMessage: Scalars['String']['output'];
  memberName: Scalars['String']['output'];
  memberRole: Scalars['String']['output'];
};

export type ComponentHomeComponentsLetsMeetChatBubbleInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  memberMessage?: InputMaybe<Scalars['String']['input']>;
  memberName?: InputMaybe<Scalars['String']['input']>;
  memberRole?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentHomeComponentsLetsMeetTeamMember = {
  __typename?: 'ComponentHomeComponentsLetsMeetTeamMember';
  avatar: UploadFileEntityResponse;
  chatBubble: ComponentHomeComponentsLetsMeetChatBubble;
  doodle: UploadFileEntityResponse;
  id: Scalars['ID']['output'];
};

export type ComponentHomeComponentsLetsMeetTeamMemberInput = {
  avatar?: InputMaybe<Scalars['ID']['input']>;
  chatBubble?: InputMaybe<ComponentHomeComponentsLetsMeetChatBubbleInput>;
  doodle?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ComponentHomeComponentsOurServiceCard = {
  __typename?: 'ComponentHomeComponentsOurServiceCard';
  buttonCaption?: Maybe<Scalars['String']['output']>;
  buttonHref?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  heading: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  list?: Maybe<Array<Maybe<ComponentCommonComponentsRichListItem>>>;
  priceFrom?: Maybe<Scalars['String']['output']>;
};


export type ComponentHomeComponentsOurServiceCardListArgs = {
  filters?: InputMaybe<ComponentCommonComponentsRichListItemFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentHomeComponentsPartnersCard = {
  __typename?: 'ComponentHomeComponentsPartnersCard';
  clientLogo: UploadFileEntityResponse;
  content: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type ComponentHomeComponentsPartnersCardFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentHomeComponentsPartnersCardFiltersInput>>>;
  content?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentHomeComponentsPartnersCardFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentHomeComponentsPartnersCardFiltersInput>>>;
};

export type ComponentHomeComponentsTechStackRow = {
  __typename?: 'ComponentHomeComponentsTechStackRow';
  id: Scalars['ID']['output'];
  pill: Array<Maybe<ComponentCommonComponentsImageWithCaption>>;
};


export type ComponentHomeComponentsTechStackRowPillArgs = {
  filters?: InputMaybe<ComponentCommonComponentsImageWithCaptionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentHomeComponentsTechStackRowFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentHomeComponentsTechStackRowFiltersInput>>>;
  not?: InputMaybe<ComponentHomeComponentsTechStackRowFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentHomeComponentsTechStackRowFiltersInput>>>;
  pill?: InputMaybe<ComponentCommonComponentsImageWithCaptionFiltersInput>;
};

export type ComponentHomeComponentsTechStackRowInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  pill?: InputMaybe<Array<InputMaybe<ComponentCommonComponentsImageWithCaptionInput>>>;
};

export type ComponentHomeSectionsCaseStudies = {
  __typename?: 'ComponentHomeSectionsCaseStudies';
  caseStudies?: Maybe<CaseStudyRelationResponseCollection>;
  id: Scalars['ID']['output'];
};


export type ComponentHomeSectionsCaseStudiesCaseStudiesArgs = {
  filters?: InputMaybe<CaseStudyFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentHomeSectionsCaseStudiesInput = {
  caseStudies?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ComponentHomeSectionsClientOpinions = {
  __typename?: 'ComponentHomeSectionsClientOpinions';
  awardLogo: UploadFileEntityResponse;
  id: Scalars['ID']['output'];
  opinions: Array<Maybe<ComponentHomeComponentsClientOpinionsCard>>;
};


export type ComponentHomeSectionsClientOpinionsOpinionsArgs = {
  filters?: InputMaybe<ComponentHomeComponentsClientOpinionsCardFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentHomeSectionsClutchScore = {
  __typename?: 'ComponentHomeSectionsClutchScore';
  firstReview: ComponentCommonComponentsClutchReviewCard;
  id: Scalars['ID']['output'];
  secondReview: ComponentCommonComponentsClutchReviewCard;
  thirdReview: ComponentCommonComponentsClutchReviewCard;
};

export type ComponentHomeSectionsClutchScoreInput = {
  firstReview?: InputMaybe<ComponentCommonComponentsClutchReviewCardInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  secondReview?: InputMaybe<ComponentCommonComponentsClutchReviewCardInput>;
  thirdReview?: InputMaybe<ComponentCommonComponentsClutchReviewCardInput>;
};

export type ComponentHomeSectionsCompanyStatistics = {
  __typename?: 'ComponentHomeSectionsCompanyStatistics';
  cakeDoodle: UploadFileEntityResponse;
  companyStatisticsCard: Array<Maybe<ComponentHomeComponentsCompanyStatisticsCard>>;
  id: Scalars['ID']['output'];
};


export type ComponentHomeSectionsCompanyStatisticsCompanyStatisticsCardArgs = {
  filters?: InputMaybe<ComponentHomeComponentsCompanyStatisticsCardFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentHomeSectionsCompanyStatisticsInput = {
  cakeDoodle?: InputMaybe<Scalars['ID']['input']>;
  companyStatisticsCard?: InputMaybe<Array<InputMaybe<ComponentHomeComponentsCompanyStatisticsCardInput>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ComponentHomeSectionsLetsMeet = {
  __typename?: 'ComponentHomeSectionsLetsMeet';
  id: Scalars['ID']['output'];
  teamMemberFive: ComponentHomeComponentsLetsMeetTeamMember;
  teamMemberFour: ComponentHomeComponentsLetsMeetTeamMember;
  teamMemberOne: ComponentHomeComponentsLetsMeetTeamMember;
  teamMemberThree: ComponentHomeComponentsLetsMeetTeamMember;
  teamMemberTwo: ComponentHomeComponentsLetsMeetTeamMember;
};

export type ComponentHomeSectionsLetsMeetInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  teamMemberFive?: InputMaybe<ComponentHomeComponentsLetsMeetTeamMemberInput>;
  teamMemberFour?: InputMaybe<ComponentHomeComponentsLetsMeetTeamMemberInput>;
  teamMemberOne?: InputMaybe<ComponentHomeComponentsLetsMeetTeamMemberInput>;
  teamMemberThree?: InputMaybe<ComponentHomeComponentsLetsMeetTeamMemberInput>;
  teamMemberTwo?: InputMaybe<ComponentHomeComponentsLetsMeetTeamMemberInput>;
};

export type ComponentHomeSectionsPartners = {
  __typename?: 'ComponentHomeSectionsPartners';
  id: Scalars['ID']['output'];
  partnersCards: Array<Maybe<ComponentHomeComponentsPartnersCard>>;
};


export type ComponentHomeSectionsPartnersPartnersCardsArgs = {
  filters?: InputMaybe<ComponentHomeComponentsPartnersCardFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentHomeSectionsTechStack = {
  __typename?: 'ComponentHomeSectionsTechStack';
  id: Scalars['ID']['output'];
  row: Array<Maybe<ComponentHomeComponentsTechStackRow>>;
};


export type ComponentHomeSectionsTechStackRowArgs = {
  filters?: InputMaybe<ComponentHomeComponentsTechStackRowFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentHomeSectionsTechStackInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  row?: InputMaybe<Array<InputMaybe<ComponentHomeComponentsTechStackRowInput>>>;
};

export type ComponentMetaMetadata = {
  __typename?: 'ComponentMetaMetadata';
  id: Scalars['ID']['output'];
  metaDescription: Scalars['String']['output'];
  metaTitle: Scalars['String']['output'];
  ogImage: UploadFileEntityResponse;
};

export type ComponentMetaMetadataFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentMetaMetadataFiltersInput>>>;
  metaDescription?: InputMaybe<StringFilterInput>;
  metaTitle?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentMetaMetadataFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentMetaMetadataFiltersInput>>>;
};

export type ComponentMetaMetadataInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  metaDescription?: InputMaybe<Scalars['String']['input']>;
  metaTitle?: InputMaybe<Scalars['String']['input']>;
  ogImage?: InputMaybe<Scalars['ID']['input']>;
};

export type ComponentPrivacyPolicySectionsPrivacyPolicy = {
  __typename?: 'ComponentPrivacyPolicySectionsPrivacyPolicy';
  id: Scalars['ID']['output'];
  intro: Scalars['String']['output'];
  lastUpdated: ComponentCommonComponentsDateWithLabel;
  paragraph: Array<Maybe<ComponentCommonComponentsHeadingWithRichText>>;
};


export type ComponentPrivacyPolicySectionsPrivacyPolicyParagraphArgs = {
  filters?: InputMaybe<ComponentCommonComponentsHeadingWithRichTextFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentPrivacyPolicySectionsPrivacyPolicyInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  intro?: InputMaybe<Scalars['String']['input']>;
  lastUpdated?: InputMaybe<ComponentCommonComponentsDateWithLabelInput>;
  paragraph?: InputMaybe<Array<InputMaybe<ComponentCommonComponentsHeadingWithRichTextInput>>>;
};

export type ContactForm = {
  __typename?: 'ContactForm';
  attachments?: Maybe<UploadFileRelationResponseCollection>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type ContactFormAttachmentsArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ContactFormEntity = {
  __typename?: 'ContactFormEntity';
  attributes?: Maybe<ContactForm>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type ContactFormEntityResponse = {
  __typename?: 'ContactFormEntityResponse';
  data?: Maybe<ContactFormEntity>;
};

export type ContactFormEntityResponseCollection = {
  __typename?: 'ContactFormEntityResponseCollection';
  data: Array<ContactFormEntity>;
  meta: ResponseCollectionMeta;
};

export type ContactFormFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ContactFormFiltersInput>>>;
  captchaToken?: InputMaybe<StringFilterInput>;
  companyName?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  email?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  message?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ContactFormFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ContactFormFiltersInput>>>;
  phoneNumber?: InputMaybe<StringFilterInput>;
  privacyPolicy?: InputMaybe<BooleanFilterInput>;
  purpose?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type ContactFormInput = {
  attachments?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  captchaToken?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  privacyPolicy?: InputMaybe<Scalars['Boolean']['input']>;
  purpose?: InputMaybe<Scalars['String']['input']>;
};

export type DateFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  contains?: InputMaybe<Scalars['Date']['input']>;
  containsi?: InputMaybe<Scalars['Date']['input']>;
  endsWith?: InputMaybe<Scalars['Date']['input']>;
  eq?: InputMaybe<Scalars['Date']['input']>;
  eqi?: InputMaybe<Scalars['Date']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nei?: InputMaybe<Scalars['Date']['input']>;
  not?: InputMaybe<DateFilterInput>;
  notContains?: InputMaybe<Scalars['Date']['input']>;
  notContainsi?: InputMaybe<Scalars['Date']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  startsWith?: InputMaybe<Scalars['Date']['input']>;
};

export type DateTimeFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  contains?: InputMaybe<Scalars['DateTime']['input']>;
  containsi?: InputMaybe<Scalars['DateTime']['input']>;
  endsWith?: InputMaybe<Scalars['DateTime']['input']>;
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  eqi?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  ne?: InputMaybe<Scalars['DateTime']['input']>;
  nei?: InputMaybe<Scalars['DateTime']['input']>;
  not?: InputMaybe<DateTimeFilterInput>;
  notContains?: InputMaybe<Scalars['DateTime']['input']>;
  notContainsi?: InputMaybe<Scalars['DateTime']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  startsWith?: InputMaybe<Scalars['DateTime']['input']>;
};

export enum Enum_Componentcommoncomponentsbreadcrumbs_Modecolor {
  Dark = 'dark',
  Light = 'light'
}

export enum Enum_Componentcommoncomponentsbreadcrumbs_Position {
  Absolute = 'absolute',
  Relative = 'relative'
}

export enum Enum_Componentcommoncomponentsbutton_Variant {
  Dark = 'dark',
  Light = 'light'
}

export enum Enum_Componentcommoncomponentsdecoratedtextimage_Circle {
  Circle_1 = 'circle_1',
  Circle_2 = 'circle_2',
  Circle_3 = 'circle_3',
  Circle_4 = 'circle_4',
  Circle_5 = 'circle_5'
}

export enum Enum_Componentcommoncomponentsdecoratedtextimage_Exclaim {
  LeftCrown = 'left_crown',
  LeftSunlight = 'left_sunlight',
  RightSunlight = 'right_sunlight'
}

export enum Enum_Componentcommoncomponentsdecoratedtextimage_Highlight {
  BrushedLime = 'brushed_lime',
  SlightlyRaggedLime = 'slightly_ragged_lime',
  SlightlyRaggedViolet = 'slightly_ragged_violet'
}

export enum Enum_Componentcommoncomponentsdecoratedtextimage_Underline {
  OneLine = 'one_line',
  ThreeLinesCrossed = 'three_lines_crossed',
  ThreeLinesCrossedBent = 'three_lines_crossed_bent',
  TwoLines = 'two_lines'
}

export enum Enum_Componentdynamicblocksdynamicconstantblock_Name {
  BuildGreatProducts = 'build_great_products',
  CompanyDesignTeam = 'company_design_team',
  CompanyInNumbers = 'company_in_numbers',
  CompanyLeadershipTeam = 'company_leadership_team',
  CompanyPartnerships = 'company_partnerships',
  CompanyTechStack = 'company_tech_stack',
  CompanyYearsOfExperience = 'company_years_of_experience',
  CtaLetsBuild = 'cta_lets_build',
  FullPageDivider = 'full_page_divider',
  HowWeBuildProducts = 'how_we_build_products',
  LastDribbbleShots = 'last_dribbble_shots',
  ReadOurBlogs = 'read_our_blogs',
  SubscribeToNewsletter = 'subscribe_to_newsletter'
}

export enum Enum_Componentdynamicblocksdynamicfeaturelistblock_Imageposition {
  Left = 'left',
  Right = 'right'
}

export enum Enum_Componentdynamicblocksdynamicinfogridblock_Mode {
  DarkWithIcons = 'dark_with_icons',
  DarkWithSlider = 'dark_with_slider',
  DarkWithTimeline = 'dark_with_timeline',
  DarkWithUnderlines = 'dark_with_underlines',
  LightWithBigIcons = 'light_with_big_icons',
  LightWithLimeDots = 'light_with_lime_dots',
  LightWithVerticalTimeline = 'light_with_vertical_timeline'
}

export enum Enum_Inventorydefinition_Capitalletter {
  A = 'A',
  B = 'B',
  C = 'C',
  D = 'D',
  E = 'E',
  F = 'F',
  G = 'G',
  H = 'H',
  I = 'I',
  J = 'J',
  K = 'K',
  L = 'L',
  M = 'M',
  N = 'N',
  O = 'O',
  P = 'P',
  Q = 'Q',
  R = 'R',
  S = 'S',
  T = 'T',
  U = 'U',
  V = 'V',
  W = 'W',
  X = 'X',
  Y = 'Y',
  Z = 'Z'
}

export type Error = {
  __typename?: 'Error';
  code: Scalars['String']['output'];
  message?: Maybe<Scalars['String']['output']>;
};

export type FileInfoInput = {
  alternativeText?: InputMaybe<Scalars['String']['input']>;
  caption?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type FloatFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  contains?: InputMaybe<Scalars['Float']['input']>;
  containsi?: InputMaybe<Scalars['Float']['input']>;
  endsWith?: InputMaybe<Scalars['Float']['input']>;
  eq?: InputMaybe<Scalars['Float']['input']>;
  eqi?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  ne?: InputMaybe<Scalars['Float']['input']>;
  nei?: InputMaybe<Scalars['Float']['input']>;
  not?: InputMaybe<FloatFilterInput>;
  notContains?: InputMaybe<Scalars['Float']['input']>;
  notContainsi?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  startsWith?: InputMaybe<Scalars['Float']['input']>;
};

export type GenericMorph = AboutUs | Article | ArticleCategory | ArticleTag | CaseStudy | CaseStudyAll | CaseStudyCategory | CaseStudyTag | ComponentAboutUsStatistics | ComponentAboutUsValues | ComponentCaseStudyAllSectionsFeatured | ComponentCommonComponentsBreadcrumbs | ComponentCommonComponentsButton | ComponentCommonComponentsChartPoint | ComponentCommonComponentsCkEditor | ComponentCommonComponentsClutchReviewCard | ComponentCommonComponentsDateWithLabel | ComponentCommonComponentsDecoratedTextImage | ComponentCommonComponentsFaceItem | ComponentCommonComponentsFaqItem | ComponentCommonComponentsFeatureWithDoodle | ComponentCommonComponentsGridListItem | ComponentCommonComponentsHeadingWithRichText | ComponentCommonComponentsHistory | ComponentCommonComponentsHoverAvatar | ComponentCommonComponentsHoverImageWithCaption | ComponentCommonComponentsImageWithCaption | ComponentCommonComponentsItems | ComponentCommonComponentsLink | ComponentCommonComponentsMediaItem | ComponentCommonComponentsPointWithPhoto | ComponentCommonComponentsRichListItem | ComponentCommonComponentsShowcaseCaseStudySlugs | ComponentCommonComponentsSliderItem | ComponentCommonComponentsSliderPointsItem | ComponentCommonComponentsSocialItem | ComponentCommonComponentsStickyCta | ComponentCommonComponentsTag | ComponentCommonComponentsTextList | ComponentCommonComponentsTextListItem | ComponentDynamicBlocksBannerSection | ComponentDynamicBlocksCaseStudiesShowcase | ComponentDynamicBlocksDynamicCaseStudiesPreview | ComponentDynamicBlocksDynamicChartSection | ComponentDynamicBlocksDynamicClientOpinions | ComponentDynamicBlocksDynamicConstantBlock | ComponentDynamicBlocksDynamicDarkInfoDividerBlock | ComponentDynamicBlocksDynamicDividerWithPhotosBlock | ComponentDynamicBlocksDynamicFaces | ComponentDynamicBlocksDynamicFaqBlock | ComponentDynamicBlocksDynamicFeatureListBlock | ComponentDynamicBlocksDynamicGallerySection | ComponentDynamicBlocksDynamicHeroBlock | ComponentDynamicBlocksDynamicHeroDescription | ComponentDynamicBlocksDynamicHeroWithContactBlock | ComponentDynamicBlocksDynamicHistorySection | ComponentDynamicBlocksDynamicInfoGridBlock | ComponentDynamicBlocksDynamicInfoWithPhotoBlock | ComponentDynamicBlocksDynamicLeadership | ComponentDynamicBlocksDynamicLogosBlock | ComponentDynamicBlocksDynamicMedia | ComponentDynamicBlocksDynamicPartners | ComponentDynamicBlocksDynamicPointsWithPhotosBlock | ComponentDynamicBlocksDynamicRichTextBlock | ComponentDynamicBlocksDynamicScrollSlider | ComponentDynamicBlocksDynamicSeeMoreBlock | ComponentDynamicBlocksDynamicSliderPointsBlock | ComponentDynamicBlocksDynamicStatistics | ComponentDynamicBlocksDynamicTeamInvolved | ComponentDynamicBlocksDynamicTeamInvolvedWithHover | ComponentDynamicBlocksDynamicTestimonialBlock | ComponentDynamicBlocksDynamicTextWithPhotos | ComponentDynamicBlocksDynamicVideoBanner | ComponentDynamicBlocksDynamicYourTurnSection | ComponentDynamicBlocksHowWeWork | ComponentDynamicBlocksLetsBuildBlock | ComponentDynamicBlocksNewsletterBlock | ComponentDynamicBlocksRecommendedArticles | ComponentDynamicBlocksStandaloneContactForm | ComponentHomeComponentsClientOpinionsCard | ComponentHomeComponentsCompanyStatisticsCard | ComponentHomeComponentsLetsMeetChatBubble | ComponentHomeComponentsLetsMeetTeamMember | ComponentHomeComponentsOurServiceCard | ComponentHomeComponentsPartnersCard | ComponentHomeComponentsTechStackRow | ComponentHomeSectionsCaseStudies | ComponentHomeSectionsClientOpinions | ComponentHomeSectionsClutchScore | ComponentHomeSectionsCompanyStatistics | ComponentHomeSectionsLetsMeet | ComponentHomeSectionsPartners | ComponentHomeSectionsTechStack | ComponentMetaMetadata | ComponentPrivacyPolicySectionsPrivacyPolicy | ContactForm | Global | GuidesPage | Home | I18NLocale | InventoryAll | InventoryDefinition | Leadership | Library | LibraryRequest | Page | Partner | PartnerTag | PrivacyPolicy | ResourcesPage | UploadFile | UploadFolder | UsersPermissionsPermission | UsersPermissionsRole | UsersPermissionsUser;

export type Global = {
  __typename?: 'Global';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<GlobalRelationResponseCollection>;
  metadata: ComponentMetaMetadata;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type GlobalEntity = {
  __typename?: 'GlobalEntity';
  attributes?: Maybe<Global>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type GlobalEntityResponse = {
  __typename?: 'GlobalEntityResponse';
  data?: Maybe<GlobalEntity>;
};

export type GlobalInput = {
  metadata?: InputMaybe<ComponentMetaMetadataInput>;
};

export type GlobalRelationResponseCollection = {
  __typename?: 'GlobalRelationResponseCollection';
  data: Array<GlobalEntity>;
};

export type GuidesPage = {
  __typename?: 'GuidesPage';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<GuidesPageRelationResponseCollection>;
  metadata: ComponentMetaMetadata;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type GuidesPageEntity = {
  __typename?: 'GuidesPageEntity';
  attributes?: Maybe<GuidesPage>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type GuidesPageEntityResponse = {
  __typename?: 'GuidesPageEntityResponse';
  data?: Maybe<GuidesPageEntity>;
};

export type GuidesPageInput = {
  metadata?: InputMaybe<ComponentMetaMetadataInput>;
};

export type GuidesPageRelationResponseCollection = {
  __typename?: 'GuidesPageRelationResponseCollection';
  data: Array<GuidesPageEntity>;
};

export type Home = {
  __typename?: 'Home';
  blocks: Array<Maybe<HomeBlocksDynamicZone>>;
  caseStudies: ComponentHomeSectionsCaseStudies;
  clutchScore: ComponentHomeSectionsClutchScore;
  companyStatistics: ComponentHomeSectionsCompanyStatistics;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  letsMeet: ComponentHomeSectionsLetsMeet;
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<HomeRelationResponseCollection>;
  metadata: ComponentMetaMetadata;
  partners?: Maybe<PartnerRelationResponseCollection>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  techStack: ComponentHomeSectionsTechStack;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type HomeLocalizationsArgs = {
  publicationState?: InputMaybe<PublicationState>;
};


export type HomePartnersArgs = {
  filters?: InputMaybe<PartnerFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type HomeBlocksDynamicZone = ComponentDynamicBlocksBannerSection | ComponentDynamicBlocksCaseStudiesShowcase | ComponentDynamicBlocksDynamicCaseStudiesPreview | ComponentDynamicBlocksDynamicChartSection | ComponentDynamicBlocksDynamicClientOpinions | ComponentDynamicBlocksDynamicConstantBlock | ComponentDynamicBlocksDynamicDarkInfoDividerBlock | ComponentDynamicBlocksDynamicDividerWithPhotosBlock | ComponentDynamicBlocksDynamicFaces | ComponentDynamicBlocksDynamicFaqBlock | ComponentDynamicBlocksDynamicFeatureListBlock | ComponentDynamicBlocksDynamicGallerySection | ComponentDynamicBlocksDynamicHeroBlock | ComponentDynamicBlocksDynamicHeroDescription | ComponentDynamicBlocksDynamicHeroWithContactBlock | ComponentDynamicBlocksDynamicHistorySection | ComponentDynamicBlocksDynamicInfoGridBlock | ComponentDynamicBlocksDynamicInfoWithPhotoBlock | ComponentDynamicBlocksDynamicLeadership | ComponentDynamicBlocksDynamicLogosBlock | ComponentDynamicBlocksDynamicMedia | ComponentDynamicBlocksDynamicPartners | ComponentDynamicBlocksDynamicPointsWithPhotosBlock | ComponentDynamicBlocksDynamicRichTextBlock | ComponentDynamicBlocksDynamicScrollSlider | ComponentDynamicBlocksDynamicSeeMoreBlock | ComponentDynamicBlocksDynamicSliderPointsBlock | ComponentDynamicBlocksDynamicStatistics | ComponentDynamicBlocksDynamicTeamInvolved | ComponentDynamicBlocksDynamicTeamInvolvedWithHover | ComponentDynamicBlocksDynamicTestimonialBlock | ComponentDynamicBlocksDynamicTextWithPhotos | ComponentDynamicBlocksDynamicVideoBanner | ComponentDynamicBlocksDynamicYourTurnSection | ComponentDynamicBlocksHowWeWork | ComponentDynamicBlocksLetsBuildBlock | ComponentDynamicBlocksNewsletterBlock | ComponentDynamicBlocksRecommendedArticles | ComponentDynamicBlocksStandaloneContactForm | Error;

export type HomeEntity = {
  __typename?: 'HomeEntity';
  attributes?: Maybe<Home>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type HomeEntityResponse = {
  __typename?: 'HomeEntityResponse';
  data?: Maybe<HomeEntity>;
};

export type HomeInput = {
  blocks?: InputMaybe<Array<Scalars['HomeBlocksDynamicZoneInput']['input']>>;
  caseStudies?: InputMaybe<ComponentHomeSectionsCaseStudiesInput>;
  clutchScore?: InputMaybe<ComponentHomeSectionsClutchScoreInput>;
  companyStatistics?: InputMaybe<ComponentHomeSectionsCompanyStatisticsInput>;
  letsMeet?: InputMaybe<ComponentHomeSectionsLetsMeetInput>;
  metadata?: InputMaybe<ComponentMetaMetadataInput>;
  partners?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  techStack?: InputMaybe<ComponentHomeSectionsTechStackInput>;
};

export type HomeRelationResponseCollection = {
  __typename?: 'HomeRelationResponseCollection';
  data: Array<HomeEntity>;
};

export type I18NLocale = {
  __typename?: 'I18NLocale';
  code?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type I18NLocaleEntity = {
  __typename?: 'I18NLocaleEntity';
  attributes?: Maybe<I18NLocale>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type I18NLocaleEntityResponse = {
  __typename?: 'I18NLocaleEntityResponse';
  data?: Maybe<I18NLocaleEntity>;
};

export type I18NLocaleEntityResponseCollection = {
  __typename?: 'I18NLocaleEntityResponseCollection';
  data: Array<I18NLocaleEntity>;
  meta: ResponseCollectionMeta;
};

export type I18NLocaleFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<I18NLocaleFiltersInput>>>;
  code?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<I18NLocaleFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<I18NLocaleFiltersInput>>>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type IdFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  contains?: InputMaybe<Scalars['ID']['input']>;
  containsi?: InputMaybe<Scalars['ID']['input']>;
  endsWith?: InputMaybe<Scalars['ID']['input']>;
  eq?: InputMaybe<Scalars['ID']['input']>;
  eqi?: InputMaybe<Scalars['ID']['input']>;
  gt?: InputMaybe<Scalars['ID']['input']>;
  gte?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  lt?: InputMaybe<Scalars['ID']['input']>;
  lte?: InputMaybe<Scalars['ID']['input']>;
  ne?: InputMaybe<Scalars['ID']['input']>;
  nei?: InputMaybe<Scalars['ID']['input']>;
  not?: InputMaybe<IdFilterInput>;
  notContains?: InputMaybe<Scalars['ID']['input']>;
  notContainsi?: InputMaybe<Scalars['ID']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  startsWith?: InputMaybe<Scalars['ID']['input']>;
};

export type IntFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  contains?: InputMaybe<Scalars['Int']['input']>;
  containsi?: InputMaybe<Scalars['Int']['input']>;
  endsWith?: InputMaybe<Scalars['Int']['input']>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  eqi?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  nei?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<IntFilterInput>;
  notContains?: InputMaybe<Scalars['Int']['input']>;
  notContainsi?: InputMaybe<Scalars['Int']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  startsWith?: InputMaybe<Scalars['Int']['input']>;
};

export type InventoryAll = {
  __typename?: 'InventoryAll';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<InventoryAllRelationResponseCollection>;
  metadata: ComponentMetaMetadata;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type InventoryAllEntity = {
  __typename?: 'InventoryAllEntity';
  attributes?: Maybe<InventoryAll>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type InventoryAllEntityResponse = {
  __typename?: 'InventoryAllEntityResponse';
  data?: Maybe<InventoryAllEntity>;
};

export type InventoryAllInput = {
  metadata?: InputMaybe<ComponentMetaMetadataInput>;
};

export type InventoryAllRelationResponseCollection = {
  __typename?: 'InventoryAllRelationResponseCollection';
  data: Array<InventoryAllEntity>;
};

export type InventoryDefinition = {
  __typename?: 'InventoryDefinition';
  articles?: Maybe<ArticleRelationResponseCollection>;
  capitalLetter: Enum_Inventorydefinition_Capitalletter;
  content: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  doodle?: Maybe<UploadFileEntityResponse>;
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<InventoryDefinitionRelationResponseCollection>;
  metadata: ComponentMetaMetadata;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type InventoryDefinitionArticlesArgs = {
  filters?: InputMaybe<ArticleFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type InventoryDefinitionLocalizationsArgs = {
  filters?: InputMaybe<InventoryDefinitionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type InventoryDefinitionEntity = {
  __typename?: 'InventoryDefinitionEntity';
  attributes?: Maybe<InventoryDefinition>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type InventoryDefinitionEntityResponse = {
  __typename?: 'InventoryDefinitionEntityResponse';
  data?: Maybe<InventoryDefinitionEntity>;
};

export type InventoryDefinitionEntityResponseCollection = {
  __typename?: 'InventoryDefinitionEntityResponseCollection';
  data: Array<InventoryDefinitionEntity>;
  meta: ResponseCollectionMeta;
};

export type InventoryDefinitionFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<InventoryDefinitionFiltersInput>>>;
  articles?: InputMaybe<ArticleFiltersInput>;
  capitalLetter?: InputMaybe<StringFilterInput>;
  content?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  locale?: InputMaybe<StringFilterInput>;
  localizations?: InputMaybe<InventoryDefinitionFiltersInput>;
  metadata?: InputMaybe<ComponentMetaMetadataFiltersInput>;
  not?: InputMaybe<InventoryDefinitionFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<InventoryDefinitionFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  slug?: InputMaybe<StringFilterInput>;
  title?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type InventoryDefinitionInput = {
  articles?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  capitalLetter?: InputMaybe<Enum_Inventorydefinition_Capitalletter>;
  content?: InputMaybe<Scalars['String']['input']>;
  doodle?: InputMaybe<Scalars['ID']['input']>;
  metadata?: InputMaybe<ComponentMetaMetadataInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type InventoryDefinitionRelationResponseCollection = {
  __typename?: 'InventoryDefinitionRelationResponseCollection';
  data: Array<InventoryDefinitionEntity>;
};

export type JsonFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  contains?: InputMaybe<Scalars['JSON']['input']>;
  containsi?: InputMaybe<Scalars['JSON']['input']>;
  endsWith?: InputMaybe<Scalars['JSON']['input']>;
  eq?: InputMaybe<Scalars['JSON']['input']>;
  eqi?: InputMaybe<Scalars['JSON']['input']>;
  gt?: InputMaybe<Scalars['JSON']['input']>;
  gte?: InputMaybe<Scalars['JSON']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  lt?: InputMaybe<Scalars['JSON']['input']>;
  lte?: InputMaybe<Scalars['JSON']['input']>;
  ne?: InputMaybe<Scalars['JSON']['input']>;
  nei?: InputMaybe<Scalars['JSON']['input']>;
  not?: InputMaybe<JsonFilterInput>;
  notContains?: InputMaybe<Scalars['JSON']['input']>;
  notContainsi?: InputMaybe<Scalars['JSON']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  startsWith?: InputMaybe<Scalars['JSON']['input']>;
};

export type Leadership = {
  __typename?: 'Leadership';
  avatar: UploadFileEntityResponse;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<LeadershipRelationResponseCollection>;
  name: Scalars['String']['output'];
  position: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  url: Scalars['String']['output'];
};


export type LeadershipLocalizationsArgs = {
  filters?: InputMaybe<LeadershipFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type LeadershipEntity = {
  __typename?: 'LeadershipEntity';
  attributes?: Maybe<Leadership>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type LeadershipEntityResponse = {
  __typename?: 'LeadershipEntityResponse';
  data?: Maybe<LeadershipEntity>;
};

export type LeadershipEntityResponseCollection = {
  __typename?: 'LeadershipEntityResponseCollection';
  data: Array<LeadershipEntity>;
  meta: ResponseCollectionMeta;
};

export type LeadershipFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<LeadershipFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  locale?: InputMaybe<StringFilterInput>;
  localizations?: InputMaybe<LeadershipFiltersInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<LeadershipFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<LeadershipFiltersInput>>>;
  position?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  url?: InputMaybe<StringFilterInput>;
};

export type LeadershipInput = {
  avatar?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type LeadershipRelationResponseCollection = {
  __typename?: 'LeadershipRelationResponseCollection';
  data: Array<LeadershipEntity>;
};

export type Library = {
  __typename?: 'Library';
  asset: UploadFileEntityResponse;
  content: Scalars['String']['output'];
  cover: UploadFileEntityResponse;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  doodle?: Maybe<UploadFileEntityResponse>;
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<LibraryRelationResponseCollection>;
  metadata: ComponentMetaMetadata;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  requests?: Maybe<LibraryRequestRelationResponseCollection>;
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type LibraryLocalizationsArgs = {
  filters?: InputMaybe<LibraryFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type LibraryRequestsArgs = {
  filters?: InputMaybe<LibraryRequestFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type LibraryEntity = {
  __typename?: 'LibraryEntity';
  attributes?: Maybe<Library>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type LibraryEntityResponse = {
  __typename?: 'LibraryEntityResponse';
  data?: Maybe<LibraryEntity>;
};

export type LibraryEntityResponseCollection = {
  __typename?: 'LibraryEntityResponseCollection';
  data: Array<LibraryEntity>;
  meta: ResponseCollectionMeta;
};

export type LibraryFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<LibraryFiltersInput>>>;
  content?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  locale?: InputMaybe<StringFilterInput>;
  localizations?: InputMaybe<LibraryFiltersInput>;
  metadata?: InputMaybe<ComponentMetaMetadataFiltersInput>;
  not?: InputMaybe<LibraryFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<LibraryFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  requests?: InputMaybe<LibraryRequestFiltersInput>;
  slug?: InputMaybe<StringFilterInput>;
  title?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type LibraryInput = {
  asset?: InputMaybe<Scalars['ID']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  cover?: InputMaybe<Scalars['ID']['input']>;
  doodle?: InputMaybe<Scalars['ID']['input']>;
  metadata?: InputMaybe<ComponentMetaMetadataInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  requests?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type LibraryRelationResponseCollection = {
  __typename?: 'LibraryRelationResponseCollection';
  data: Array<LibraryEntity>;
};

export type LibraryRequest = {
  __typename?: 'LibraryRequest';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  email: Scalars['String']['output'];
  library?: Maybe<LibraryEntityResponse>;
  marketingAgree: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type LibraryRequestEntity = {
  __typename?: 'LibraryRequestEntity';
  attributes?: Maybe<LibraryRequest>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type LibraryRequestEntityResponse = {
  __typename?: 'LibraryRequestEntityResponse';
  data?: Maybe<LibraryRequestEntity>;
};

export type LibraryRequestEntityResponseCollection = {
  __typename?: 'LibraryRequestEntityResponseCollection';
  data: Array<LibraryRequestEntity>;
  meta: ResponseCollectionMeta;
};

export type LibraryRequestFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<LibraryRequestFiltersInput>>>;
  captchaToken?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  email?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  library?: InputMaybe<LibraryFiltersInput>;
  marketingAgree?: InputMaybe<BooleanFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<LibraryRequestFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<LibraryRequestFiltersInput>>>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type LibraryRequestInput = {
  captchaToken?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  library?: InputMaybe<Scalars['ID']['input']>;
  marketingAgree?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type LibraryRequestRelationResponseCollection = {
  __typename?: 'LibraryRequestRelationResponseCollection';
  data: Array<LibraryRequestEntity>;
};

export type LongFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  contains?: InputMaybe<Scalars['Long']['input']>;
  containsi?: InputMaybe<Scalars['Long']['input']>;
  endsWith?: InputMaybe<Scalars['Long']['input']>;
  eq?: InputMaybe<Scalars['Long']['input']>;
  eqi?: InputMaybe<Scalars['Long']['input']>;
  gt?: InputMaybe<Scalars['Long']['input']>;
  gte?: InputMaybe<Scalars['Long']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  lt?: InputMaybe<Scalars['Long']['input']>;
  lte?: InputMaybe<Scalars['Long']['input']>;
  ne?: InputMaybe<Scalars['Long']['input']>;
  nei?: InputMaybe<Scalars['Long']['input']>;
  not?: InputMaybe<LongFilterInput>;
  notContains?: InputMaybe<Scalars['Long']['input']>;
  notContainsi?: InputMaybe<Scalars['Long']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  startsWith?: InputMaybe<Scalars['Long']['input']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  addContactToAudience: StatusResponse;
  /** Change user password. Confirm with the current password. */
  changePassword?: Maybe<UsersPermissionsLoginPayload>;
  createAboutUsLocalization?: Maybe<AboutUsEntityResponse>;
  createArticle?: Maybe<ArticleEntityResponse>;
  createArticleCategory?: Maybe<ArticleCategoryEntityResponse>;
  createArticleCategoryLocalization?: Maybe<ArticleCategoryEntityResponse>;
  createArticleLocalization?: Maybe<ArticleEntityResponse>;
  createArticleTag?: Maybe<ArticleTagEntityResponse>;
  createArticleTagLocalization?: Maybe<ArticleTagEntityResponse>;
  createCaseStudy?: Maybe<CaseStudyEntityResponse>;
  createCaseStudyAllLocalization?: Maybe<CaseStudyAllEntityResponse>;
  createCaseStudyCategory?: Maybe<CaseStudyCategoryEntityResponse>;
  createCaseStudyCategoryLocalization?: Maybe<CaseStudyCategoryEntityResponse>;
  createCaseStudyLocalization?: Maybe<CaseStudyEntityResponse>;
  createCaseStudyTag?: Maybe<CaseStudyTagEntityResponse>;
  createCaseStudyTagLocalization?: Maybe<CaseStudyTagEntityResponse>;
  createContactForm?: Maybe<ContactFormEntityResponse>;
  createGlobalLocalization?: Maybe<GlobalEntityResponse>;
  createGuidesPageLocalization?: Maybe<GuidesPageEntityResponse>;
  createHomeLocalization?: Maybe<HomeEntityResponse>;
  createInventoryAllLocalization?: Maybe<InventoryAllEntityResponse>;
  createInventoryDefinition?: Maybe<InventoryDefinitionEntityResponse>;
  createInventoryDefinitionLocalization?: Maybe<InventoryDefinitionEntityResponse>;
  createLeadership?: Maybe<LeadershipEntityResponse>;
  createLeadershipLocalization?: Maybe<LeadershipEntityResponse>;
  createLibrary?: Maybe<LibraryEntityResponse>;
  createLibraryLocalization?: Maybe<LibraryEntityResponse>;
  createLibraryRequest?: Maybe<LibraryRequestEntityResponse>;
  createPage?: Maybe<PageEntityResponse>;
  createPageLocalization?: Maybe<PageEntityResponse>;
  createPartner?: Maybe<PartnerEntityResponse>;
  createPartnerLocalization?: Maybe<PartnerEntityResponse>;
  createPartnerTag?: Maybe<PartnerTagEntityResponse>;
  createPartnerTagLocalization?: Maybe<PartnerTagEntityResponse>;
  createPrivacyPolicyLocalization?: Maybe<PrivacyPolicyEntityResponse>;
  createResourcesPageLocalization?: Maybe<ResourcesPageEntityResponse>;
  createUploadFile?: Maybe<UploadFileEntityResponse>;
  createUploadFolder?: Maybe<UploadFolderEntityResponse>;
  /** Create a new role */
  createUsersPermissionsRole?: Maybe<UsersPermissionsCreateRolePayload>;
  /** Create a new user */
  createUsersPermissionsUser: UsersPermissionsUserEntityResponse;
  deleteAboutUs?: Maybe<AboutUsEntityResponse>;
  deleteArticle?: Maybe<ArticleEntityResponse>;
  deleteArticleCategory?: Maybe<ArticleCategoryEntityResponse>;
  deleteArticleTag?: Maybe<ArticleTagEntityResponse>;
  deleteCaseStudy?: Maybe<CaseStudyEntityResponse>;
  deleteCaseStudyAll?: Maybe<CaseStudyAllEntityResponse>;
  deleteCaseStudyCategory?: Maybe<CaseStudyCategoryEntityResponse>;
  deleteCaseStudyTag?: Maybe<CaseStudyTagEntityResponse>;
  deleteContactForm?: Maybe<ContactFormEntityResponse>;
  deleteGlobal?: Maybe<GlobalEntityResponse>;
  deleteGuidesPage?: Maybe<GuidesPageEntityResponse>;
  deleteHome?: Maybe<HomeEntityResponse>;
  deleteInventoryAll?: Maybe<InventoryAllEntityResponse>;
  deleteInventoryDefinition?: Maybe<InventoryDefinitionEntityResponse>;
  deleteLeadership?: Maybe<LeadershipEntityResponse>;
  deleteLibrary?: Maybe<LibraryEntityResponse>;
  deleteLibraryRequest?: Maybe<LibraryRequestEntityResponse>;
  deletePage?: Maybe<PageEntityResponse>;
  deletePartner?: Maybe<PartnerEntityResponse>;
  deletePartnerTag?: Maybe<PartnerTagEntityResponse>;
  deletePrivacyPolicy?: Maybe<PrivacyPolicyEntityResponse>;
  deleteResourcesPage?: Maybe<ResourcesPageEntityResponse>;
  deleteUploadFile?: Maybe<UploadFileEntityResponse>;
  deleteUploadFolder?: Maybe<UploadFolderEntityResponse>;
  /** Delete an existing role */
  deleteUsersPermissionsRole?: Maybe<UsersPermissionsDeleteRolePayload>;
  /** Delete an existing user */
  deleteUsersPermissionsUser: UsersPermissionsUserEntityResponse;
  /** Confirm an email users email address */
  emailConfirmation?: Maybe<UsersPermissionsLoginPayload>;
  /** Request a reset password token */
  forgotPassword?: Maybe<UsersPermissionsPasswordPayload>;
  login: UsersPermissionsLoginPayload;
  multipleUpload: Array<Maybe<UploadFileEntityResponse>>;
  /** Register a user */
  register: UsersPermissionsLoginPayload;
  removeFile?: Maybe<UploadFileEntityResponse>;
  /** Reset user password. Confirm with a code (resetToken from forgotPassword) */
  resetPassword?: Maybe<UsersPermissionsLoginPayload>;
  updateAboutUs?: Maybe<AboutUsEntityResponse>;
  updateArticle?: Maybe<ArticleEntityResponse>;
  updateArticleCategory?: Maybe<ArticleCategoryEntityResponse>;
  updateArticleTag?: Maybe<ArticleTagEntityResponse>;
  updateCaseStudy?: Maybe<CaseStudyEntityResponse>;
  updateCaseStudyAll?: Maybe<CaseStudyAllEntityResponse>;
  updateCaseStudyCategory?: Maybe<CaseStudyCategoryEntityResponse>;
  updateCaseStudyTag?: Maybe<CaseStudyTagEntityResponse>;
  updateContactForm?: Maybe<ContactFormEntityResponse>;
  updateFileInfo: UploadFileEntityResponse;
  updateGlobal?: Maybe<GlobalEntityResponse>;
  updateGuidesPage?: Maybe<GuidesPageEntityResponse>;
  updateHome?: Maybe<HomeEntityResponse>;
  updateInventoryAll?: Maybe<InventoryAllEntityResponse>;
  updateInventoryDefinition?: Maybe<InventoryDefinitionEntityResponse>;
  updateLeadership?: Maybe<LeadershipEntityResponse>;
  updateLibrary?: Maybe<LibraryEntityResponse>;
  updateLibraryRequest?: Maybe<LibraryRequestEntityResponse>;
  updatePage?: Maybe<PageEntityResponse>;
  updatePartner?: Maybe<PartnerEntityResponse>;
  updatePartnerTag?: Maybe<PartnerTagEntityResponse>;
  updatePrivacyPolicy?: Maybe<PrivacyPolicyEntityResponse>;
  updateResourcesPage?: Maybe<ResourcesPageEntityResponse>;
  updateUploadFile?: Maybe<UploadFileEntityResponse>;
  updateUploadFolder?: Maybe<UploadFolderEntityResponse>;
  /** Update an existing role */
  updateUsersPermissionsRole?: Maybe<UsersPermissionsUpdateRolePayload>;
  /** Update an existing user */
  updateUsersPermissionsUser: UsersPermissionsUserEntityResponse;
  upload: UploadFileEntityResponse;
};


export type MutationAddContactToAudienceArgs = {
  data: AddContactInput;
};


export type MutationChangePasswordArgs = {
  currentPassword: Scalars['String']['input'];
  password: Scalars['String']['input'];
  passwordConfirmation: Scalars['String']['input'];
};


export type MutationCreateAboutUsLocalizationArgs = {
  data?: InputMaybe<AboutUsInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateArticleArgs = {
  data: ArticleInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateArticleCategoryArgs = {
  data: ArticleCategoryInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateArticleCategoryLocalizationArgs = {
  data?: InputMaybe<ArticleCategoryInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateArticleLocalizationArgs = {
  data?: InputMaybe<ArticleInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateArticleTagArgs = {
  data: ArticleTagInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateArticleTagLocalizationArgs = {
  data?: InputMaybe<ArticleTagInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateCaseStudyArgs = {
  data: CaseStudyInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateCaseStudyAllLocalizationArgs = {
  data?: InputMaybe<CaseStudyAllInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateCaseStudyCategoryArgs = {
  data: CaseStudyCategoryInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateCaseStudyCategoryLocalizationArgs = {
  data?: InputMaybe<CaseStudyCategoryInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateCaseStudyLocalizationArgs = {
  data?: InputMaybe<CaseStudyInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateCaseStudyTagArgs = {
  data: CaseStudyTagInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateCaseStudyTagLocalizationArgs = {
  data?: InputMaybe<CaseStudyTagInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateContactFormArgs = {
  data: ContactFormInput;
};


export type MutationCreateGlobalLocalizationArgs = {
  data?: InputMaybe<GlobalInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateGuidesPageLocalizationArgs = {
  data?: InputMaybe<GuidesPageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateHomeLocalizationArgs = {
  data?: InputMaybe<HomeInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateInventoryAllLocalizationArgs = {
  data?: InputMaybe<InventoryAllInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateInventoryDefinitionArgs = {
  data: InventoryDefinitionInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateInventoryDefinitionLocalizationArgs = {
  data?: InputMaybe<InventoryDefinitionInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateLeadershipArgs = {
  data: LeadershipInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateLeadershipLocalizationArgs = {
  data?: InputMaybe<LeadershipInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateLibraryArgs = {
  data: LibraryInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateLibraryLocalizationArgs = {
  data?: InputMaybe<LibraryInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateLibraryRequestArgs = {
  data: LibraryRequestInput;
};


export type MutationCreatePageArgs = {
  data: PageInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreatePageLocalizationArgs = {
  data?: InputMaybe<PageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreatePartnerArgs = {
  data: PartnerInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreatePartnerLocalizationArgs = {
  data?: InputMaybe<PartnerInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreatePartnerTagArgs = {
  data: PartnerTagInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreatePartnerTagLocalizationArgs = {
  data?: InputMaybe<PartnerTagInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreatePrivacyPolicyLocalizationArgs = {
  data?: InputMaybe<PrivacyPolicyInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateResourcesPageLocalizationArgs = {
  data?: InputMaybe<ResourcesPageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateUploadFileArgs = {
  data: UploadFileInput;
};


export type MutationCreateUploadFolderArgs = {
  data: UploadFolderInput;
};


export type MutationCreateUsersPermissionsRoleArgs = {
  data: UsersPermissionsRoleInput;
};


export type MutationCreateUsersPermissionsUserArgs = {
  data: UsersPermissionsUserInput;
};


export type MutationDeleteAboutUsArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationDeleteArticleArgs = {
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationDeleteArticleCategoryArgs = {
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationDeleteArticleTagArgs = {
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationDeleteCaseStudyArgs = {
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationDeleteCaseStudyAllArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationDeleteCaseStudyCategoryArgs = {
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationDeleteCaseStudyTagArgs = {
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationDeleteContactFormArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteGlobalArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationDeleteGuidesPageArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationDeleteHomeArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationDeleteInventoryAllArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationDeleteInventoryDefinitionArgs = {
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationDeleteLeadershipArgs = {
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationDeleteLibraryArgs = {
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationDeleteLibraryRequestArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeletePageArgs = {
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationDeletePartnerArgs = {
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationDeletePartnerTagArgs = {
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationDeletePrivacyPolicyArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationDeleteResourcesPageArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationDeleteUploadFileArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteUploadFolderArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteUsersPermissionsRoleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteUsersPermissionsUserArgs = {
  id: Scalars['ID']['input'];
};


export type MutationEmailConfirmationArgs = {
  confirmation: Scalars['String']['input'];
};


export type MutationForgotPasswordArgs = {
  email: Scalars['String']['input'];
};


export type MutationLoginArgs = {
  input: UsersPermissionsLoginInput;
};


export type MutationMultipleUploadArgs = {
  field?: InputMaybe<Scalars['String']['input']>;
  files: Array<InputMaybe<Scalars['Upload']['input']>>;
  ref?: InputMaybe<Scalars['String']['input']>;
  refId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationRegisterArgs = {
  input: UsersPermissionsRegisterInput;
};


export type MutationRemoveFileArgs = {
  id: Scalars['ID']['input'];
};


export type MutationResetPasswordArgs = {
  code: Scalars['String']['input'];
  password: Scalars['String']['input'];
  passwordConfirmation: Scalars['String']['input'];
};


export type MutationUpdateAboutUsArgs = {
  data: AboutUsInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationUpdateArticleArgs = {
  data: ArticleInput;
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationUpdateArticleCategoryArgs = {
  data: ArticleCategoryInput;
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationUpdateArticleTagArgs = {
  data: ArticleTagInput;
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationUpdateCaseStudyArgs = {
  data: CaseStudyInput;
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationUpdateCaseStudyAllArgs = {
  data: CaseStudyAllInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationUpdateCaseStudyCategoryArgs = {
  data: CaseStudyCategoryInput;
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationUpdateCaseStudyTagArgs = {
  data: CaseStudyTagInput;
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationUpdateContactFormArgs = {
  data: ContactFormInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateFileInfoArgs = {
  id: Scalars['ID']['input'];
  info?: InputMaybe<FileInfoInput>;
};


export type MutationUpdateGlobalArgs = {
  data: GlobalInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationUpdateGuidesPageArgs = {
  data: GuidesPageInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationUpdateHomeArgs = {
  data: HomeInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationUpdateInventoryAllArgs = {
  data: InventoryAllInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationUpdateInventoryDefinitionArgs = {
  data: InventoryDefinitionInput;
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationUpdateLeadershipArgs = {
  data: LeadershipInput;
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationUpdateLibraryArgs = {
  data: LibraryInput;
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationUpdateLibraryRequestArgs = {
  data: LibraryRequestInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdatePageArgs = {
  data: PageInput;
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationUpdatePartnerArgs = {
  data: PartnerInput;
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationUpdatePartnerTagArgs = {
  data: PartnerTagInput;
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationUpdatePrivacyPolicyArgs = {
  data: PrivacyPolicyInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationUpdateResourcesPageArgs = {
  data: ResourcesPageInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationUpdateUploadFileArgs = {
  data: UploadFileInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateUploadFolderArgs = {
  data: UploadFolderInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateUsersPermissionsRoleArgs = {
  data: UsersPermissionsRoleInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateUsersPermissionsUserArgs = {
  data: UsersPermissionsUserInput;
  id: Scalars['ID']['input'];
};


export type MutationUploadArgs = {
  field?: InputMaybe<Scalars['String']['input']>;
  file: Scalars['Upload']['input'];
  info?: InputMaybe<FileInfoInput>;
  ref?: InputMaybe<Scalars['String']['input']>;
  refId?: InputMaybe<Scalars['ID']['input']>;
};

export type Page = {
  __typename?: 'Page';
  blocks: Array<Maybe<PageBlocksDynamicZone>>;
  breadcrumbs: ComponentCommonComponentsBreadcrumbs;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<PageRelationResponseCollection>;
  metadata: ComponentMetaMetadata;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  showFooter: Scalars['Boolean']['output'];
  showHeader: Scalars['Boolean']['output'];
  slug?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type PageLocalizationsArgs = {
  filters?: InputMaybe<PageFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type PageBlocksDynamicZone = ComponentDynamicBlocksBannerSection | ComponentDynamicBlocksCaseStudiesShowcase | ComponentDynamicBlocksDynamicCaseStudiesPreview | ComponentDynamicBlocksDynamicChartSection | ComponentDynamicBlocksDynamicClientOpinions | ComponentDynamicBlocksDynamicConstantBlock | ComponentDynamicBlocksDynamicDarkInfoDividerBlock | ComponentDynamicBlocksDynamicDividerWithPhotosBlock | ComponentDynamicBlocksDynamicFaces | ComponentDynamicBlocksDynamicFaqBlock | ComponentDynamicBlocksDynamicFeatureListBlock | ComponentDynamicBlocksDynamicGallerySection | ComponentDynamicBlocksDynamicHeroBlock | ComponentDynamicBlocksDynamicHeroWithContactBlock | ComponentDynamicBlocksDynamicHistorySection | ComponentDynamicBlocksDynamicInfoGridBlock | ComponentDynamicBlocksDynamicInfoWithPhotoBlock | ComponentDynamicBlocksDynamicLeadership | ComponentDynamicBlocksDynamicLogosBlock | ComponentDynamicBlocksDynamicMedia | ComponentDynamicBlocksDynamicPartners | ComponentDynamicBlocksDynamicPointsWithPhotosBlock | ComponentDynamicBlocksDynamicRichTextBlock | ComponentDynamicBlocksDynamicScrollSlider | ComponentDynamicBlocksDynamicSeeMoreBlock | ComponentDynamicBlocksDynamicSliderPointsBlock | ComponentDynamicBlocksDynamicStatistics | ComponentDynamicBlocksDynamicTeamInvolved | ComponentDynamicBlocksDynamicTeamInvolvedWithHover | ComponentDynamicBlocksDynamicTestimonialBlock | ComponentDynamicBlocksDynamicTextWithPhotos | ComponentDynamicBlocksDynamicVideoBanner | ComponentDynamicBlocksHowWeWork | ComponentDynamicBlocksLetsBuildBlock | ComponentDynamicBlocksNewsletterBlock | ComponentDynamicBlocksRecommendedArticles | ComponentDynamicBlocksStandaloneContactForm | Error;

export type PageEntity = {
  __typename?: 'PageEntity';
  attributes?: Maybe<Page>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type PageEntityResponse = {
  __typename?: 'PageEntityResponse';
  data?: Maybe<PageEntity>;
};

export type PageEntityResponseCollection = {
  __typename?: 'PageEntityResponseCollection';
  data: Array<PageEntity>;
  meta: ResponseCollectionMeta;
};

export type PageFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<PageFiltersInput>>>;
  breadcrumbs?: InputMaybe<ComponentCommonComponentsBreadcrumbsFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  locale?: InputMaybe<StringFilterInput>;
  localizations?: InputMaybe<PageFiltersInput>;
  metadata?: InputMaybe<ComponentMetaMetadataFiltersInput>;
  not?: InputMaybe<PageFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<PageFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  showFooter?: InputMaybe<BooleanFilterInput>;
  showHeader?: InputMaybe<BooleanFilterInput>;
  slug?: InputMaybe<StringFilterInput>;
  title?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type PageInput = {
  blocks?: InputMaybe<Array<Scalars['PageBlocksDynamicZoneInput']['input']>>;
  breadcrumbs?: InputMaybe<ComponentCommonComponentsBreadcrumbsInput>;
  metadata?: InputMaybe<ComponentMetaMetadataInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  showFooter?: InputMaybe<Scalars['Boolean']['input']>;
  showHeader?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type PageRelationResponseCollection = {
  __typename?: 'PageRelationResponseCollection';
  data: Array<PageEntity>;
};

export type Pagination = {
  __typename?: 'Pagination';
  page: Scalars['Int']['output'];
  pageCount: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PaginationArg = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
};

export type Partner = {
  __typename?: 'Partner';
  clientLogo: UploadFileEntityResponse;
  content: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<PartnerRelationResponseCollection>;
  name: Scalars['String']['output'];
  partnerTags?: Maybe<PartnerTagRelationResponseCollection>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type PartnerLocalizationsArgs = {
  filters?: InputMaybe<PartnerFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type PartnerPartnerTagsArgs = {
  filters?: InputMaybe<PartnerTagFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type PartnerEntity = {
  __typename?: 'PartnerEntity';
  attributes?: Maybe<Partner>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type PartnerEntityResponse = {
  __typename?: 'PartnerEntityResponse';
  data?: Maybe<PartnerEntity>;
};

export type PartnerEntityResponseCollection = {
  __typename?: 'PartnerEntityResponseCollection';
  data: Array<PartnerEntity>;
  meta: ResponseCollectionMeta;
};

export type PartnerFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<PartnerFiltersInput>>>;
  content?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  locale?: InputMaybe<StringFilterInput>;
  localizations?: InputMaybe<PartnerFiltersInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<PartnerFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<PartnerFiltersInput>>>;
  partnerTags?: InputMaybe<PartnerTagFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type PartnerInput = {
  clientLogo?: InputMaybe<Scalars['ID']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  partnerTags?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type PartnerRelationResponseCollection = {
  __typename?: 'PartnerRelationResponseCollection';
  data: Array<PartnerEntity>;
};

export type PartnerTag = {
  __typename?: 'PartnerTag';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<PartnerTagRelationResponseCollection>;
  name: Scalars['String']['output'];
  partners?: Maybe<PartnerRelationResponseCollection>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type PartnerTagLocalizationsArgs = {
  filters?: InputMaybe<PartnerTagFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type PartnerTagPartnersArgs = {
  filters?: InputMaybe<PartnerFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type PartnerTagEntity = {
  __typename?: 'PartnerTagEntity';
  attributes?: Maybe<PartnerTag>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type PartnerTagEntityResponse = {
  __typename?: 'PartnerTagEntityResponse';
  data?: Maybe<PartnerTagEntity>;
};

export type PartnerTagEntityResponseCollection = {
  __typename?: 'PartnerTagEntityResponseCollection';
  data: Array<PartnerTagEntity>;
  meta: ResponseCollectionMeta;
};

export type PartnerTagFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<PartnerTagFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  locale?: InputMaybe<StringFilterInput>;
  localizations?: InputMaybe<PartnerTagFiltersInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<PartnerTagFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<PartnerTagFiltersInput>>>;
  partners?: InputMaybe<PartnerFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type PartnerTagInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  partners?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type PartnerTagRelationResponseCollection = {
  __typename?: 'PartnerTagRelationResponseCollection';
  data: Array<PartnerTagEntity>;
};

export type PrivacyPolicy = {
  __typename?: 'PrivacyPolicy';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<PrivacyPolicyRelationResponseCollection>;
  metadata: ComponentMetaMetadata;
  privacyPolicy: ComponentPrivacyPolicySectionsPrivacyPolicy;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type PrivacyPolicyEntity = {
  __typename?: 'PrivacyPolicyEntity';
  attributes?: Maybe<PrivacyPolicy>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type PrivacyPolicyEntityResponse = {
  __typename?: 'PrivacyPolicyEntityResponse';
  data?: Maybe<PrivacyPolicyEntity>;
};

export type PrivacyPolicyInput = {
  metadata?: InputMaybe<ComponentMetaMetadataInput>;
  privacyPolicy?: InputMaybe<ComponentPrivacyPolicySectionsPrivacyPolicyInput>;
};

export type PrivacyPolicyRelationResponseCollection = {
  __typename?: 'PrivacyPolicyRelationResponseCollection';
  data: Array<PrivacyPolicyEntity>;
};

export enum PublicationState {
  Live = 'LIVE',
  Preview = 'PREVIEW'
}

export type Query = {
  __typename?: 'Query';
  aboutUs?: Maybe<AboutUsEntityResponse>;
  article?: Maybe<ArticleEntityResponse>;
  articleCategories?: Maybe<ArticleCategoryEntityResponseCollection>;
  articleCategory?: Maybe<ArticleCategoryEntityResponse>;
  articleTag?: Maybe<ArticleTagEntityResponse>;
  articleTags?: Maybe<ArticleTagEntityResponseCollection>;
  articles?: Maybe<ArticleEntityResponseCollection>;
  caseStudies?: Maybe<CaseStudyEntityResponseCollection>;
  caseStudy?: Maybe<CaseStudyEntityResponse>;
  caseStudyAll?: Maybe<CaseStudyAllEntityResponse>;
  caseStudyCategories?: Maybe<CaseStudyCategoryEntityResponseCollection>;
  caseStudyCategory?: Maybe<CaseStudyCategoryEntityResponse>;
  caseStudyTag?: Maybe<CaseStudyTagEntityResponse>;
  caseStudyTags?: Maybe<CaseStudyTagEntityResponseCollection>;
  contactForm?: Maybe<ContactFormEntityResponse>;
  contactForms?: Maybe<ContactFormEntityResponseCollection>;
  featuredArticle?: Maybe<ArticleEntityResponse>;
  global?: Maybe<GlobalEntityResponse>;
  guidesPage?: Maybe<GuidesPageEntityResponse>;
  home?: Maybe<HomeEntityResponse>;
  i18NLocale?: Maybe<I18NLocaleEntityResponse>;
  i18NLocales?: Maybe<I18NLocaleEntityResponseCollection>;
  inventoryAll?: Maybe<InventoryAllEntityResponse>;
  inventoryDefinition?: Maybe<InventoryDefinitionEntityResponse>;
  inventoryDefinitions?: Maybe<InventoryDefinitionEntityResponseCollection>;
  leadership?: Maybe<LeadershipEntityResponse>;
  leaderships?: Maybe<LeadershipEntityResponseCollection>;
  libraries?: Maybe<LibraryEntityResponseCollection>;
  library?: Maybe<LibraryEntityResponse>;
  libraryRequest?: Maybe<LibraryRequestEntityResponse>;
  libraryRequests?: Maybe<LibraryRequestEntityResponseCollection>;
  me?: Maybe<UsersPermissionsMe>;
  mostViewedArticles?: Maybe<ArticleEntityResponseCollection>;
  page?: Maybe<PageEntityResponse>;
  pages?: Maybe<PageEntityResponseCollection>;
  partner?: Maybe<PartnerEntityResponse>;
  partnerTag?: Maybe<PartnerTagEntityResponse>;
  partnerTags?: Maybe<PartnerTagEntityResponseCollection>;
  partners?: Maybe<PartnerEntityResponseCollection>;
  privacyPolicy?: Maybe<PrivacyPolicyEntityResponse>;
  resourcesPage?: Maybe<ResourcesPageEntityResponse>;
  uploadFile?: Maybe<UploadFileEntityResponse>;
  uploadFiles?: Maybe<UploadFileEntityResponseCollection>;
  uploadFolder?: Maybe<UploadFolderEntityResponse>;
  uploadFolders?: Maybe<UploadFolderEntityResponseCollection>;
  usersPermissionsRole?: Maybe<UsersPermissionsRoleEntityResponse>;
  usersPermissionsRoles?: Maybe<UsersPermissionsRoleEntityResponseCollection>;
  usersPermissionsUser?: Maybe<UsersPermissionsUserEntityResponse>;
  usersPermissionsUsers?: Maybe<UsersPermissionsUserEntityResponseCollection>;
};


export type QueryAboutUsArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  publicationState?: InputMaybe<PublicationState>;
};


export type QueryArticleArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  isPreview: Scalars['Boolean']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  slug: Scalars['String']['input'];
};


export type QueryArticleCategoriesArgs = {
  filters?: InputMaybe<ArticleCategoryFiltersInput>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryArticleCategoryArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type QueryArticleTagArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type QueryArticleTagsArgs = {
  filters?: InputMaybe<ArticleTagFiltersInput>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryArticlesArgs = {
  filters?: InputMaybe<ArticleFiltersInput>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCaseStudiesArgs = {
  filters?: InputMaybe<CaseStudyFiltersInput>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCaseStudyArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type QueryCaseStudyAllArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type QueryCaseStudyCategoriesArgs = {
  filters?: InputMaybe<CaseStudyCategoryFiltersInput>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCaseStudyCategoryArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type QueryCaseStudyTagArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type QueryCaseStudyTagsArgs = {
  filters?: InputMaybe<CaseStudyTagFiltersInput>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryContactFormArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryContactFormsArgs = {
  filters?: InputMaybe<ContactFormFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryFeaturedArticleArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type QueryGlobalArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type QueryGuidesPageArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type QueryHomeArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  publicationState?: InputMaybe<PublicationState>;
};


export type QueryI18NLocaleArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryI18NLocalesArgs = {
  filters?: InputMaybe<I18NLocaleFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryInventoryAllArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type QueryInventoryDefinitionArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type QueryInventoryDefinitionsArgs = {
  filters?: InputMaybe<InventoryDefinitionFiltersInput>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryLeadershipArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type QueryLeadershipsArgs = {
  filters?: InputMaybe<LeadershipFiltersInput>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryLibrariesArgs = {
  filters?: InputMaybe<LibraryFiltersInput>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryLibraryArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type QueryLibraryRequestArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryLibraryRequestsArgs = {
  filters?: InputMaybe<LibraryRequestFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryMostViewedArticlesArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type QueryPageArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type QueryPagesArgs = {
  filters?: InputMaybe<PageFiltersInput>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryPartnerArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type QueryPartnerTagArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type QueryPartnerTagsArgs = {
  filters?: InputMaybe<PartnerTagFiltersInput>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryPartnersArgs = {
  filters?: InputMaybe<PartnerFiltersInput>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryPrivacyPolicyArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type QueryResourcesPageArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type QueryUploadFileArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryUploadFilesArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryUploadFolderArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryUploadFoldersArgs = {
  filters?: InputMaybe<UploadFolderFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryUsersPermissionsRoleArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryUsersPermissionsRolesArgs = {
  filters?: InputMaybe<UsersPermissionsRoleFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryUsersPermissionsUserArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryUsersPermissionsUsersArgs = {
  filters?: InputMaybe<UsersPermissionsUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ResourcesPage = {
  __typename?: 'ResourcesPage';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<ResourcesPageRelationResponseCollection>;
  metadata: ComponentMetaMetadata;
  mostReadArticles: ArticleRelationResponseCollection;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type ResourcesPageMostReadArticlesArgs = {
  filters?: InputMaybe<ArticleFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ResourcesPageEntity = {
  __typename?: 'ResourcesPageEntity';
  attributes?: Maybe<ResourcesPage>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type ResourcesPageEntityResponse = {
  __typename?: 'ResourcesPageEntityResponse';
  data?: Maybe<ResourcesPageEntity>;
};

export type ResourcesPageInput = {
  metadata?: InputMaybe<ComponentMetaMetadataInput>;
  mostReadArticles?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type ResourcesPageRelationResponseCollection = {
  __typename?: 'ResourcesPageRelationResponseCollection';
  data: Array<ResourcesPageEntity>;
};

export type ResponseCollectionMeta = {
  __typename?: 'ResponseCollectionMeta';
  pagination: Pagination;
};

export type StatusResponse = {
  __typename?: 'StatusResponse';
  ok: Scalars['Boolean']['output'];
};

export type StringFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  containsi?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  eqi?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nei?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<StringFilterInput>;
  notContains?: InputMaybe<Scalars['String']['input']>;
  notContainsi?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type UploadFile = {
  __typename?: 'UploadFile';
  alternativeText?: Maybe<Scalars['String']['output']>;
  caption?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  ext?: Maybe<Scalars['String']['output']>;
  formats?: Maybe<Scalars['JSON']['output']>;
  hash: Scalars['String']['output'];
  height?: Maybe<Scalars['Int']['output']>;
  mime: Scalars['String']['output'];
  name: Scalars['String']['output'];
  placeholder?: Maybe<Scalars['String']['output']>;
  previewUrl?: Maybe<Scalars['String']['output']>;
  provider: Scalars['String']['output'];
  provider_metadata?: Maybe<Scalars['JSON']['output']>;
  related?: Maybe<Array<Maybe<GenericMorph>>>;
  size: Scalars['Float']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  url: Scalars['String']['output'];
  width?: Maybe<Scalars['Int']['output']>;
};

export type UploadFileEntity = {
  __typename?: 'UploadFileEntity';
  attributes?: Maybe<UploadFile>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type UploadFileEntityResponse = {
  __typename?: 'UploadFileEntityResponse';
  data?: Maybe<UploadFileEntity>;
};

export type UploadFileEntityResponseCollection = {
  __typename?: 'UploadFileEntityResponseCollection';
  data: Array<UploadFileEntity>;
  meta: ResponseCollectionMeta;
};

export type UploadFileFiltersInput = {
  alternativeText?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<UploadFileFiltersInput>>>;
  caption?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  ext?: InputMaybe<StringFilterInput>;
  folder?: InputMaybe<UploadFolderFiltersInput>;
  folderPath?: InputMaybe<StringFilterInput>;
  formats?: InputMaybe<JsonFilterInput>;
  hash?: InputMaybe<StringFilterInput>;
  height?: InputMaybe<IntFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  mime?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<UploadFileFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UploadFileFiltersInput>>>;
  placeholder?: InputMaybe<StringFilterInput>;
  previewUrl?: InputMaybe<StringFilterInput>;
  provider?: InputMaybe<StringFilterInput>;
  provider_metadata?: InputMaybe<JsonFilterInput>;
  size?: InputMaybe<FloatFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  url?: InputMaybe<StringFilterInput>;
  width?: InputMaybe<IntFilterInput>;
};

export type UploadFileInput = {
  alternativeText?: InputMaybe<Scalars['String']['input']>;
  caption?: InputMaybe<Scalars['String']['input']>;
  ext?: InputMaybe<Scalars['String']['input']>;
  folder?: InputMaybe<Scalars['ID']['input']>;
  folderPath?: InputMaybe<Scalars['String']['input']>;
  formats?: InputMaybe<Scalars['JSON']['input']>;
  hash?: InputMaybe<Scalars['String']['input']>;
  height?: InputMaybe<Scalars['Int']['input']>;
  mime?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  placeholder?: InputMaybe<Scalars['String']['input']>;
  previewUrl?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  provider_metadata?: InputMaybe<Scalars['JSON']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

export type UploadFileRelationResponseCollection = {
  __typename?: 'UploadFileRelationResponseCollection';
  data: Array<UploadFileEntity>;
};

export type UploadFolder = {
  __typename?: 'UploadFolder';
  children?: Maybe<UploadFolderRelationResponseCollection>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  files?: Maybe<UploadFileRelationResponseCollection>;
  name: Scalars['String']['output'];
  parent?: Maybe<UploadFolderEntityResponse>;
  path: Scalars['String']['output'];
  pathId: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type UploadFolderChildrenArgs = {
  filters?: InputMaybe<UploadFolderFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type UploadFolderFilesArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UploadFolderEntity = {
  __typename?: 'UploadFolderEntity';
  attributes?: Maybe<UploadFolder>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type UploadFolderEntityResponse = {
  __typename?: 'UploadFolderEntityResponse';
  data?: Maybe<UploadFolderEntity>;
};

export type UploadFolderEntityResponseCollection = {
  __typename?: 'UploadFolderEntityResponseCollection';
  data: Array<UploadFolderEntity>;
  meta: ResponseCollectionMeta;
};

export type UploadFolderFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<UploadFolderFiltersInput>>>;
  children?: InputMaybe<UploadFolderFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  files?: InputMaybe<UploadFileFiltersInput>;
  id?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<UploadFolderFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UploadFolderFiltersInput>>>;
  parent?: InputMaybe<UploadFolderFiltersInput>;
  path?: InputMaybe<StringFilterInput>;
  pathId?: InputMaybe<IntFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type UploadFolderInput = {
  children?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  files?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  parent?: InputMaybe<Scalars['ID']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  pathId?: InputMaybe<Scalars['Int']['input']>;
};

export type UploadFolderRelationResponseCollection = {
  __typename?: 'UploadFolderRelationResponseCollection';
  data: Array<UploadFolderEntity>;
};

export type UsersPermissionsCreateRolePayload = {
  __typename?: 'UsersPermissionsCreateRolePayload';
  ok: Scalars['Boolean']['output'];
};

export type UsersPermissionsDeleteRolePayload = {
  __typename?: 'UsersPermissionsDeleteRolePayload';
  ok: Scalars['Boolean']['output'];
};

export type UsersPermissionsLoginInput = {
  identifier: Scalars['String']['input'];
  password: Scalars['String']['input'];
  provider?: Scalars['String']['input'];
};

export type UsersPermissionsLoginPayload = {
  __typename?: 'UsersPermissionsLoginPayload';
  jwt?: Maybe<Scalars['String']['output']>;
  user: UsersPermissionsMe;
};

export type UsersPermissionsMe = {
  __typename?: 'UsersPermissionsMe';
  blocked?: Maybe<Scalars['Boolean']['output']>;
  confirmed?: Maybe<Scalars['Boolean']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  role?: Maybe<UsersPermissionsMeRole>;
  username: Scalars['String']['output'];
};

export type UsersPermissionsMeRole = {
  __typename?: 'UsersPermissionsMeRole';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  type?: Maybe<Scalars['String']['output']>;
};

export type UsersPermissionsPasswordPayload = {
  __typename?: 'UsersPermissionsPasswordPayload';
  ok: Scalars['Boolean']['output'];
};

export type UsersPermissionsPermission = {
  __typename?: 'UsersPermissionsPermission';
  action: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  role?: Maybe<UsersPermissionsRoleEntityResponse>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type UsersPermissionsPermissionEntity = {
  __typename?: 'UsersPermissionsPermissionEntity';
  attributes?: Maybe<UsersPermissionsPermission>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type UsersPermissionsPermissionFiltersInput = {
  action?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<UsersPermissionsPermissionFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<UsersPermissionsPermissionFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UsersPermissionsPermissionFiltersInput>>>;
  role?: InputMaybe<UsersPermissionsRoleFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type UsersPermissionsPermissionRelationResponseCollection = {
  __typename?: 'UsersPermissionsPermissionRelationResponseCollection';
  data: Array<UsersPermissionsPermissionEntity>;
};

export type UsersPermissionsRegisterInput = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type UsersPermissionsRole = {
  __typename?: 'UsersPermissionsRole';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  permissions?: Maybe<UsersPermissionsPermissionRelationResponseCollection>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  users?: Maybe<UsersPermissionsUserRelationResponseCollection>;
};


export type UsersPermissionsRolePermissionsArgs = {
  filters?: InputMaybe<UsersPermissionsPermissionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type UsersPermissionsRoleUsersArgs = {
  filters?: InputMaybe<UsersPermissionsUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UsersPermissionsRoleEntity = {
  __typename?: 'UsersPermissionsRoleEntity';
  attributes?: Maybe<UsersPermissionsRole>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type UsersPermissionsRoleEntityResponse = {
  __typename?: 'UsersPermissionsRoleEntityResponse';
  data?: Maybe<UsersPermissionsRoleEntity>;
};

export type UsersPermissionsRoleEntityResponseCollection = {
  __typename?: 'UsersPermissionsRoleEntityResponseCollection';
  data: Array<UsersPermissionsRoleEntity>;
  meta: ResponseCollectionMeta;
};

export type UsersPermissionsRoleFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<UsersPermissionsRoleFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<UsersPermissionsRoleFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UsersPermissionsRoleFiltersInput>>>;
  permissions?: InputMaybe<UsersPermissionsPermissionFiltersInput>;
  type?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  users?: InputMaybe<UsersPermissionsUserFiltersInput>;
};

export type UsersPermissionsRoleInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  type?: InputMaybe<Scalars['String']['input']>;
  users?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type UsersPermissionsUpdateRolePayload = {
  __typename?: 'UsersPermissionsUpdateRolePayload';
  ok: Scalars['Boolean']['output'];
};

export type UsersPermissionsUser = {
  __typename?: 'UsersPermissionsUser';
  articles?: Maybe<ArticleRelationResponseCollection>;
  avatar?: Maybe<UploadFileEntityResponse>;
  blocked?: Maybe<Scalars['Boolean']['output']>;
  confirmed?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  provider?: Maybe<Scalars['String']['output']>;
  role?: Maybe<UsersPermissionsRoleEntityResponse>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  username: Scalars['String']['output'];
};


export type UsersPermissionsUserArticlesArgs = {
  filters?: InputMaybe<ArticleFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UsersPermissionsUserEntity = {
  __typename?: 'UsersPermissionsUserEntity';
  attributes?: Maybe<UsersPermissionsUser>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type UsersPermissionsUserEntityResponse = {
  __typename?: 'UsersPermissionsUserEntityResponse';
  data?: Maybe<UsersPermissionsUserEntity>;
};

export type UsersPermissionsUserEntityResponseCollection = {
  __typename?: 'UsersPermissionsUserEntityResponseCollection';
  data: Array<UsersPermissionsUserEntity>;
  meta: ResponseCollectionMeta;
};

export type UsersPermissionsUserFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<UsersPermissionsUserFiltersInput>>>;
  articles?: InputMaybe<ArticleFiltersInput>;
  blocked?: InputMaybe<BooleanFilterInput>;
  confirmationToken?: InputMaybe<StringFilterInput>;
  confirmed?: InputMaybe<BooleanFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  email?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<UsersPermissionsUserFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UsersPermissionsUserFiltersInput>>>;
  password?: InputMaybe<StringFilterInput>;
  provider?: InputMaybe<StringFilterInput>;
  resetPasswordToken?: InputMaybe<StringFilterInput>;
  role?: InputMaybe<UsersPermissionsRoleFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  username?: InputMaybe<StringFilterInput>;
};

export type UsersPermissionsUserInput = {
  articles?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  avatar?: InputMaybe<Scalars['ID']['input']>;
  blocked?: InputMaybe<Scalars['Boolean']['input']>;
  confirmationToken?: InputMaybe<Scalars['String']['input']>;
  confirmed?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  resetPasswordToken?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['ID']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type UsersPermissionsUserRelationResponseCollection = {
  __typename?: 'UsersPermissionsUserRelationResponseCollection';
  data: Array<UsersPermissionsUserEntity>;
};

export type ArticleCardFragment = { __typename?: 'Article', slug: string, title: string, lead: string, creationDate: DateLike, minutesOfRead?: number | null, tags: { __typename?: 'ArticleTagRelationResponseCollection', data: Array<{ __typename?: 'ArticleTagEntity', id?: string | null, attributes?: { __typename?: 'ArticleTag', name: string } | null }> }, coverImage: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null }, authors: { __typename?: 'UsersPermissionsUserRelationResponseCollection', data: Array<{ __typename?: 'UsersPermissionsUserEntity', id?: string | null, attributes?: { __typename?: 'UsersPermissionsUser', username: string, description?: string | null, avatar?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } | null } | null }> } };

export type ArticleCategoryFragment = { __typename?: 'ArticleCategoryEntityResponse', data?: { __typename?: 'ArticleCategoryEntity', attributes?: { __typename?: 'ArticleCategory', name: string, topCategory: boolean } | null } | null };

export type ArticleTagsFragment = { __typename?: 'ArticleTagRelationResponseCollection', data: Array<{ __typename?: 'ArticleTagEntity', id?: string | null, attributes?: { __typename?: 'ArticleTag', name: string } | null }> };

export type AuthorsFragment = { __typename?: 'UsersPermissionsUserRelationResponseCollection', data: Array<{ __typename?: 'UsersPermissionsUserEntity', id?: string | null, attributes?: { __typename?: 'UsersPermissionsUser', username: string, description?: string | null, avatar?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } | null } | null }> };

export type ButtonFragment = { __typename?: 'ComponentCommonComponentsButton', label: string, url: string, variant: Enum_Componentcommoncomponentsbutton_Variant };

export type CaseStudyFragment = { __typename?: 'CaseStudyEntity', id?: string | null, attributes?: { __typename?: 'CaseStudy', slug: string, doodleText?: string | null, title: string, description: string, position: number, image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null }, caseStudyCategory?: { __typename?: 'CaseStudyCategoryEntityResponse', data?: { __typename?: 'CaseStudyCategoryEntity', id?: string | null, attributes?: { __typename?: 'CaseStudyCategory', name: string } | null } | null } | null, caseStudyTags?: { __typename?: 'CaseStudyTagRelationResponseCollection', data: Array<{ __typename?: 'CaseStudyTagEntity', id?: string | null, attributes?: { __typename?: 'CaseStudyTag', name: string } | null }> } | null } | null };

export type ClientOpinionCardFragment = { __typename?: 'ComponentHomeComponentsClientOpinionsCard', clientName: string, content: string, clientDescription: string, clientDescriptionSecondLine?: string | null, clientAvatar: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null }, clientLogo: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } };

export type DecoratedTextImgFragment = { __typename: 'ComponentCommonComponentsDecoratedTextImage', id: string, circle?: Enum_Componentcommoncomponentsdecoratedtextimage_Circle | null, exclaim?: Enum_Componentcommoncomponentsdecoratedtextimage_Exclaim | null, highlight?: Enum_Componentcommoncomponentsdecoratedtextimage_Highlight | null, underline?: Enum_Componentcommoncomponentsdecoratedtextimage_Underline | null, isCircleDarkMode?: boolean | null };

export type DynamicTestimonialFragment = { __typename: 'ComponentDynamicBlocksDynamicTestimonialBlock', id: string, quote: string, person: string, position: string, decoratedTextImages?: { __typename: 'ComponentCommonComponentsDecoratedTextImage', id: string, circle?: Enum_Componentcommoncomponentsdecoratedtextimage_Circle | null, exclaim?: Enum_Componentcommoncomponentsdecoratedtextimage_Exclaim | null, highlight?: Enum_Componentcommoncomponentsdecoratedtextimage_Highlight | null, underline?: Enum_Componentcommoncomponentsdecoratedtextimage_Underline | null, isCircleDarkMode?: boolean | null } | null, photo: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } };

export type DynamicHeroFragment = { __typename: 'ComponentDynamicBlocksDynamicHeroBlock', id: string, title: string, description?: string | null, buttonCaption?: string | null, buttonLink?: string | null, decoratedTextImages?: { __typename: 'ComponentCommonComponentsDecoratedTextImage', id: string, circle?: Enum_Componentcommoncomponentsdecoratedtextimage_Circle | null, exclaim?: Enum_Componentcommoncomponentsdecoratedtextimage_Exclaim | null, highlight?: Enum_Componentcommoncomponentsdecoratedtextimage_Highlight | null, underline?: Enum_Componentcommoncomponentsdecoratedtextimage_Underline | null, isCircleDarkMode?: boolean | null } | null };

export type DynamicConstantFragment = { __typename: 'ComponentDynamicBlocksDynamicConstantBlock', id: string, name: Enum_Componentdynamicblocksdynamicconstantblock_Name };

export type DynamicFaqFragment = { __typename: 'ComponentDynamicBlocksDynamicFaqBlock', id: string, header: string, decoratedTextImages?: { __typename: 'ComponentCommonComponentsDecoratedTextImage', id: string, circle?: Enum_Componentcommoncomponentsdecoratedtextimage_Circle | null, exclaim?: Enum_Componentcommoncomponentsdecoratedtextimage_Exclaim | null, highlight?: Enum_Componentcommoncomponentsdecoratedtextimage_Highlight | null, underline?: Enum_Componentcommoncomponentsdecoratedtextimage_Underline | null, isCircleDarkMode?: boolean | null } | null, items: Array<{ __typename?: 'ComponentCommonComponentsFaqItem', answer: string, question: string } | null> };

export type DynamicPointsWithPhotosFragment = { __typename: 'ComponentDynamicBlocksDynamicPointsWithPhotosBlock', id: string, header: string, elements: Array<{ __typename?: 'ComponentCommonComponentsPointWithPhoto', id: string, text: string, photo: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } } | null> };

export type DynamicDarkInfoDividerFragment = { __typename: 'ComponentDynamicBlocksDynamicDarkInfoDividerBlock', id: string, header: string, description?: string | null, buttonLink?: string | null, buttonCaption?: string | null };

export type DynamicInfoWithPhotoFragment = { __typename: 'ComponentDynamicBlocksDynamicInfoWithPhotoBlock', id: string, header: string, message: string, buttonLink?: string | null, buttonCaption?: string | null, photo: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } };

export type LogosFragment = { __typename?: 'ArticleTagRelationResponseCollection', data: Array<{ __typename?: 'ArticleTagEntity', id?: string | null, attributes?: { __typename?: 'ArticleTag', name: string } | null }> };

export type DynamicLogosFragment = { __typename: 'ComponentDynamicBlocksDynamicLogosBlock', id: string, header: string, logos: { __typename?: 'UploadFileRelationResponseCollection', data: Array<{ __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null }> } };

export type DynamicRichTextFragment = { __typename: 'ComponentDynamicBlocksDynamicRichTextBlock', id: string, text: { __typename: 'ComponentCommonComponentsCkEditor', id: string, richText: string } };

export type DynamicInfoGridFragment = { __typename: 'ComponentDynamicBlocksDynamicInfoGridBlock', id: string, header: string, mode: Enum_Componentdynamicblocksdynamicinfogridblock_Mode, items: Array<{ __typename?: 'ComponentCommonComponentsGridListItem', heading: string, description: string, buttonLabel?: string | null, buttonLink?: string | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } | null } | null>, decoratedTextImages?: { __typename: 'ComponentCommonComponentsDecoratedTextImage', id: string, circle?: Enum_Componentcommoncomponentsdecoratedtextimage_Circle | null, exclaim?: Enum_Componentcommoncomponentsdecoratedtextimage_Exclaim | null, highlight?: Enum_Componentcommoncomponentsdecoratedtextimage_Highlight | null, underline?: Enum_Componentcommoncomponentsdecoratedtextimage_Underline | null, isCircleDarkMode?: boolean | null } | null };

export type DynamicSliderWithPointsFragment = { __typename: 'ComponentDynamicBlocksDynamicSliderPointsBlock', id: string, header: string, subheader: string, items: Array<{ __typename?: 'ComponentCommonComponentsSliderPointsItem', header: string, paragraphOneTitle: string, paragraphTwoTitle?: string | null, paragraphThreeTitle?: string | null, paragraphOneDescription: string, paragraphTwoDescription?: string | null, paragraphThreeDescription?: string | null, buttonLabel?: string | null, buttonLink?: string | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } | null } | null> };

export type DynamicDividerWithPhotosFragment = { __typename: 'ComponentDynamicBlocksDynamicDividerWithPhotosBlock', id: string, multipleImages: { __typename?: 'UploadFileRelationResponseCollection', data: Array<{ __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null }> } };

export type DynamicGallerySectionFragment = { __typename: 'ComponentDynamicBlocksDynamicGallerySection', id: string, topText?: string | null, middleText?: string | null, bottomText?: string | null };

export type AvatarWithHoverFragment = { __typename?: 'ComponentCommonComponentsHoverAvatar', id: string, hoverText: string, name?: string | null, role?: string | null, image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } };

export type DynamicTextWithPhotosFragment = { __typename: 'ComponentDynamicBlocksDynamicTextWithPhotos', id: string, headerStartText?: string | null, headerMiddleText?: string | null, headerEndText?: string | null, desc?: string | null, button?: { __typename?: 'ComponentCommonComponentsButton', label: string, url: string, variant: Enum_Componentcommoncomponentsbutton_Variant } | null, firstAvatar?: { __typename?: 'ComponentCommonComponentsHoverAvatar', id: string, hoverText: string, name?: string | null, role?: string | null, image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } } | null, secondAvatar?: { __typename?: 'ComponentCommonComponentsHoverAvatar', id: string, hoverText: string, name?: string | null, role?: string | null, image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } } | null };

export type DynamicChartSectionFragment = { __typename: 'ComponentDynamicBlocksDynamicChartSection', id: string, header: string, items: Array<{ __typename?: 'ComponentCommonComponentsChartPoint', id: string, heading: string, list: Array<{ __typename?: 'ComponentCommonComponentsTextListItem', id: string, textListItem: string } | null> } | null> };

export type DynamicHistorySectionFragment = { __typename: 'ComponentDynamicBlocksDynamicHistorySection', id: string, header: string, items: Array<{ __typename?: 'ComponentCommonComponentsHistory', id: string, year: string, name: string, description: string } | null> };

export type DynamicTeamInvolvedFragment = { __typename: 'ComponentDynamicBlocksDynamicTeamInvolved', id: string, header: string, subheader: string, items: Array<{ __typename?: 'ComponentCommonComponentsImageWithCaption', id: string, caption: string, image1: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', width?: number | null, height?: number | null, url: string } | null } | null } } | null> };

export type DynamicFeatureListFragment = { __typename: 'ComponentDynamicBlocksDynamicFeatureListBlock', id: string, cta: string, largeImage: boolean, displayDigits: boolean, imagePosition: Enum_Componentdynamicblocksdynamicfeaturelistblock_Imageposition, buttonLabel?: string | null, buttonLink?: string | null, ctaImage: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null }, ctaImageMobile?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } | null, items: Array<{ __typename?: 'ComponentCommonComponentsFeatureWithDoodle', id: string, text: string, paragraph?: string | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } | null } | null> };

export type DynamicHeroWithContactFragment = { __typename: 'ComponentDynamicBlocksDynamicHeroWithContactBlock', id: string, ctaTop: string, ctaBottom?: string | null, contactCardTitle: string, contactCardLabel: string, formNameLabel: string, formEmailLabel: string, formPhoneLabel: string, formCompanyLabel: string, formPrivacyPolicyLabel: string, formSubmitLabel: string, formPrivacyPolicyLink?: string | null, contactCardAdditionalLabelText?: string | null, thanksInPolish?: boolean | null, withDoodleInBackground?: boolean | null, hideMobileButton?: boolean | null, backgroundImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } | null, contactCardImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } | null };

export type DynamicClientOpinionsFragment = { __typename: 'ComponentDynamicBlocksDynamicClientOpinions', id: string, title: string, subtitle: string, opinions: { __typename?: 'ComponentHomeSectionsClientOpinions', id: string, opinions: Array<{ __typename?: 'ComponentHomeComponentsClientOpinionsCard', id: string, clientName: string, clientDescription: string, clientDescriptionSecondLine?: string | null, content: string, clientLogo: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null }, clientAvatar: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } } | null>, awardLogo: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } }, decoratedTextImages?: { __typename: 'ComponentCommonComponentsDecoratedTextImage', id: string, circle?: Enum_Componentcommoncomponentsdecoratedtextimage_Circle | null, exclaim?: Enum_Componentcommoncomponentsdecoratedtextimage_Exclaim | null, highlight?: Enum_Componentcommoncomponentsdecoratedtextimage_Highlight | null, underline?: Enum_Componentcommoncomponentsdecoratedtextimage_Underline | null, isCircleDarkMode?: boolean | null } | null };

export type DynamicSeeMoreBlockFragment = { __typename: 'ComponentDynamicBlocksDynamicSeeMoreBlock', id: string, header: string, buttonLabel?: string | null, buttonLink?: string | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } | null };

export type DynamicPartnersBlockFragment = { __typename: 'ComponentDynamicBlocksDynamicPartners', id: string, header: string, partners: { __typename?: 'PartnerRelationResponseCollection', data: Array<{ __typename?: 'PartnerEntity', id?: string | null, attributes?: { __typename?: 'Partner', content: string, name: string, clientLogo: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null }, partnerTags?: { __typename?: 'PartnerTagRelationResponseCollection', data: Array<{ __typename?: 'PartnerTagEntity', id?: string | null, attributes?: { __typename?: 'PartnerTag', name: string } | null }> } | null } | null }> } };

export type DynamicLeadershipFragment = { __typename: 'ComponentDynamicBlocksDynamicLeadership', id: string, header: string, leaders: { __typename?: 'LeadershipRelationResponseCollection', data: Array<{ __typename?: 'LeadershipEntity', attributes?: { __typename?: 'Leadership', name: string, position: string, url: string, avatar: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } } | null }> } };

export type DynamicStatisticsFragment = { __typename: 'ComponentDynamicBlocksDynamicStatistics', id: string, underlinedValues?: boolean | null, darkBackground?: boolean | null, statHeader?: string | null, statistics: Array<{ __typename?: 'ComponentAboutUsStatistics', value: string, description: string, descriptionAdd?: string | null } | null> };

export type DynamicCaseStudiesPreviewFragment = { __typename: 'ComponentDynamicBlocksDynamicCaseStudiesPreview', id: string, bigBoxHeader: string, bigBoxButtonLabel: string, bigBoxButtonLink: string, middleBoxCaption: string, rightBoxCaption: string, bigBoxBackgroundImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } | null, middleBoxBackgroundImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } | null, rightBoxBackgroundImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } | null };

export type DynamicVideoBannerFragment = { __typename: 'ComponentDynamicBlocksDynamicVideoBanner', id: string, header: string, buttonLabel?: string | null, buttonLink?: string | null, coverImageFallback: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null }, coverVideoUrl: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null }, decoratedTextImages?: { __typename: 'ComponentCommonComponentsDecoratedTextImage', id: string, circle?: Enum_Componentcommoncomponentsdecoratedtextimage_Circle | null, exclaim?: Enum_Componentcommoncomponentsdecoratedtextimage_Exclaim | null, highlight?: Enum_Componentcommoncomponentsdecoratedtextimage_Highlight | null, underline?: Enum_Componentcommoncomponentsdecoratedtextimage_Underline | null, isCircleDarkMode?: boolean | null } | null };

export type DynamicTeamInvolvedWithHoverFragment = { __typename: 'ComponentDynamicBlocksDynamicTeamInvolvedWithHover', id: string, header: string, items: Array<{ __typename?: 'ComponentCommonComponentsHoverImageWithCaption', imageCaptionFirstLine: string, imageCaptionSecondLine?: string | null, comment: string, hoverImage: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null }, afterImage: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } } | null> };

export type HowWeWorkFragment = { __typename: 'ComponentDynamicBlocksHowWeWork', id: string, heading: string, howWeWorkItem: Array<{ __typename?: 'ComponentCommonComponentsItems', id: string, text: string, image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } } | null> };

export type DynamicScrollSliderFragment = { __typename: 'ComponentDynamicBlocksDynamicScrollSlider', id: string, badgeText: string, badgeImage: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null }, items: Array<{ __typename?: 'ComponentCommonComponentsSliderItem', imageAlt: string, url: string, slideImage: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } } | null> };

export type DynamicMediaFragment = { __typename: 'ComponentDynamicBlocksDynamicMedia', id: string, items: Array<{ __typename: 'ComponentCommonComponentsMediaItem', id: string, name: string, coverVideo: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null }, coverImageFallback: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } } | null> };

export type StandaloneContactFormFragment = { __typename: 'ComponentDynamicBlocksStandaloneContactForm', id: string, contactCardTitle: string, contactCardLabel: string, formNameLabel: string, formEmailLabel: string, formPhoneLabel: string, formCompanyLabel: string, formPrivacyPolicyLabel: string, formSubmitLabel: string, formPrivacyPolicyLink?: string | null, contactCardAdditionalLabelText?: string | null, thanksInPolish?: boolean | null, contactCardImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } | null };

export type DynamicFacesFragment = { __typename: 'ComponentDynamicBlocksDynamicFaces', id: string, header: string, decoratedTextImages?: { __typename: 'ComponentCommonComponentsDecoratedTextImage', id: string, circle?: Enum_Componentcommoncomponentsdecoratedtextimage_Circle | null, exclaim?: Enum_Componentcommoncomponentsdecoratedtextimage_Exclaim | null, highlight?: Enum_Componentcommoncomponentsdecoratedtextimage_Highlight | null, underline?: Enum_Componentcommoncomponentsdecoratedtextimage_Underline | null, isCircleDarkMode?: boolean | null } | null, items: Array<{ __typename: 'ComponentCommonComponentsFaceItem', id: string, name: string, position: string, comment: string, image1: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null }, image2: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } } | null> };

export type DynamicRecommendedArticlesFragment = { __typename: 'ComponentDynamicBlocksRecommendedArticles', id: string, header: string, decoratedTextImages?: { __typename: 'ComponentCommonComponentsDecoratedTextImage', id: string, circle?: Enum_Componentcommoncomponentsdecoratedtextimage_Circle | null, exclaim?: Enum_Componentcommoncomponentsdecoratedtextimage_Exclaim | null, highlight?: Enum_Componentcommoncomponentsdecoratedtextimage_Highlight | null, underline?: Enum_Componentcommoncomponentsdecoratedtextimage_Underline | null, isCircleDarkMode?: boolean | null } | null, tags: { __typename?: 'ArticleTagRelationResponseCollection', data: Array<{ __typename?: 'ArticleTagEntity', id?: string | null, attributes?: { __typename?: 'ArticleTag', name: string } | null }> } };

export type CaseStudiesShowcaseFragment = { __typename: 'ComponentDynamicBlocksCaseStudiesShowcase', id: string, title: string, subtitle: string, buttonText: string, caseStudySlugs: Array<{ __typename?: 'ComponentCommonComponentsShowcaseCaseStudySlugs', id: string, caseStudySlug: string } | null> };

export type LetsBuildBlockFragment = { __typename: 'ComponentDynamicBlocksLetsBuildBlock', id: string, ctaText: string };

export type NewsletterBlockFragment = { __typename: 'ComponentDynamicBlocksNewsletterBlock', id: string, info: string, emailPlaceholder: string, marketingText: string, marketingPrivacyLinkLabel: string, subscribe: string, successLabel: string };

export type BannerBlockFragment = { __typename: 'ComponentDynamicBlocksBannerSection', id: string, bannerTitle: string, bannerDesc: string };

export type DynamicYourTurnSectionFragment = { __typename: 'ComponentDynamicBlocksDynamicYourTurnSection', id: string, header: string, subheader: string, paragraph: string, buttonCaption?: string | null, buttonLink?: string | null, quote: string, person: string, position: string, photo: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null }, leaders: { __typename?: 'LeadershipRelationResponseCollection', data: Array<{ __typename?: 'LeadershipEntity', id?: string | null, attributes?: { __typename?: 'Leadership', name: string, position: string, url: string, avatar: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } } | null }> } };

export type FileFragment = { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string } | null } | null };

export type ImageFragment = { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null };

export type ImagesFragment = { __typename?: 'UploadFileRelationResponseCollection', data: Array<{ __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null }> };

export type LeadershipFragment = { __typename?: 'LeadershipEntity', attributes?: { __typename?: 'Leadership', name: string, position: string, url: string, avatar: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } } | null };

export type LinkFragment = { __typename?: 'ComponentCommonComponentsLink', label: string, url: string };

export type MetadataFragment = { __typename?: 'ComponentMetaMetadata', metaTitle: string, metaDescription: string, ogImage: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } };

export type OurServicesCardFragment = { __typename?: 'ComponentHomeComponentsOurServiceCard', id: string, heading: string, description: string, buttonHref?: string | null, buttonCaption?: string | null, priceFrom?: string | null, list?: Array<{ __typename?: 'ComponentCommonComponentsRichListItem', id: string, emoji?: string | null, heading?: string | null, description: string } | null> | null };

export type PartnerFragment = { __typename?: 'PartnerEntity', attributes?: { __typename?: 'Partner', content: string, clientLogo: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null }, partnerTags?: { __typename?: 'PartnerTagRelationResponseCollection', data: Array<{ __typename?: 'PartnerTagEntity', id?: string | null, attributes?: { __typename?: 'PartnerTag', name: string } | null }> } | null } | null };

type RichText_ComponentCommonComponentsCkEditor_Fragment = { __typename: 'ComponentCommonComponentsCkEditor', id: string, richText: string };

type RichText_ComponentDynamicBlocksBannerSection_Fragment = { __typename?: 'ComponentDynamicBlocksBannerSection' };

type RichText_ComponentDynamicBlocksCaseStudiesShowcase_Fragment = { __typename?: 'ComponentDynamicBlocksCaseStudiesShowcase' };

type RichText_ComponentDynamicBlocksDynamicCaseStudiesPreview_Fragment = { __typename?: 'ComponentDynamicBlocksDynamicCaseStudiesPreview' };

type RichText_ComponentDynamicBlocksDynamicChartSection_Fragment = { __typename?: 'ComponentDynamicBlocksDynamicChartSection' };

type RichText_ComponentDynamicBlocksDynamicClientOpinions_Fragment = { __typename?: 'ComponentDynamicBlocksDynamicClientOpinions' };

type RichText_ComponentDynamicBlocksDynamicConstantBlock_Fragment = { __typename?: 'ComponentDynamicBlocksDynamicConstantBlock' };

type RichText_ComponentDynamicBlocksDynamicDarkInfoDividerBlock_Fragment = { __typename?: 'ComponentDynamicBlocksDynamicDarkInfoDividerBlock' };

type RichText_ComponentDynamicBlocksDynamicDividerWithPhotosBlock_Fragment = { __typename?: 'ComponentDynamicBlocksDynamicDividerWithPhotosBlock' };

type RichText_ComponentDynamicBlocksDynamicFaces_Fragment = { __typename?: 'ComponentDynamicBlocksDynamicFaces' };

type RichText_ComponentDynamicBlocksDynamicFaqBlock_Fragment = { __typename?: 'ComponentDynamicBlocksDynamicFaqBlock' };

type RichText_ComponentDynamicBlocksDynamicFeatureListBlock_Fragment = { __typename?: 'ComponentDynamicBlocksDynamicFeatureListBlock' };

type RichText_ComponentDynamicBlocksDynamicGallerySection_Fragment = { __typename?: 'ComponentDynamicBlocksDynamicGallerySection' };

type RichText_ComponentDynamicBlocksDynamicHeroBlock_Fragment = { __typename?: 'ComponentDynamicBlocksDynamicHeroBlock' };

type RichText_ComponentDynamicBlocksDynamicHeroWithContactBlock_Fragment = { __typename?: 'ComponentDynamicBlocksDynamicHeroWithContactBlock' };

type RichText_ComponentDynamicBlocksDynamicHistorySection_Fragment = { __typename?: 'ComponentDynamicBlocksDynamicHistorySection' };

type RichText_ComponentDynamicBlocksDynamicInfoGridBlock_Fragment = { __typename?: 'ComponentDynamicBlocksDynamicInfoGridBlock' };

type RichText_ComponentDynamicBlocksDynamicInfoWithPhotoBlock_Fragment = { __typename?: 'ComponentDynamicBlocksDynamicInfoWithPhotoBlock' };

type RichText_ComponentDynamicBlocksDynamicLeadership_Fragment = { __typename?: 'ComponentDynamicBlocksDynamicLeadership' };

type RichText_ComponentDynamicBlocksDynamicLogosBlock_Fragment = { __typename?: 'ComponentDynamicBlocksDynamicLogosBlock' };

type RichText_ComponentDynamicBlocksDynamicMedia_Fragment = { __typename?: 'ComponentDynamicBlocksDynamicMedia' };

type RichText_ComponentDynamicBlocksDynamicPartners_Fragment = { __typename?: 'ComponentDynamicBlocksDynamicPartners' };

type RichText_ComponentDynamicBlocksDynamicPointsWithPhotosBlock_Fragment = { __typename?: 'ComponentDynamicBlocksDynamicPointsWithPhotosBlock' };

type RichText_ComponentDynamicBlocksDynamicRichTextBlock_Fragment = { __typename?: 'ComponentDynamicBlocksDynamicRichTextBlock' };

type RichText_ComponentDynamicBlocksDynamicScrollSlider_Fragment = { __typename?: 'ComponentDynamicBlocksDynamicScrollSlider' };

type RichText_ComponentDynamicBlocksDynamicSeeMoreBlock_Fragment = { __typename?: 'ComponentDynamicBlocksDynamicSeeMoreBlock' };

type RichText_ComponentDynamicBlocksDynamicSliderPointsBlock_Fragment = { __typename?: 'ComponentDynamicBlocksDynamicSliderPointsBlock' };

type RichText_ComponentDynamicBlocksDynamicStatistics_Fragment = { __typename?: 'ComponentDynamicBlocksDynamicStatistics' };

type RichText_ComponentDynamicBlocksDynamicTeamInvolved_Fragment = { __typename?: 'ComponentDynamicBlocksDynamicTeamInvolved' };

type RichText_ComponentDynamicBlocksDynamicTeamInvolvedWithHover_Fragment = { __typename?: 'ComponentDynamicBlocksDynamicTeamInvolvedWithHover' };

type RichText_ComponentDynamicBlocksDynamicTestimonialBlock_Fragment = { __typename?: 'ComponentDynamicBlocksDynamicTestimonialBlock' };

type RichText_ComponentDynamicBlocksDynamicTextWithPhotos_Fragment = { __typename?: 'ComponentDynamicBlocksDynamicTextWithPhotos' };

type RichText_ComponentDynamicBlocksDynamicVideoBanner_Fragment = { __typename?: 'ComponentDynamicBlocksDynamicVideoBanner' };

type RichText_ComponentDynamicBlocksHowWeWork_Fragment = { __typename?: 'ComponentDynamicBlocksHowWeWork' };

type RichText_ComponentDynamicBlocksLetsBuildBlock_Fragment = { __typename?: 'ComponentDynamicBlocksLetsBuildBlock' };

type RichText_ComponentDynamicBlocksNewsletterBlock_Fragment = { __typename?: 'ComponentDynamicBlocksNewsletterBlock' };

type RichText_ComponentDynamicBlocksRecommendedArticles_Fragment = { __typename?: 'ComponentDynamicBlocksRecommendedArticles' };

type RichText_ComponentDynamicBlocksStandaloneContactForm_Fragment = { __typename?: 'ComponentDynamicBlocksStandaloneContactForm' };

type RichText_Error_Fragment = { __typename?: 'Error' };

export type RichTextFragment = RichText_ComponentCommonComponentsCkEditor_Fragment | RichText_ComponentDynamicBlocksBannerSection_Fragment | RichText_ComponentDynamicBlocksCaseStudiesShowcase_Fragment | RichText_ComponentDynamicBlocksDynamicCaseStudiesPreview_Fragment | RichText_ComponentDynamicBlocksDynamicChartSection_Fragment | RichText_ComponentDynamicBlocksDynamicClientOpinions_Fragment | RichText_ComponentDynamicBlocksDynamicConstantBlock_Fragment | RichText_ComponentDynamicBlocksDynamicDarkInfoDividerBlock_Fragment | RichText_ComponentDynamicBlocksDynamicDividerWithPhotosBlock_Fragment | RichText_ComponentDynamicBlocksDynamicFaces_Fragment | RichText_ComponentDynamicBlocksDynamicFaqBlock_Fragment | RichText_ComponentDynamicBlocksDynamicFeatureListBlock_Fragment | RichText_ComponentDynamicBlocksDynamicGallerySection_Fragment | RichText_ComponentDynamicBlocksDynamicHeroBlock_Fragment | RichText_ComponentDynamicBlocksDynamicHeroWithContactBlock_Fragment | RichText_ComponentDynamicBlocksDynamicHistorySection_Fragment | RichText_ComponentDynamicBlocksDynamicInfoGridBlock_Fragment | RichText_ComponentDynamicBlocksDynamicInfoWithPhotoBlock_Fragment | RichText_ComponentDynamicBlocksDynamicLeadership_Fragment | RichText_ComponentDynamicBlocksDynamicLogosBlock_Fragment | RichText_ComponentDynamicBlocksDynamicMedia_Fragment | RichText_ComponentDynamicBlocksDynamicPartners_Fragment | RichText_ComponentDynamicBlocksDynamicPointsWithPhotosBlock_Fragment | RichText_ComponentDynamicBlocksDynamicRichTextBlock_Fragment | RichText_ComponentDynamicBlocksDynamicScrollSlider_Fragment | RichText_ComponentDynamicBlocksDynamicSeeMoreBlock_Fragment | RichText_ComponentDynamicBlocksDynamicSliderPointsBlock_Fragment | RichText_ComponentDynamicBlocksDynamicStatistics_Fragment | RichText_ComponentDynamicBlocksDynamicTeamInvolved_Fragment | RichText_ComponentDynamicBlocksDynamicTeamInvolvedWithHover_Fragment | RichText_ComponentDynamicBlocksDynamicTestimonialBlock_Fragment | RichText_ComponentDynamicBlocksDynamicTextWithPhotos_Fragment | RichText_ComponentDynamicBlocksDynamicVideoBanner_Fragment | RichText_ComponentDynamicBlocksHowWeWork_Fragment | RichText_ComponentDynamicBlocksLetsBuildBlock_Fragment | RichText_ComponentDynamicBlocksNewsletterBlock_Fragment | RichText_ComponentDynamicBlocksRecommendedArticles_Fragment | RichText_ComponentDynamicBlocksStandaloneContactForm_Fragment | RichText_Error_Fragment;

export type RichTextBlockFragment = { __typename?: 'ComponentCommonComponentsCkEditor', id: string, richText: string };

export type SocialItemFragment = { __typename?: 'ComponentCommonComponentsSocialItem', url: string, icon: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } };

export type StickyCtaFragment = { __typename?: 'ComponentCommonComponentsStickyCta', title: string, subttitle: string, buttonCaption?: string | null, buttonLink?: string | null };

export type TechStackRowFragment = { __typename?: 'ComponentHomeComponentsTechStackRow', pill: Array<{ __typename?: 'ComponentCommonComponentsImageWithCaption', caption: string, image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } } | null> };

export type TextListFragment = { __typename?: 'ComponentCommonComponentsTextList', textListItems: Array<{ __typename?: 'ComponentCommonComponentsTextListItem', textListItem: string } | null> };

export type UserFragment = { __typename?: 'UsersPermissionsUserEntity', id?: string | null, attributes?: { __typename?: 'UsersPermissionsUser', username: string, description?: string | null, avatar?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } | null } | null };

export type AddSubscriberToNewsletterMutationVariables = Exact<{
  email: Scalars['String']['input'];
  captchaToken: Scalars['String']['input'];
}>;


export type AddSubscriberToNewsletterMutation = { __typename?: 'Mutation', addContactToAudience: { __typename?: 'StatusResponse', ok: boolean } };

export type CreateLibraryRequestMutationVariables = Exact<{
  data: LibraryRequestInput;
}>;


export type CreateLibraryRequestMutation = { __typename?: 'Mutation', createLibraryRequest?: { __typename?: 'LibraryRequestEntityResponse', data?: { __typename?: 'LibraryRequestEntity', id?: string | null, attributes?: { __typename?: 'LibraryRequest', library?: { __typename?: 'LibraryEntityResponse', data?: { __typename?: 'LibraryEntity', attributes?: { __typename?: 'Library', asset: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string } | null } | null } } | null } | null } | null } | null } | null } | null };

export type StatisticsFragment = { __typename?: 'ComponentAboutUsStatistics', value: string, description: string, descriptionAdd?: string | null };

export type ValuesFragment = { __typename?: 'ComponentAboutUsValues', header: string, description: string, coverImageFallback: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null }, coverVideo?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } | null };

export type GetAboutUsQueryVariables = Exact<{
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
}>;


export type GetAboutUsQuery = { __typename?: 'Query', aboutUs?: { __typename?: 'AboutUsEntityResponse', data?: { __typename?: 'AboutUsEntity', attributes?: { __typename?: 'AboutUs', metadata: { __typename?: 'ComponentMetaMetadata', metaTitle: string, metaDescription: string, ogImage: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } }, statistics: Array<{ __typename?: 'ComponentAboutUsStatistics', value: string, description: string, descriptionAdd?: string | null } | null>, partners: { __typename?: 'PartnerRelationResponseCollection', data: Array<{ __typename?: 'PartnerEntity', attributes?: { __typename?: 'Partner', content: string, clientLogo: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null }, partnerTags?: { __typename?: 'PartnerTagRelationResponseCollection', data: Array<{ __typename?: 'PartnerTagEntity', id?: string | null, attributes?: { __typename?: 'PartnerTag', name: string } | null }> } | null } | null }> }, leaderships: { __typename?: 'LeadershipRelationResponseCollection', data: Array<{ __typename?: 'LeadershipEntity', attributes?: { __typename?: 'Leadership', name: string, position: string, url: string, avatar: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } } | null }> }, blocks: Array<{ __typename: 'ComponentDynamicBlocksBannerSection', id: string, bannerTitle: string, bannerDesc: string } | { __typename: 'ComponentDynamicBlocksCaseStudiesShowcase', id: string, title: string, subtitle: string, buttonText: string, caseStudySlugs: Array<{ __typename?: 'ComponentCommonComponentsShowcaseCaseStudySlugs', id: string, caseStudySlug: string } | null> } | { __typename: 'ComponentDynamicBlocksDynamicCaseStudiesPreview', id: string, bigBoxHeader: string, bigBoxButtonLabel: string, bigBoxButtonLink: string, middleBoxCaption: string, rightBoxCaption: string, bigBoxBackgroundImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } | null, middleBoxBackgroundImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } | null, rightBoxBackgroundImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } | null } | { __typename: 'ComponentDynamicBlocksDynamicChartSection', id: string, header: string, items: Array<{ __typename?: 'ComponentCommonComponentsChartPoint', id: string, heading: string, list: Array<{ __typename?: 'ComponentCommonComponentsTextListItem', id: string, textListItem: string } | null> } | null> } | { __typename: 'ComponentDynamicBlocksDynamicClientOpinions', id: string, title: string, subtitle: string, opinions: { __typename?: 'ComponentHomeSectionsClientOpinions', id: string, opinions: Array<{ __typename?: 'ComponentHomeComponentsClientOpinionsCard', id: string, clientName: string, clientDescription: string, clientDescriptionSecondLine?: string | null, content: string, clientLogo: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null }, clientAvatar: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } } | null>, awardLogo: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } }, decoratedTextImages?: { __typename: 'ComponentCommonComponentsDecoratedTextImage', id: string, circle?: Enum_Componentcommoncomponentsdecoratedtextimage_Circle | null, exclaim?: Enum_Componentcommoncomponentsdecoratedtextimage_Exclaim | null, highlight?: Enum_Componentcommoncomponentsdecoratedtextimage_Highlight | null, underline?: Enum_Componentcommoncomponentsdecoratedtextimage_Underline | null, isCircleDarkMode?: boolean | null } | null } | { __typename: 'ComponentDynamicBlocksDynamicConstantBlock', id: string, name: Enum_Componentdynamicblocksdynamicconstantblock_Name } | { __typename: 'ComponentDynamicBlocksDynamicDarkInfoDividerBlock', id: string, header: string, description?: string | null, buttonLink?: string | null, buttonCaption?: string | null } | { __typename: 'ComponentDynamicBlocksDynamicDividerWithPhotosBlock', id: string, multipleImages: { __typename?: 'UploadFileRelationResponseCollection', data: Array<{ __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null }> } } | { __typename: 'ComponentDynamicBlocksDynamicFaces', id: string, header: string, decoratedTextImages?: { __typename: 'ComponentCommonComponentsDecoratedTextImage', id: string, circle?: Enum_Componentcommoncomponentsdecoratedtextimage_Circle | null, exclaim?: Enum_Componentcommoncomponentsdecoratedtextimage_Exclaim | null, highlight?: Enum_Componentcommoncomponentsdecoratedtextimage_Highlight | null, underline?: Enum_Componentcommoncomponentsdecoratedtextimage_Underline | null, isCircleDarkMode?: boolean | null } | null, items: Array<{ __typename: 'ComponentCommonComponentsFaceItem', id: string, name: string, position: string, comment: string, image1: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null }, image2: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } } | null> } | { __typename: 'ComponentDynamicBlocksDynamicFaqBlock', id: string, header: string, decoratedTextImages?: { __typename: 'ComponentCommonComponentsDecoratedTextImage', id: string, circle?: Enum_Componentcommoncomponentsdecoratedtextimage_Circle | null, exclaim?: Enum_Componentcommoncomponentsdecoratedtextimage_Exclaim | null, highlight?: Enum_Componentcommoncomponentsdecoratedtextimage_Highlight | null, underline?: Enum_Componentcommoncomponentsdecoratedtextimage_Underline | null, isCircleDarkMode?: boolean | null } | null, items: Array<{ __typename?: 'ComponentCommonComponentsFaqItem', answer: string, question: string } | null> } | { __typename: 'ComponentDynamicBlocksDynamicFeatureListBlock', id: string, cta: string, largeImage: boolean, displayDigits: boolean, imagePosition: Enum_Componentdynamicblocksdynamicfeaturelistblock_Imageposition, buttonLabel?: string | null, buttonLink?: string | null, ctaImage: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null }, ctaImageMobile?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } | null, items: Array<{ __typename?: 'ComponentCommonComponentsFeatureWithDoodle', id: string, text: string, paragraph?: string | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } | null } | null> } | { __typename: 'ComponentDynamicBlocksDynamicGallerySection', id: string, topText?: string | null, middleText?: string | null, bottomText?: string | null } | { __typename: 'ComponentDynamicBlocksDynamicHeroBlock', id: string, title: string, description?: string | null, buttonCaption?: string | null, buttonLink?: string | null, decoratedTextImages?: { __typename: 'ComponentCommonComponentsDecoratedTextImage', id: string, circle?: Enum_Componentcommoncomponentsdecoratedtextimage_Circle | null, exclaim?: Enum_Componentcommoncomponentsdecoratedtextimage_Exclaim | null, highlight?: Enum_Componentcommoncomponentsdecoratedtextimage_Highlight | null, underline?: Enum_Componentcommoncomponentsdecoratedtextimage_Underline | null, isCircleDarkMode?: boolean | null } | null } | { __typename: 'ComponentDynamicBlocksDynamicHeroWithContactBlock', id: string, ctaTop: string, ctaBottom?: string | null, contactCardTitle: string, contactCardLabel: string, formNameLabel: string, formEmailLabel: string, formPhoneLabel: string, formCompanyLabel: string, formPrivacyPolicyLabel: string, formSubmitLabel: string, formPrivacyPolicyLink?: string | null, contactCardAdditionalLabelText?: string | null, thanksInPolish?: boolean | null, withDoodleInBackground?: boolean | null, hideMobileButton?: boolean | null, backgroundImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } | null, contactCardImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } | null } | { __typename: 'ComponentDynamicBlocksDynamicHistorySection', id: string, header: string, items: Array<{ __typename?: 'ComponentCommonComponentsHistory', id: string, year: string, name: string, description: string } | null> } | { __typename: 'ComponentDynamicBlocksDynamicInfoGridBlock', id: string, header: string, mode: Enum_Componentdynamicblocksdynamicinfogridblock_Mode, items: Array<{ __typename?: 'ComponentCommonComponentsGridListItem', heading: string, description: string, buttonLabel?: string | null, buttonLink?: string | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } | null } | null>, decoratedTextImages?: { __typename: 'ComponentCommonComponentsDecoratedTextImage', id: string, circle?: Enum_Componentcommoncomponentsdecoratedtextimage_Circle | null, exclaim?: Enum_Componentcommoncomponentsdecoratedtextimage_Exclaim | null, highlight?: Enum_Componentcommoncomponentsdecoratedtextimage_Highlight | null, underline?: Enum_Componentcommoncomponentsdecoratedtextimage_Underline | null, isCircleDarkMode?: boolean | null } | null } | { __typename: 'ComponentDynamicBlocksDynamicInfoWithPhotoBlock', id: string, header: string, message: string, buttonLink?: string | null, buttonCaption?: string | null, photo: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } } | { __typename: 'ComponentDynamicBlocksDynamicLeadership', id: string, header: string, leaders: { __typename?: 'LeadershipRelationResponseCollection', data: Array<{ __typename?: 'LeadershipEntity', attributes?: { __typename?: 'Leadership', name: string, position: string, url: string, avatar: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } } | null }> } } | { __typename: 'ComponentDynamicBlocksDynamicLogosBlock', id: string, header: string, logos: { __typename?: 'UploadFileRelationResponseCollection', data: Array<{ __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null }> } } | { __typename: 'ComponentDynamicBlocksDynamicMedia', id: string, items: Array<{ __typename: 'ComponentCommonComponentsMediaItem', id: string, name: string, coverVideo: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null }, coverImageFallback: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } } | null> } | { __typename: 'ComponentDynamicBlocksDynamicPartners', id: string, header: string, partners: { __typename?: 'PartnerRelationResponseCollection', data: Array<{ __typename?: 'PartnerEntity', id?: string | null, attributes?: { __typename?: 'Partner', content: string, name: string, clientLogo: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null }, partnerTags?: { __typename?: 'PartnerTagRelationResponseCollection', data: Array<{ __typename?: 'PartnerTagEntity', id?: string | null, attributes?: { __typename?: 'PartnerTag', name: string } | null }> } | null } | null }> } } | { __typename: 'ComponentDynamicBlocksDynamicPointsWithPhotosBlock', id: string, header: string, elements: Array<{ __typename?: 'ComponentCommonComponentsPointWithPhoto', id: string, text: string, photo: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } } | null> } | { __typename: 'ComponentDynamicBlocksDynamicRichTextBlock', id: string, text: { __typename: 'ComponentCommonComponentsCkEditor', id: string, richText: string } } | { __typename: 'ComponentDynamicBlocksDynamicScrollSlider', id: string, badgeText: string, badgeImage: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null }, items: Array<{ __typename?: 'ComponentCommonComponentsSliderItem', imageAlt: string, url: string, slideImage: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } } | null> } | { __typename: 'ComponentDynamicBlocksDynamicSeeMoreBlock', id: string, header: string, buttonLabel?: string | null, buttonLink?: string | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } | null } | { __typename: 'ComponentDynamicBlocksDynamicSliderPointsBlock', id: string, header: string, subheader: string, items: Array<{ __typename?: 'ComponentCommonComponentsSliderPointsItem', header: string, paragraphOneTitle: string, paragraphTwoTitle?: string | null, paragraphThreeTitle?: string | null, paragraphOneDescription: string, paragraphTwoDescription?: string | null, paragraphThreeDescription?: string | null, buttonLabel?: string | null, buttonLink?: string | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } | null } | null> } | { __typename: 'ComponentDynamicBlocksDynamicStatistics', id: string, underlinedValues?: boolean | null, darkBackground?: boolean | null, statHeader?: string | null, statistics: Array<{ __typename?: 'ComponentAboutUsStatistics', value: string, description: string, descriptionAdd?: string | null } | null> } | { __typename: 'ComponentDynamicBlocksDynamicTeamInvolved', id: string, header: string, subheader: string, items: Array<{ __typename?: 'ComponentCommonComponentsImageWithCaption', id: string, caption: string, image1: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', width?: number | null, height?: number | null, url: string } | null } | null } } | null> } | { __typename: 'ComponentDynamicBlocksDynamicTeamInvolvedWithHover', id: string, header: string, items: Array<{ __typename?: 'ComponentCommonComponentsHoverImageWithCaption', imageCaptionFirstLine: string, imageCaptionSecondLine?: string | null, comment: string, hoverImage: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null }, afterImage: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } } | null> } | { __typename: 'ComponentDynamicBlocksDynamicTestimonialBlock', id: string, quote: string, person: string, position: string, decoratedTextImages?: { __typename: 'ComponentCommonComponentsDecoratedTextImage', id: string, circle?: Enum_Componentcommoncomponentsdecoratedtextimage_Circle | null, exclaim?: Enum_Componentcommoncomponentsdecoratedtextimage_Exclaim | null, highlight?: Enum_Componentcommoncomponentsdecoratedtextimage_Highlight | null, underline?: Enum_Componentcommoncomponentsdecoratedtextimage_Underline | null, isCircleDarkMode?: boolean | null } | null, photo: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } } | { __typename: 'ComponentDynamicBlocksDynamicTextWithPhotos', id: string, headerStartText?: string | null, headerMiddleText?: string | null, headerEndText?: string | null, desc?: string | null, button?: { __typename?: 'ComponentCommonComponentsButton', label: string, url: string, variant: Enum_Componentcommoncomponentsbutton_Variant } | null, firstAvatar?: { __typename?: 'ComponentCommonComponentsHoverAvatar', id: string, hoverText: string, name?: string | null, role?: string | null, image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } } | null, secondAvatar?: { __typename?: 'ComponentCommonComponentsHoverAvatar', id: string, hoverText: string, name?: string | null, role?: string | null, image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } } | null } | { __typename: 'ComponentDynamicBlocksDynamicVideoBanner', id: string, header: string, buttonLabel?: string | null, buttonLink?: string | null, coverImageFallback: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null }, coverVideoUrl: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null }, decoratedTextImages?: { __typename: 'ComponentCommonComponentsDecoratedTextImage', id: string, circle?: Enum_Componentcommoncomponentsdecoratedtextimage_Circle | null, exclaim?: Enum_Componentcommoncomponentsdecoratedtextimage_Exclaim | null, highlight?: Enum_Componentcommoncomponentsdecoratedtextimage_Highlight | null, underline?: Enum_Componentcommoncomponentsdecoratedtextimage_Underline | null, isCircleDarkMode?: boolean | null } | null } | { __typename: 'ComponentDynamicBlocksHowWeWork', id: string, heading: string, howWeWorkItem: Array<{ __typename?: 'ComponentCommonComponentsItems', id: string, text: string, image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } } | null> } | { __typename: 'ComponentDynamicBlocksLetsBuildBlock', id: string, ctaText: string } | { __typename: 'ComponentDynamicBlocksNewsletterBlock', id: string, info: string, emailPlaceholder: string, marketingText: string, marketingPrivacyLinkLabel: string, subscribe: string, successLabel: string } | { __typename: 'ComponentDynamicBlocksRecommendedArticles', id: string, header: string, decoratedTextImages?: { __typename: 'ComponentCommonComponentsDecoratedTextImage', id: string, circle?: Enum_Componentcommoncomponentsdecoratedtextimage_Circle | null, exclaim?: Enum_Componentcommoncomponentsdecoratedtextimage_Exclaim | null, highlight?: Enum_Componentcommoncomponentsdecoratedtextimage_Highlight | null, underline?: Enum_Componentcommoncomponentsdecoratedtextimage_Underline | null, isCircleDarkMode?: boolean | null } | null, tags: { __typename?: 'ArticleTagRelationResponseCollection', data: Array<{ __typename?: 'ArticleTagEntity', id?: string | null, attributes?: { __typename?: 'ArticleTag', name: string } | null }> } } | { __typename: 'ComponentDynamicBlocksStandaloneContactForm', id: string, contactCardTitle: string, contactCardLabel: string, formNameLabel: string, formEmailLabel: string, formPhoneLabel: string, formCompanyLabel: string, formPrivacyPolicyLabel: string, formSubmitLabel: string, formPrivacyPolicyLink?: string | null, contactCardAdditionalLabelText?: string | null, thanksInPolish?: boolean | null, contactCardImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } | null } | { __typename?: 'Error' } | null> } | null } | null } | null };

export type GetArticleBySlugQueryVariables = Exact<{
  slug: Scalars['String']['input'];
  isPreview: Scalars['Boolean']['input'];
  locale: Scalars['I18NLocaleCode']['input'];
}>;


export type GetArticleBySlugQuery = { __typename?: 'Query', article?: { __typename?: 'ArticleEntityResponse', data?: { __typename?: 'ArticleEntity', id?: string | null, attributes?: { __typename?: 'Article', slug: string, title: string, titleMarkdown?: string | null, content: string, creationDate: DateLike, minutesOfRead?: number | null, createdAt?: DateLike | null, updatedAt?: DateLike | null, metadata: { __typename?: 'ComponentMetaMetadata', metaTitle: string, metaDescription: string, ogImage: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } }, stickyCta?: { __typename?: 'ComponentCommonComponentsStickyCta', title: string, subttitle: string, buttonCaption?: string | null, buttonLink?: string | null } | null, authors: { __typename?: 'UsersPermissionsUserRelationResponseCollection', data: Array<{ __typename?: 'UsersPermissionsUserEntity', id?: string | null, attributes?: { __typename?: 'UsersPermissionsUser', username: string, description?: string | null, avatar?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } | null } | null }> }, coverImage: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null }, tags: { __typename?: 'ArticleTagRelationResponseCollection', data: Array<{ __typename?: 'ArticleTagEntity', id?: string | null, attributes?: { __typename?: 'ArticleTag', name: string } | null }> }, dynamicBlocks?: Array<{ __typename: 'ComponentDynamicBlocksBannerSection', id: string, bannerTitle: string, bannerDesc: string } | { __typename: 'ComponentDynamicBlocksCaseStudiesShowcase', id: string, title: string, subtitle: string, buttonText: string, caseStudySlugs: Array<{ __typename?: 'ComponentCommonComponentsShowcaseCaseStudySlugs', id: string, caseStudySlug: string } | null> } | { __typename: 'ComponentDynamicBlocksDynamicCaseStudiesPreview', id: string, bigBoxHeader: string, bigBoxButtonLabel: string, bigBoxButtonLink: string, middleBoxCaption: string, rightBoxCaption: string, bigBoxBackgroundImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } | null, middleBoxBackgroundImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } | null, rightBoxBackgroundImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } | null } | { __typename: 'ComponentDynamicBlocksDynamicChartSection', id: string, header: string, items: Array<{ __typename?: 'ComponentCommonComponentsChartPoint', id: string, heading: string, list: Array<{ __typename?: 'ComponentCommonComponentsTextListItem', id: string, textListItem: string } | null> } | null> } | { __typename: 'ComponentDynamicBlocksDynamicClientOpinions', id: string, title: string, subtitle: string, opinions: { __typename?: 'ComponentHomeSectionsClientOpinions', id: string, opinions: Array<{ __typename?: 'ComponentHomeComponentsClientOpinionsCard', id: string, clientName: string, clientDescription: string, clientDescriptionSecondLine?: string | null, content: string, clientLogo: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null }, clientAvatar: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } } | null>, awardLogo: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } }, decoratedTextImages?: { __typename: 'ComponentCommonComponentsDecoratedTextImage', id: string, circle?: Enum_Componentcommoncomponentsdecoratedtextimage_Circle | null, exclaim?: Enum_Componentcommoncomponentsdecoratedtextimage_Exclaim | null, highlight?: Enum_Componentcommoncomponentsdecoratedtextimage_Highlight | null, underline?: Enum_Componentcommoncomponentsdecoratedtextimage_Underline | null, isCircleDarkMode?: boolean | null } | null } | { __typename: 'ComponentDynamicBlocksDynamicConstantBlock', id: string, name: Enum_Componentdynamicblocksdynamicconstantblock_Name } | { __typename: 'ComponentDynamicBlocksDynamicDarkInfoDividerBlock', id: string, header: string, description?: string | null, buttonLink?: string | null, buttonCaption?: string | null } | { __typename: 'ComponentDynamicBlocksDynamicDividerWithPhotosBlock', id: string, multipleImages: { __typename?: 'UploadFileRelationResponseCollection', data: Array<{ __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null }> } } | { __typename: 'ComponentDynamicBlocksDynamicFaces', id: string, header: string, decoratedTextImages?: { __typename: 'ComponentCommonComponentsDecoratedTextImage', id: string, circle?: Enum_Componentcommoncomponentsdecoratedtextimage_Circle | null, exclaim?: Enum_Componentcommoncomponentsdecoratedtextimage_Exclaim | null, highlight?: Enum_Componentcommoncomponentsdecoratedtextimage_Highlight | null, underline?: Enum_Componentcommoncomponentsdecoratedtextimage_Underline | null, isCircleDarkMode?: boolean | null } | null, items: Array<{ __typename: 'ComponentCommonComponentsFaceItem', id: string, name: string, position: string, comment: string, image1: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null }, image2: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } } | null> } | { __typename: 'ComponentDynamicBlocksDynamicFaqBlock', id: string, header: string, decoratedTextImages?: { __typename: 'ComponentCommonComponentsDecoratedTextImage', id: string, circle?: Enum_Componentcommoncomponentsdecoratedtextimage_Circle | null, exclaim?: Enum_Componentcommoncomponentsdecoratedtextimage_Exclaim | null, highlight?: Enum_Componentcommoncomponentsdecoratedtextimage_Highlight | null, underline?: Enum_Componentcommoncomponentsdecoratedtextimage_Underline | null, isCircleDarkMode?: boolean | null } | null, items: Array<{ __typename?: 'ComponentCommonComponentsFaqItem', answer: string, question: string } | null> } | { __typename: 'ComponentDynamicBlocksDynamicFeatureListBlock', id: string, cta: string, largeImage: boolean, displayDigits: boolean, imagePosition: Enum_Componentdynamicblocksdynamicfeaturelistblock_Imageposition, buttonLabel?: string | null, buttonLink?: string | null, ctaImage: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null }, ctaImageMobile?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } | null, items: Array<{ __typename?: 'ComponentCommonComponentsFeatureWithDoodle', id: string, text: string, paragraph?: string | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } | null } | null> } | { __typename: 'ComponentDynamicBlocksDynamicGallerySection', id: string, topText?: string | null, middleText?: string | null, bottomText?: string | null } | { __typename: 'ComponentDynamicBlocksDynamicHeroBlock', id: string, title: string, description?: string | null, buttonCaption?: string | null, buttonLink?: string | null, decoratedTextImages?: { __typename: 'ComponentCommonComponentsDecoratedTextImage', id: string, circle?: Enum_Componentcommoncomponentsdecoratedtextimage_Circle | null, exclaim?: Enum_Componentcommoncomponentsdecoratedtextimage_Exclaim | null, highlight?: Enum_Componentcommoncomponentsdecoratedtextimage_Highlight | null, underline?: Enum_Componentcommoncomponentsdecoratedtextimage_Underline | null, isCircleDarkMode?: boolean | null } | null } | { __typename: 'ComponentDynamicBlocksDynamicHeroWithContactBlock', id: string, ctaTop: string, ctaBottom?: string | null, contactCardTitle: string, contactCardLabel: string, formNameLabel: string, formEmailLabel: string, formPhoneLabel: string, formCompanyLabel: string, formPrivacyPolicyLabel: string, formSubmitLabel: string, formPrivacyPolicyLink?: string | null, contactCardAdditionalLabelText?: string | null, thanksInPolish?: boolean | null, withDoodleInBackground?: boolean | null, hideMobileButton?: boolean | null, backgroundImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } | null, contactCardImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } | null } | { __typename: 'ComponentDynamicBlocksDynamicHistorySection', id: string, header: string, items: Array<{ __typename?: 'ComponentCommonComponentsHistory', id: string, year: string, name: string, description: string } | null> } | { __typename: 'ComponentDynamicBlocksDynamicInfoGridBlock', id: string, header: string, mode: Enum_Componentdynamicblocksdynamicinfogridblock_Mode, items: Array<{ __typename?: 'ComponentCommonComponentsGridListItem', heading: string, description: string, buttonLabel?: string | null, buttonLink?: string | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } | null } | null>, decoratedTextImages?: { __typename: 'ComponentCommonComponentsDecoratedTextImage', id: string, circle?: Enum_Componentcommoncomponentsdecoratedtextimage_Circle | null, exclaim?: Enum_Componentcommoncomponentsdecoratedtextimage_Exclaim | null, highlight?: Enum_Componentcommoncomponentsdecoratedtextimage_Highlight | null, underline?: Enum_Componentcommoncomponentsdecoratedtextimage_Underline | null, isCircleDarkMode?: boolean | null } | null } | { __typename: 'ComponentDynamicBlocksDynamicInfoWithPhotoBlock', id: string, header: string, message: string, buttonLink?: string | null, buttonCaption?: string | null, photo: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } } | { __typename: 'ComponentDynamicBlocksDynamicLeadership', id: string, header: string, leaders: { __typename?: 'LeadershipRelationResponseCollection', data: Array<{ __typename?: 'LeadershipEntity', attributes?: { __typename?: 'Leadership', name: string, position: string, url: string, avatar: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } } | null }> } } | { __typename: 'ComponentDynamicBlocksDynamicLogosBlock', id: string, header: string, logos: { __typename?: 'UploadFileRelationResponseCollection', data: Array<{ __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null }> } } | { __typename: 'ComponentDynamicBlocksDynamicMedia', id: string, items: Array<{ __typename: 'ComponentCommonComponentsMediaItem', id: string, name: string, coverVideo: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null }, coverImageFallback: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } } | null> } | { __typename: 'ComponentDynamicBlocksDynamicPartners', id: string, header: string, partners: { __typename?: 'PartnerRelationResponseCollection', data: Array<{ __typename?: 'PartnerEntity', id?: string | null, attributes?: { __typename?: 'Partner', content: string, name: string, clientLogo: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null }, partnerTags?: { __typename?: 'PartnerTagRelationResponseCollection', data: Array<{ __typename?: 'PartnerTagEntity', id?: string | null, attributes?: { __typename?: 'PartnerTag', name: string } | null }> } | null } | null }> } } | { __typename: 'ComponentDynamicBlocksDynamicPointsWithPhotosBlock', id: string, header: string, elements: Array<{ __typename?: 'ComponentCommonComponentsPointWithPhoto', id: string, text: string, photo: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } } | null> } | { __typename: 'ComponentDynamicBlocksDynamicRichTextBlock', id: string, text: { __typename: 'ComponentCommonComponentsCkEditor', id: string, richText: string } } | { __typename: 'ComponentDynamicBlocksDynamicScrollSlider', id: string, badgeText: string, badgeImage: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null }, items: Array<{ __typename?: 'ComponentCommonComponentsSliderItem', imageAlt: string, url: string, slideImage: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } } | null> } | { __typename: 'ComponentDynamicBlocksDynamicSeeMoreBlock', id: string, header: string, buttonLabel?: string | null, buttonLink?: string | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } | null } | { __typename: 'ComponentDynamicBlocksDynamicSliderPointsBlock', id: string, header: string, subheader: string, items: Array<{ __typename?: 'ComponentCommonComponentsSliderPointsItem', header: string, paragraphOneTitle: string, paragraphTwoTitle?: string | null, paragraphThreeTitle?: string | null, paragraphOneDescription: string, paragraphTwoDescription?: string | null, paragraphThreeDescription?: string | null, buttonLabel?: string | null, buttonLink?: string | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } | null } | null> } | { __typename: 'ComponentDynamicBlocksDynamicStatistics', id: string, underlinedValues?: boolean | null, darkBackground?: boolean | null, statHeader?: string | null, statistics: Array<{ __typename?: 'ComponentAboutUsStatistics', value: string, description: string, descriptionAdd?: string | null } | null> } | { __typename: 'ComponentDynamicBlocksDynamicTeamInvolved', id: string, header: string, subheader: string, items: Array<{ __typename?: 'ComponentCommonComponentsImageWithCaption', id: string, caption: string, image1: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', width?: number | null, height?: number | null, url: string } | null } | null } } | null> } | { __typename: 'ComponentDynamicBlocksDynamicTeamInvolvedWithHover', id: string, header: string, items: Array<{ __typename?: 'ComponentCommonComponentsHoverImageWithCaption', imageCaptionFirstLine: string, imageCaptionSecondLine?: string | null, comment: string, hoverImage: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null }, afterImage: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } } | null> } | { __typename: 'ComponentDynamicBlocksDynamicTestimonialBlock', id: string, quote: string, person: string, position: string, decoratedTextImages?: { __typename: 'ComponentCommonComponentsDecoratedTextImage', id: string, circle?: Enum_Componentcommoncomponentsdecoratedtextimage_Circle | null, exclaim?: Enum_Componentcommoncomponentsdecoratedtextimage_Exclaim | null, highlight?: Enum_Componentcommoncomponentsdecoratedtextimage_Highlight | null, underline?: Enum_Componentcommoncomponentsdecoratedtextimage_Underline | null, isCircleDarkMode?: boolean | null } | null, photo: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } } | { __typename: 'ComponentDynamicBlocksDynamicTextWithPhotos', id: string, headerStartText?: string | null, headerMiddleText?: string | null, headerEndText?: string | null, desc?: string | null, button?: { __typename?: 'ComponentCommonComponentsButton', label: string, url: string, variant: Enum_Componentcommoncomponentsbutton_Variant } | null, firstAvatar?: { __typename?: 'ComponentCommonComponentsHoverAvatar', id: string, hoverText: string, name?: string | null, role?: string | null, image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } } | null, secondAvatar?: { __typename?: 'ComponentCommonComponentsHoverAvatar', id: string, hoverText: string, name?: string | null, role?: string | null, image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } } | null } | { __typename: 'ComponentDynamicBlocksDynamicVideoBanner', id: string, header: string, buttonLabel?: string | null, buttonLink?: string | null, coverImageFallback: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null }, coverVideoUrl: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null }, decoratedTextImages?: { __typename: 'ComponentCommonComponentsDecoratedTextImage', id: string, circle?: Enum_Componentcommoncomponentsdecoratedtextimage_Circle | null, exclaim?: Enum_Componentcommoncomponentsdecoratedtextimage_Exclaim | null, highlight?: Enum_Componentcommoncomponentsdecoratedtextimage_Highlight | null, underline?: Enum_Componentcommoncomponentsdecoratedtextimage_Underline | null, isCircleDarkMode?: boolean | null } | null } | { __typename: 'ComponentDynamicBlocksHowWeWork', id: string, heading: string, howWeWorkItem: Array<{ __typename?: 'ComponentCommonComponentsItems', id: string, text: string, image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } } | null> } | { __typename: 'ComponentDynamicBlocksLetsBuildBlock', id: string, ctaText: string } | { __typename: 'ComponentDynamicBlocksNewsletterBlock', id: string, info: string, emailPlaceholder: string, marketingText: string, marketingPrivacyLinkLabel: string, subscribe: string, successLabel: string } | { __typename: 'ComponentDynamicBlocksRecommendedArticles', id: string, header: string, decoratedTextImages?: { __typename: 'ComponentCommonComponentsDecoratedTextImage', id: string, circle?: Enum_Componentcommoncomponentsdecoratedtextimage_Circle | null, exclaim?: Enum_Componentcommoncomponentsdecoratedtextimage_Exclaim | null, highlight?: Enum_Componentcommoncomponentsdecoratedtextimage_Highlight | null, underline?: Enum_Componentcommoncomponentsdecoratedtextimage_Underline | null, isCircleDarkMode?: boolean | null } | null, tags: { __typename?: 'ArticleTagRelationResponseCollection', data: Array<{ __typename?: 'ArticleTagEntity', id?: string | null, attributes?: { __typename?: 'ArticleTag', name: string } | null }> } } | { __typename: 'ComponentDynamicBlocksStandaloneContactForm', id: string, contactCardTitle: string, contactCardLabel: string, formNameLabel: string, formEmailLabel: string, formPhoneLabel: string, formCompanyLabel: string, formPrivacyPolicyLabel: string, formSubmitLabel: string, formPrivacyPolicyLink?: string | null, contactCardAdditionalLabelText?: string | null, thanksInPolish?: boolean | null, contactCardImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } | null } | { __typename?: 'Error' } | null> | null, category: { __typename?: 'ArticleCategoryEntityResponse', data?: { __typename?: 'ArticleCategoryEntity', id?: string | null } | null } } | null } | null } | null };

export type GetArticleCardsQueryVariables = Exact<{
  publicationState: PublicationState;
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  title: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
}>;


export type GetArticleCardsQuery = { __typename?: 'Query', articles?: { __typename?: 'ArticleEntityResponseCollection', data: Array<{ __typename?: 'ArticleEntity', id?: string | null, attributes?: { __typename?: 'Article', slug: string, title: string, lead: string, creationDate: DateLike, minutesOfRead?: number | null, tags: { __typename?: 'ArticleTagRelationResponseCollection', data: Array<{ __typename?: 'ArticleTagEntity', id?: string | null, attributes?: { __typename?: 'ArticleTag', name: string } | null }> }, coverImage: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null }, authors: { __typename?: 'UsersPermissionsUserRelationResponseCollection', data: Array<{ __typename?: 'UsersPermissionsUserEntity', id?: string | null, attributes?: { __typename?: 'UsersPermissionsUser', username: string, description?: string | null, avatar?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } | null } | null }> } } | null }>, meta: { __typename?: 'ResponseCollectionMeta', pagination: { __typename?: 'Pagination', page: number, pageSize: number, pageCount: number, total: number } } } | null };

export type GetArticleCategoriesQueryVariables = Exact<{
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
}>;


export type GetArticleCategoriesQuery = { __typename?: 'Query', articleCategories?: { __typename?: 'ArticleCategoryEntityResponseCollection', data: Array<{ __typename?: 'ArticleCategoryEntity', id?: string | null, attributes?: { __typename?: 'ArticleCategory', name: string } | null }> } | null };

export type GetArticlesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetArticlesQuery = { __typename?: 'Query', articles?: { __typename?: 'ArticleEntityResponseCollection', data: Array<{ __typename?: 'ArticleEntity', attributes?: { __typename?: 'Article', slug: string } | null }> } | null };

export type GetCaseStudiesQueryVariables = Exact<{
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
}>;


export type GetCaseStudiesQuery = { __typename?: 'Query', caseStudies?: { __typename?: 'CaseStudyEntityResponseCollection', data: Array<{ __typename?: 'CaseStudyEntity', id?: string | null, attributes?: { __typename?: 'CaseStudy', slug: string, doodleText?: string | null, title: string, description: string, position: number, image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null }, caseStudyCategory?: { __typename?: 'CaseStudyCategoryEntityResponse', data?: { __typename?: 'CaseStudyCategoryEntity', id?: string | null, attributes?: { __typename?: 'CaseStudyCategory', name: string } | null } | null } | null, caseStudyTags?: { __typename?: 'CaseStudyTagRelationResponseCollection', data: Array<{ __typename?: 'CaseStudyTagEntity', id?: string | null, attributes?: { __typename?: 'CaseStudyTag', name: string } | null }> } | null } | null }> } | null };

export type GetCaseStudiesBySlugArrayQueryVariables = Exact<{
  slugs?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  locale: Scalars['I18NLocaleCode']['input'];
}>;


export type GetCaseStudiesBySlugArrayQuery = { __typename?: 'Query', caseStudies?: { __typename?: 'CaseStudyEntityResponseCollection', data: Array<{ __typename?: 'CaseStudyEntity', id?: string | null, attributes?: { __typename?: 'CaseStudy', slug: string, doodleText?: string | null, title: string, description: string, position: number, image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null }, caseStudyCategory?: { __typename?: 'CaseStudyCategoryEntityResponse', data?: { __typename?: 'CaseStudyCategoryEntity', id?: string | null, attributes?: { __typename?: 'CaseStudyCategory', name: string } | null } | null } | null, caseStudyTags?: { __typename?: 'CaseStudyTagRelationResponseCollection', data: Array<{ __typename?: 'CaseStudyTagEntity', id?: string | null, attributes?: { __typename?: 'CaseStudyTag', name: string } | null }> } | null } | null }> } | null };

export type FeaturedCaseStudyFragment = { __typename?: 'ComponentCaseStudyAllSectionsFeatured', heading: string, descriptionOne: string, descriptionTwo?: string | null, caseStudy?: { __typename?: 'CaseStudyEntityResponse', data?: { __typename?: 'CaseStudyEntity', id?: string | null, attributes?: { __typename?: 'CaseStudy', slug: string, doodleText?: string | null, title: string, description: string, position: number, image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null }, caseStudyCategory?: { __typename?: 'CaseStudyCategoryEntityResponse', data?: { __typename?: 'CaseStudyCategoryEntity', id?: string | null, attributes?: { __typename?: 'CaseStudyCategory', name: string } | null } | null } | null, caseStudyTags?: { __typename?: 'CaseStudyTagRelationResponseCollection', data: Array<{ __typename?: 'CaseStudyTagEntity', id?: string | null, attributes?: { __typename?: 'CaseStudyTag', name: string } | null }> } | null } | null } | null } | null };

export type GetCaseStudyAllQueryVariables = Exact<{
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
}>;


export type GetCaseStudyAllQuery = { __typename?: 'Query', caseStudyAll?: { __typename?: 'CaseStudyAllEntityResponse', data?: { __typename?: 'CaseStudyAllEntity', attributes?: { __typename?: 'CaseStudyAll', featured: { __typename?: 'ComponentCaseStudyAllSectionsFeatured', heading: string, descriptionOne: string, descriptionTwo?: string | null, caseStudy?: { __typename?: 'CaseStudyEntityResponse', data?: { __typename?: 'CaseStudyEntity', id?: string | null, attributes?: { __typename?: 'CaseStudy', slug: string, doodleText?: string | null, title: string, description: string, position: number, image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null }, caseStudyCategory?: { __typename?: 'CaseStudyCategoryEntityResponse', data?: { __typename?: 'CaseStudyCategoryEntity', id?: string | null, attributes?: { __typename?: 'CaseStudyCategory', name: string } | null } | null } | null, caseStudyTags?: { __typename?: 'CaseStudyTagRelationResponseCollection', data: Array<{ __typename?: 'CaseStudyTagEntity', id?: string | null, attributes?: { __typename?: 'CaseStudyTag', name: string } | null }> } | null } | null } | null } | null }, metadata: { __typename?: 'ComponentMetaMetadata', metaTitle: string, metaDescription: string, ogImage: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } } } | null } | null } | null };

export type GetCaseStudyBySlugQueryVariables = Exact<{
  slug: Scalars['String']['input'];
  publicationState: PublicationState;
  locale: Scalars['I18NLocaleCode']['input'];
}>;


export type GetCaseStudyBySlugQuery = { __typename?: 'Query', caseStudies?: { __typename?: 'CaseStudyEntityResponseCollection', data: Array<{ __typename?: 'CaseStudyEntity', id?: string | null, attributes?: { __typename?: 'CaseStudy', title: string, titleMarkdown?: string | null, description: string, descriptionMarkdown?: string | null, client: string, clientTooltip?: string | null, location: string, website?: string | null, projectStatus?: string | null, projectStartDate?: string | null, slug: string, doodleText?: string | null, position: number, metadata: { __typename?: 'ComponentMetaMetadata', metaTitle: string, metaDescription: string, ogImage: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } }, contentBlocks: Array<{ __typename: 'ComponentCommonComponentsCkEditor', id: string, richText: string } | { __typename: 'ComponentDynamicBlocksBannerSection', id: string, bannerTitle: string, bannerDesc: string } | { __typename: 'ComponentDynamicBlocksCaseStudiesShowcase', id: string, title: string, subtitle: string, buttonText: string, caseStudySlugs: Array<{ __typename?: 'ComponentCommonComponentsShowcaseCaseStudySlugs', id: string, caseStudySlug: string } | null> } | { __typename: 'ComponentDynamicBlocksDynamicCaseStudiesPreview', id: string, bigBoxHeader: string, bigBoxButtonLabel: string, bigBoxButtonLink: string, middleBoxCaption: string, rightBoxCaption: string, bigBoxBackgroundImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } | null, middleBoxBackgroundImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } | null, rightBoxBackgroundImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } | null } | { __typename: 'ComponentDynamicBlocksDynamicChartSection', id: string, header: string, items: Array<{ __typename?: 'ComponentCommonComponentsChartPoint', id: string, heading: string, list: Array<{ __typename?: 'ComponentCommonComponentsTextListItem', id: string, textListItem: string } | null> } | null> } | { __typename: 'ComponentDynamicBlocksDynamicClientOpinions', id: string, title: string, subtitle: string, opinions: { __typename?: 'ComponentHomeSectionsClientOpinions', id: string, opinions: Array<{ __typename?: 'ComponentHomeComponentsClientOpinionsCard', id: string, clientName: string, clientDescription: string, clientDescriptionSecondLine?: string | null, content: string, clientLogo: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null }, clientAvatar: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } } | null>, awardLogo: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } }, decoratedTextImages?: { __typename: 'ComponentCommonComponentsDecoratedTextImage', id: string, circle?: Enum_Componentcommoncomponentsdecoratedtextimage_Circle | null, exclaim?: Enum_Componentcommoncomponentsdecoratedtextimage_Exclaim | null, highlight?: Enum_Componentcommoncomponentsdecoratedtextimage_Highlight | null, underline?: Enum_Componentcommoncomponentsdecoratedtextimage_Underline | null, isCircleDarkMode?: boolean | null } | null } | { __typename: 'ComponentDynamicBlocksDynamicConstantBlock', id: string, name: Enum_Componentdynamicblocksdynamicconstantblock_Name } | { __typename: 'ComponentDynamicBlocksDynamicDarkInfoDividerBlock', id: string, header: string, description?: string | null, buttonLink?: string | null, buttonCaption?: string | null } | { __typename: 'ComponentDynamicBlocksDynamicDividerWithPhotosBlock', id: string, multipleImages: { __typename?: 'UploadFileRelationResponseCollection', data: Array<{ __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null }> } } | { __typename: 'ComponentDynamicBlocksDynamicFaces', id: string, header: string, decoratedTextImages?: { __typename: 'ComponentCommonComponentsDecoratedTextImage', id: string, circle?: Enum_Componentcommoncomponentsdecoratedtextimage_Circle | null, exclaim?: Enum_Componentcommoncomponentsdecoratedtextimage_Exclaim | null, highlight?: Enum_Componentcommoncomponentsdecoratedtextimage_Highlight | null, underline?: Enum_Componentcommoncomponentsdecoratedtextimage_Underline | null, isCircleDarkMode?: boolean | null } | null, items: Array<{ __typename: 'ComponentCommonComponentsFaceItem', id: string, name: string, position: string, comment: string, image1: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null }, image2: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } } | null> } | { __typename: 'ComponentDynamicBlocksDynamicFaqBlock', id: string, header: string, decoratedTextImages?: { __typename: 'ComponentCommonComponentsDecoratedTextImage', id: string, circle?: Enum_Componentcommoncomponentsdecoratedtextimage_Circle | null, exclaim?: Enum_Componentcommoncomponentsdecoratedtextimage_Exclaim | null, highlight?: Enum_Componentcommoncomponentsdecoratedtextimage_Highlight | null, underline?: Enum_Componentcommoncomponentsdecoratedtextimage_Underline | null, isCircleDarkMode?: boolean | null } | null, items: Array<{ __typename?: 'ComponentCommonComponentsFaqItem', answer: string, question: string } | null> } | { __typename: 'ComponentDynamicBlocksDynamicFeatureListBlock', id: string, cta: string, largeImage: boolean, displayDigits: boolean, imagePosition: Enum_Componentdynamicblocksdynamicfeaturelistblock_Imageposition, buttonLabel?: string | null, buttonLink?: string | null, ctaImage: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null }, ctaImageMobile?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } | null, items: Array<{ __typename?: 'ComponentCommonComponentsFeatureWithDoodle', id: string, text: string, paragraph?: string | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } | null } | null> } | { __typename: 'ComponentDynamicBlocksDynamicGallerySection', id: string, topText?: string | null, middleText?: string | null, bottomText?: string | null } | { __typename: 'ComponentDynamicBlocksDynamicHeroBlock', id: string, title: string, description?: string | null, buttonCaption?: string | null, buttonLink?: string | null, decoratedTextImages?: { __typename: 'ComponentCommonComponentsDecoratedTextImage', id: string, circle?: Enum_Componentcommoncomponentsdecoratedtextimage_Circle | null, exclaim?: Enum_Componentcommoncomponentsdecoratedtextimage_Exclaim | null, highlight?: Enum_Componentcommoncomponentsdecoratedtextimage_Highlight | null, underline?: Enum_Componentcommoncomponentsdecoratedtextimage_Underline | null, isCircleDarkMode?: boolean | null } | null } | { __typename: 'ComponentDynamicBlocksDynamicHeroWithContactBlock', id: string, ctaTop: string, ctaBottom?: string | null, contactCardTitle: string, contactCardLabel: string, formNameLabel: string, formEmailLabel: string, formPhoneLabel: string, formCompanyLabel: string, formPrivacyPolicyLabel: string, formSubmitLabel: string, formPrivacyPolicyLink?: string | null, contactCardAdditionalLabelText?: string | null, thanksInPolish?: boolean | null, withDoodleInBackground?: boolean | null, hideMobileButton?: boolean | null, backgroundImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } | null, contactCardImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } | null } | { __typename: 'ComponentDynamicBlocksDynamicHistorySection', id: string, header: string, items: Array<{ __typename?: 'ComponentCommonComponentsHistory', id: string, year: string, name: string, description: string } | null> } | { __typename: 'ComponentDynamicBlocksDynamicInfoGridBlock', id: string, header: string, mode: Enum_Componentdynamicblocksdynamicinfogridblock_Mode, items: Array<{ __typename?: 'ComponentCommonComponentsGridListItem', heading: string, description: string, buttonLabel?: string | null, buttonLink?: string | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } | null } | null>, decoratedTextImages?: { __typename: 'ComponentCommonComponentsDecoratedTextImage', id: string, circle?: Enum_Componentcommoncomponentsdecoratedtextimage_Circle | null, exclaim?: Enum_Componentcommoncomponentsdecoratedtextimage_Exclaim | null, highlight?: Enum_Componentcommoncomponentsdecoratedtextimage_Highlight | null, underline?: Enum_Componentcommoncomponentsdecoratedtextimage_Underline | null, isCircleDarkMode?: boolean | null } | null } | { __typename: 'ComponentDynamicBlocksDynamicInfoWithPhotoBlock', id: string, header: string, message: string, buttonLink?: string | null, buttonCaption?: string | null, photo: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } } | { __typename: 'ComponentDynamicBlocksDynamicLeadership', id: string, header: string, leaders: { __typename?: 'LeadershipRelationResponseCollection', data: Array<{ __typename?: 'LeadershipEntity', attributes?: { __typename?: 'Leadership', name: string, position: string, url: string, avatar: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } } | null }> } } | { __typename: 'ComponentDynamicBlocksDynamicLogosBlock', id: string, header: string, logos: { __typename?: 'UploadFileRelationResponseCollection', data: Array<{ __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null }> } } | { __typename: 'ComponentDynamicBlocksDynamicMedia', id: string, items: Array<{ __typename: 'ComponentCommonComponentsMediaItem', id: string, name: string, coverVideo: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null }, coverImageFallback: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } } | null> } | { __typename: 'ComponentDynamicBlocksDynamicPartners', id: string, header: string, partners: { __typename?: 'PartnerRelationResponseCollection', data: Array<{ __typename?: 'PartnerEntity', id?: string | null, attributes?: { __typename?: 'Partner', content: string, name: string, clientLogo: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null }, partnerTags?: { __typename?: 'PartnerTagRelationResponseCollection', data: Array<{ __typename?: 'PartnerTagEntity', id?: string | null, attributes?: { __typename?: 'PartnerTag', name: string } | null }> } | null } | null }> } } | { __typename: 'ComponentDynamicBlocksDynamicPointsWithPhotosBlock', id: string, header: string, elements: Array<{ __typename?: 'ComponentCommonComponentsPointWithPhoto', id: string, text: string, photo: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } } | null> } | { __typename: 'ComponentDynamicBlocksDynamicRichTextBlock', id: string, text: { __typename: 'ComponentCommonComponentsCkEditor', id: string, richText: string } } | { __typename: 'ComponentDynamicBlocksDynamicScrollSlider', id: string, badgeText: string, badgeImage: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null }, items: Array<{ __typename?: 'ComponentCommonComponentsSliderItem', imageAlt: string, url: string, slideImage: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } } | null> } | { __typename: 'ComponentDynamicBlocksDynamicSeeMoreBlock', id: string, header: string, buttonLabel?: string | null, buttonLink?: string | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } | null } | { __typename: 'ComponentDynamicBlocksDynamicSliderPointsBlock', id: string, header: string, subheader: string, items: Array<{ __typename?: 'ComponentCommonComponentsSliderPointsItem', header: string, paragraphOneTitle: string, paragraphTwoTitle?: string | null, paragraphThreeTitle?: string | null, paragraphOneDescription: string, paragraphTwoDescription?: string | null, paragraphThreeDescription?: string | null, buttonLabel?: string | null, buttonLink?: string | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } | null } | null> } | { __typename: 'ComponentDynamicBlocksDynamicStatistics', id: string, underlinedValues?: boolean | null, darkBackground?: boolean | null, statHeader?: string | null, statistics: Array<{ __typename?: 'ComponentAboutUsStatistics', value: string, description: string, descriptionAdd?: string | null } | null> } | { __typename: 'ComponentDynamicBlocksDynamicTeamInvolved', id: string, header: string, subheader: string, items: Array<{ __typename?: 'ComponentCommonComponentsImageWithCaption', id: string, caption: string, image1: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', width?: number | null, height?: number | null, url: string } | null } | null } } | null> } | { __typename: 'ComponentDynamicBlocksDynamicTeamInvolvedWithHover', id: string, header: string, items: Array<{ __typename?: 'ComponentCommonComponentsHoverImageWithCaption', imageCaptionFirstLine: string, imageCaptionSecondLine?: string | null, comment: string, hoverImage: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null }, afterImage: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } } | null> } | { __typename: 'ComponentDynamicBlocksDynamicTestimonialBlock', id: string, quote: string, person: string, position: string, decoratedTextImages?: { __typename: 'ComponentCommonComponentsDecoratedTextImage', id: string, circle?: Enum_Componentcommoncomponentsdecoratedtextimage_Circle | null, exclaim?: Enum_Componentcommoncomponentsdecoratedtextimage_Exclaim | null, highlight?: Enum_Componentcommoncomponentsdecoratedtextimage_Highlight | null, underline?: Enum_Componentcommoncomponentsdecoratedtextimage_Underline | null, isCircleDarkMode?: boolean | null } | null, photo: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } } | { __typename: 'ComponentDynamicBlocksDynamicTextWithPhotos', id: string, headerStartText?: string | null, headerMiddleText?: string | null, headerEndText?: string | null, desc?: string | null, button?: { __typename?: 'ComponentCommonComponentsButton', label: string, url: string, variant: Enum_Componentcommoncomponentsbutton_Variant } | null, firstAvatar?: { __typename?: 'ComponentCommonComponentsHoverAvatar', id: string, hoverText: string, name?: string | null, role?: string | null, image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } } | null, secondAvatar?: { __typename?: 'ComponentCommonComponentsHoverAvatar', id: string, hoverText: string, name?: string | null, role?: string | null, image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } } | null } | { __typename: 'ComponentDynamicBlocksDynamicVideoBanner', id: string, header: string, buttonLabel?: string | null, buttonLink?: string | null, coverImageFallback: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null }, coverVideoUrl: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null }, decoratedTextImages?: { __typename: 'ComponentCommonComponentsDecoratedTextImage', id: string, circle?: Enum_Componentcommoncomponentsdecoratedtextimage_Circle | null, exclaim?: Enum_Componentcommoncomponentsdecoratedtextimage_Exclaim | null, highlight?: Enum_Componentcommoncomponentsdecoratedtextimage_Highlight | null, underline?: Enum_Componentcommoncomponentsdecoratedtextimage_Underline | null, isCircleDarkMode?: boolean | null } | null } | { __typename: 'ComponentDynamicBlocksHowWeWork', id: string, heading: string, howWeWorkItem: Array<{ __typename?: 'ComponentCommonComponentsItems', id: string, text: string, image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } } | null> } | { __typename: 'ComponentDynamicBlocksLetsBuildBlock', id: string, ctaText: string } | { __typename: 'ComponentDynamicBlocksNewsletterBlock', id: string, info: string, emailPlaceholder: string, marketingText: string, marketingPrivacyLinkLabel: string, subscribe: string, successLabel: string } | { __typename: 'ComponentDynamicBlocksRecommendedArticles', id: string, header: string, decoratedTextImages?: { __typename: 'ComponentCommonComponentsDecoratedTextImage', id: string, circle?: Enum_Componentcommoncomponentsdecoratedtextimage_Circle | null, exclaim?: Enum_Componentcommoncomponentsdecoratedtextimage_Exclaim | null, highlight?: Enum_Componentcommoncomponentsdecoratedtextimage_Highlight | null, underline?: Enum_Componentcommoncomponentsdecoratedtextimage_Underline | null, isCircleDarkMode?: boolean | null } | null, tags: { __typename?: 'ArticleTagRelationResponseCollection', data: Array<{ __typename?: 'ArticleTagEntity', id?: string | null, attributes?: { __typename?: 'ArticleTag', name: string } | null }> } } | { __typename: 'ComponentDynamicBlocksStandaloneContactForm', id: string, contactCardTitle: string, contactCardLabel: string, formNameLabel: string, formEmailLabel: string, formPhoneLabel: string, formCompanyLabel: string, formPrivacyPolicyLabel: string, formSubmitLabel: string, formPrivacyPolicyLink?: string | null, contactCardAdditionalLabelText?: string | null, thanksInPolish?: boolean | null, contactCardImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } | null } | { __typename?: 'Error' } | null>, image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null }, caseStudyCategory?: { __typename?: 'CaseStudyCategoryEntityResponse', data?: { __typename?: 'CaseStudyCategoryEntity', id?: string | null, attributes?: { __typename?: 'CaseStudyCategory', name: string } | null } | null } | null, caseStudyTags?: { __typename?: 'CaseStudyTagRelationResponseCollection', data: Array<{ __typename?: 'CaseStudyTagEntity', id?: string | null, attributes?: { __typename?: 'CaseStudyTag', name: string } | null }> } | null } | null }> } | null };

export type GetDynamicPageBySlugQueryVariables = Exact<{
  slug: Scalars['String']['input'];
  publicationState: PublicationState;
  locale: Scalars['I18NLocaleCode']['input'];
}>;


export type GetDynamicPageBySlugQuery = { __typename?: 'Query', pages?: { __typename?: 'PageEntityResponseCollection', data: Array<{ __typename?: 'PageEntity', id?: string | null, attributes?: { __typename?: 'Page', showHeader: boolean, showFooter: boolean, metadata: { __typename?: 'ComponentMetaMetadata', metaTitle: string, metaDescription: string, ogImage: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } }, breadcrumbs: { __typename?: 'ComponentCommonComponentsBreadcrumbs', position: Enum_Componentcommoncomponentsbreadcrumbs_Position, modeColor: Enum_Componentcommoncomponentsbreadcrumbs_Modecolor }, blocks: Array<{ __typename: 'ComponentDynamicBlocksBannerSection', id: string, bannerTitle: string, bannerDesc: string } | { __typename: 'ComponentDynamicBlocksCaseStudiesShowcase', id: string, title: string, subtitle: string, buttonText: string, caseStudySlugs: Array<{ __typename?: 'ComponentCommonComponentsShowcaseCaseStudySlugs', id: string, caseStudySlug: string } | null> } | { __typename: 'ComponentDynamicBlocksDynamicCaseStudiesPreview', id: string, bigBoxHeader: string, bigBoxButtonLabel: string, bigBoxButtonLink: string, middleBoxCaption: string, rightBoxCaption: string, bigBoxBackgroundImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } | null, middleBoxBackgroundImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } | null, rightBoxBackgroundImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } | null } | { __typename: 'ComponentDynamicBlocksDynamicChartSection', id: string, header: string, items: Array<{ __typename?: 'ComponentCommonComponentsChartPoint', id: string, heading: string, list: Array<{ __typename?: 'ComponentCommonComponentsTextListItem', id: string, textListItem: string } | null> } | null> } | { __typename: 'ComponentDynamicBlocksDynamicClientOpinions', id: string, title: string, subtitle: string, opinions: { __typename?: 'ComponentHomeSectionsClientOpinions', id: string, opinions: Array<{ __typename?: 'ComponentHomeComponentsClientOpinionsCard', id: string, clientName: string, clientDescription: string, clientDescriptionSecondLine?: string | null, content: string, clientLogo: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null }, clientAvatar: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } } | null>, awardLogo: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } }, decoratedTextImages?: { __typename: 'ComponentCommonComponentsDecoratedTextImage', id: string, circle?: Enum_Componentcommoncomponentsdecoratedtextimage_Circle | null, exclaim?: Enum_Componentcommoncomponentsdecoratedtextimage_Exclaim | null, highlight?: Enum_Componentcommoncomponentsdecoratedtextimage_Highlight | null, underline?: Enum_Componentcommoncomponentsdecoratedtextimage_Underline | null, isCircleDarkMode?: boolean | null } | null } | { __typename: 'ComponentDynamicBlocksDynamicConstantBlock', id: string, name: Enum_Componentdynamicblocksdynamicconstantblock_Name } | { __typename: 'ComponentDynamicBlocksDynamicDarkInfoDividerBlock', id: string, header: string, description?: string | null, buttonLink?: string | null, buttonCaption?: string | null } | { __typename: 'ComponentDynamicBlocksDynamicDividerWithPhotosBlock', id: string, multipleImages: { __typename?: 'UploadFileRelationResponseCollection', data: Array<{ __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null }> } } | { __typename: 'ComponentDynamicBlocksDynamicFaces', id: string, header: string, decoratedTextImages?: { __typename: 'ComponentCommonComponentsDecoratedTextImage', id: string, circle?: Enum_Componentcommoncomponentsdecoratedtextimage_Circle | null, exclaim?: Enum_Componentcommoncomponentsdecoratedtextimage_Exclaim | null, highlight?: Enum_Componentcommoncomponentsdecoratedtextimage_Highlight | null, underline?: Enum_Componentcommoncomponentsdecoratedtextimage_Underline | null, isCircleDarkMode?: boolean | null } | null, items: Array<{ __typename: 'ComponentCommonComponentsFaceItem', id: string, name: string, position: string, comment: string, image1: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null }, image2: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } } | null> } | { __typename: 'ComponentDynamicBlocksDynamicFaqBlock', id: string, header: string, decoratedTextImages?: { __typename: 'ComponentCommonComponentsDecoratedTextImage', id: string, circle?: Enum_Componentcommoncomponentsdecoratedtextimage_Circle | null, exclaim?: Enum_Componentcommoncomponentsdecoratedtextimage_Exclaim | null, highlight?: Enum_Componentcommoncomponentsdecoratedtextimage_Highlight | null, underline?: Enum_Componentcommoncomponentsdecoratedtextimage_Underline | null, isCircleDarkMode?: boolean | null } | null, items: Array<{ __typename?: 'ComponentCommonComponentsFaqItem', answer: string, question: string } | null> } | { __typename: 'ComponentDynamicBlocksDynamicFeatureListBlock', id: string, cta: string, largeImage: boolean, displayDigits: boolean, imagePosition: Enum_Componentdynamicblocksdynamicfeaturelistblock_Imageposition, buttonLabel?: string | null, buttonLink?: string | null, ctaImage: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null }, ctaImageMobile?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } | null, items: Array<{ __typename?: 'ComponentCommonComponentsFeatureWithDoodle', id: string, text: string, paragraph?: string | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } | null } | null> } | { __typename: 'ComponentDynamicBlocksDynamicGallerySection', id: string, topText?: string | null, middleText?: string | null, bottomText?: string | null } | { __typename: 'ComponentDynamicBlocksDynamicHeroBlock', id: string, title: string, description?: string | null, buttonCaption?: string | null, buttonLink?: string | null, decoratedTextImages?: { __typename: 'ComponentCommonComponentsDecoratedTextImage', id: string, circle?: Enum_Componentcommoncomponentsdecoratedtextimage_Circle | null, exclaim?: Enum_Componentcommoncomponentsdecoratedtextimage_Exclaim | null, highlight?: Enum_Componentcommoncomponentsdecoratedtextimage_Highlight | null, underline?: Enum_Componentcommoncomponentsdecoratedtextimage_Underline | null, isCircleDarkMode?: boolean | null } | null } | { __typename: 'ComponentDynamicBlocksDynamicHeroWithContactBlock', id: string, ctaTop: string, ctaBottom?: string | null, contactCardTitle: string, contactCardLabel: string, formNameLabel: string, formEmailLabel: string, formPhoneLabel: string, formCompanyLabel: string, formPrivacyPolicyLabel: string, formSubmitLabel: string, formPrivacyPolicyLink?: string | null, contactCardAdditionalLabelText?: string | null, thanksInPolish?: boolean | null, withDoodleInBackground?: boolean | null, hideMobileButton?: boolean | null, backgroundImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } | null, contactCardImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } | null } | { __typename: 'ComponentDynamicBlocksDynamicHistorySection', id: string, header: string, items: Array<{ __typename?: 'ComponentCommonComponentsHistory', id: string, year: string, name: string, description: string } | null> } | { __typename: 'ComponentDynamicBlocksDynamicInfoGridBlock', id: string, header: string, mode: Enum_Componentdynamicblocksdynamicinfogridblock_Mode, items: Array<{ __typename?: 'ComponentCommonComponentsGridListItem', heading: string, description: string, buttonLabel?: string | null, buttonLink?: string | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } | null } | null>, decoratedTextImages?: { __typename: 'ComponentCommonComponentsDecoratedTextImage', id: string, circle?: Enum_Componentcommoncomponentsdecoratedtextimage_Circle | null, exclaim?: Enum_Componentcommoncomponentsdecoratedtextimage_Exclaim | null, highlight?: Enum_Componentcommoncomponentsdecoratedtextimage_Highlight | null, underline?: Enum_Componentcommoncomponentsdecoratedtextimage_Underline | null, isCircleDarkMode?: boolean | null } | null } | { __typename: 'ComponentDynamicBlocksDynamicInfoWithPhotoBlock', id: string, header: string, message: string, buttonLink?: string | null, buttonCaption?: string | null, photo: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } } | { __typename: 'ComponentDynamicBlocksDynamicLeadership', id: string, header: string, leaders: { __typename?: 'LeadershipRelationResponseCollection', data: Array<{ __typename?: 'LeadershipEntity', attributes?: { __typename?: 'Leadership', name: string, position: string, url: string, avatar: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } } | null }> } } | { __typename: 'ComponentDynamicBlocksDynamicLogosBlock', id: string, header: string, logos: { __typename?: 'UploadFileRelationResponseCollection', data: Array<{ __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null }> } } | { __typename: 'ComponentDynamicBlocksDynamicMedia', id: string, items: Array<{ __typename: 'ComponentCommonComponentsMediaItem', id: string, name: string, coverVideo: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null }, coverImageFallback: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } } | null> } | { __typename: 'ComponentDynamicBlocksDynamicPartners', id: string, header: string, partners: { __typename?: 'PartnerRelationResponseCollection', data: Array<{ __typename?: 'PartnerEntity', id?: string | null, attributes?: { __typename?: 'Partner', content: string, name: string, clientLogo: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null }, partnerTags?: { __typename?: 'PartnerTagRelationResponseCollection', data: Array<{ __typename?: 'PartnerTagEntity', id?: string | null, attributes?: { __typename?: 'PartnerTag', name: string } | null }> } | null } | null }> } } | { __typename: 'ComponentDynamicBlocksDynamicPointsWithPhotosBlock', id: string, header: string, elements: Array<{ __typename?: 'ComponentCommonComponentsPointWithPhoto', id: string, text: string, photo: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } } | null> } | { __typename: 'ComponentDynamicBlocksDynamicRichTextBlock', id: string, text: { __typename: 'ComponentCommonComponentsCkEditor', id: string, richText: string } } | { __typename: 'ComponentDynamicBlocksDynamicScrollSlider', id: string, badgeText: string, badgeImage: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null }, items: Array<{ __typename?: 'ComponentCommonComponentsSliderItem', imageAlt: string, url: string, slideImage: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } } | null> } | { __typename: 'ComponentDynamicBlocksDynamicSeeMoreBlock', id: string, header: string, buttonLabel?: string | null, buttonLink?: string | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } | null } | { __typename: 'ComponentDynamicBlocksDynamicSliderPointsBlock', id: string, header: string, subheader: string, items: Array<{ __typename?: 'ComponentCommonComponentsSliderPointsItem', header: string, paragraphOneTitle: string, paragraphTwoTitle?: string | null, paragraphThreeTitle?: string | null, paragraphOneDescription: string, paragraphTwoDescription?: string | null, paragraphThreeDescription?: string | null, buttonLabel?: string | null, buttonLink?: string | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } | null } | null> } | { __typename: 'ComponentDynamicBlocksDynamicStatistics', id: string, underlinedValues?: boolean | null, darkBackground?: boolean | null, statHeader?: string | null, statistics: Array<{ __typename?: 'ComponentAboutUsStatistics', value: string, description: string, descriptionAdd?: string | null } | null> } | { __typename: 'ComponentDynamicBlocksDynamicTeamInvolved', id: string, header: string, subheader: string, items: Array<{ __typename?: 'ComponentCommonComponentsImageWithCaption', id: string, caption: string, image1: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', width?: number | null, height?: number | null, url: string } | null } | null } } | null> } | { __typename: 'ComponentDynamicBlocksDynamicTeamInvolvedWithHover', id: string, header: string, items: Array<{ __typename?: 'ComponentCommonComponentsHoverImageWithCaption', imageCaptionFirstLine: string, imageCaptionSecondLine?: string | null, comment: string, hoverImage: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null }, afterImage: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } } | null> } | { __typename: 'ComponentDynamicBlocksDynamicTestimonialBlock', id: string, quote: string, person: string, position: string, decoratedTextImages?: { __typename: 'ComponentCommonComponentsDecoratedTextImage', id: string, circle?: Enum_Componentcommoncomponentsdecoratedtextimage_Circle | null, exclaim?: Enum_Componentcommoncomponentsdecoratedtextimage_Exclaim | null, highlight?: Enum_Componentcommoncomponentsdecoratedtextimage_Highlight | null, underline?: Enum_Componentcommoncomponentsdecoratedtextimage_Underline | null, isCircleDarkMode?: boolean | null } | null, photo: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } } | { __typename: 'ComponentDynamicBlocksDynamicTextWithPhotos', id: string, headerStartText?: string | null, headerMiddleText?: string | null, headerEndText?: string | null, desc?: string | null, button?: { __typename?: 'ComponentCommonComponentsButton', label: string, url: string, variant: Enum_Componentcommoncomponentsbutton_Variant } | null, firstAvatar?: { __typename?: 'ComponentCommonComponentsHoverAvatar', id: string, hoverText: string, name?: string | null, role?: string | null, image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } } | null, secondAvatar?: { __typename?: 'ComponentCommonComponentsHoverAvatar', id: string, hoverText: string, name?: string | null, role?: string | null, image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } } | null } | { __typename: 'ComponentDynamicBlocksDynamicVideoBanner', id: string, header: string, buttonLabel?: string | null, buttonLink?: string | null, coverImageFallback: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null }, coverVideoUrl: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null }, decoratedTextImages?: { __typename: 'ComponentCommonComponentsDecoratedTextImage', id: string, circle?: Enum_Componentcommoncomponentsdecoratedtextimage_Circle | null, exclaim?: Enum_Componentcommoncomponentsdecoratedtextimage_Exclaim | null, highlight?: Enum_Componentcommoncomponentsdecoratedtextimage_Highlight | null, underline?: Enum_Componentcommoncomponentsdecoratedtextimage_Underline | null, isCircleDarkMode?: boolean | null } | null } | { __typename: 'ComponentDynamicBlocksHowWeWork', id: string, heading: string, howWeWorkItem: Array<{ __typename?: 'ComponentCommonComponentsItems', id: string, text: string, image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } } | null> } | { __typename: 'ComponentDynamicBlocksLetsBuildBlock', id: string, ctaText: string } | { __typename: 'ComponentDynamicBlocksNewsletterBlock', id: string, info: string, emailPlaceholder: string, marketingText: string, marketingPrivacyLinkLabel: string, subscribe: string, successLabel: string } | { __typename: 'ComponentDynamicBlocksRecommendedArticles', id: string, header: string, decoratedTextImages?: { __typename: 'ComponentCommonComponentsDecoratedTextImage', id: string, circle?: Enum_Componentcommoncomponentsdecoratedtextimage_Circle | null, exclaim?: Enum_Componentcommoncomponentsdecoratedtextimage_Exclaim | null, highlight?: Enum_Componentcommoncomponentsdecoratedtextimage_Highlight | null, underline?: Enum_Componentcommoncomponentsdecoratedtextimage_Underline | null, isCircleDarkMode?: boolean | null } | null, tags: { __typename?: 'ArticleTagRelationResponseCollection', data: Array<{ __typename?: 'ArticleTagEntity', id?: string | null, attributes?: { __typename?: 'ArticleTag', name: string } | null }> } } | { __typename: 'ComponentDynamicBlocksStandaloneContactForm', id: string, contactCardTitle: string, contactCardLabel: string, formNameLabel: string, formEmailLabel: string, formPhoneLabel: string, formCompanyLabel: string, formPrivacyPolicyLabel: string, formSubmitLabel: string, formPrivacyPolicyLink?: string | null, contactCardAdditionalLabelText?: string | null, thanksInPolish?: boolean | null, contactCardImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } | null } | { __typename?: 'Error' } | null> } | null }> } | null };

export type GetGlobalQueryVariables = Exact<{
  locale: Scalars['I18NLocaleCode']['input'];
}>;


export type GetGlobalQuery = { __typename?: 'Query', global?: { __typename?: 'GlobalEntityResponse', data?: { __typename?: 'GlobalEntity', id?: string | null, attributes?: { __typename?: 'Global', metadata: { __typename?: 'ComponentMetaMetadata', metaTitle: string, metaDescription: string, ogImage: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } } } | null } | null } | null };

export type ClutchReviewFragment = { __typename?: 'ComponentCommonComponentsClutchReviewCard', content: string, reviewerName: string, reviewerDescription: string, rating: number, reviewerAvatar: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } };

export type CompanyStatisticsCardFragment = { __typename?: 'ComponentHomeComponentsCompanyStatisticsCard', value: string, label: string, showBadge: boolean };

export type ChatBubbleFragment = { __typename?: 'ComponentHomeComponentsLetsMeetChatBubble', memberMessage: string, memberName: string, memberRole: string };

export type LetsMeetTeamMemberFragment = { __typename?: 'ComponentHomeComponentsLetsMeetTeamMember', doodle: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null }, avatar: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null }, chatBubble: { __typename?: 'ComponentHomeComponentsLetsMeetChatBubble', memberMessage: string, memberName: string, memberRole: string } };

export type ClutchScoreFragment = { __typename?: 'ComponentHomeSectionsClutchScore', firstReview: { __typename?: 'ComponentCommonComponentsClutchReviewCard', content: string, reviewerName: string, reviewerDescription: string, rating: number, reviewerAvatar: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } }, secondReview: { __typename?: 'ComponentCommonComponentsClutchReviewCard', content: string, reviewerName: string, reviewerDescription: string, rating: number, reviewerAvatar: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } }, thirdReview: { __typename?: 'ComponentCommonComponentsClutchReviewCard', content: string, reviewerName: string, reviewerDescription: string, rating: number, reviewerAvatar: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } } };

export type CompanyStatisticsFragment = { __typename?: 'ComponentHomeSectionsCompanyStatistics', cakeDoodle: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null }, companyStatisticsCard: Array<{ __typename?: 'ComponentHomeComponentsCompanyStatisticsCard', value: string, label: string, showBadge: boolean } | null> };

export type LetsMeetFragment = { __typename?: 'ComponentHomeSectionsLetsMeet', teamMemberOne: { __typename?: 'ComponentHomeComponentsLetsMeetTeamMember', doodle: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null }, avatar: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null }, chatBubble: { __typename?: 'ComponentHomeComponentsLetsMeetChatBubble', memberMessage: string, memberName: string, memberRole: string } }, teamMemberTwo: { __typename?: 'ComponentHomeComponentsLetsMeetTeamMember', doodle: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null }, avatar: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null }, chatBubble: { __typename?: 'ComponentHomeComponentsLetsMeetChatBubble', memberMessage: string, memberName: string, memberRole: string } }, teamMemberThree: { __typename?: 'ComponentHomeComponentsLetsMeetTeamMember', doodle: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null }, avatar: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null }, chatBubble: { __typename?: 'ComponentHomeComponentsLetsMeetChatBubble', memberMessage: string, memberName: string, memberRole: string } }, teamMemberFour: { __typename?: 'ComponentHomeComponentsLetsMeetTeamMember', doodle: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null }, avatar: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null }, chatBubble: { __typename?: 'ComponentHomeComponentsLetsMeetChatBubble', memberMessage: string, memberName: string, memberRole: string } }, teamMemberFive: { __typename?: 'ComponentHomeComponentsLetsMeetTeamMember', doodle: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null }, avatar: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null }, chatBubble: { __typename?: 'ComponentHomeComponentsLetsMeetChatBubble', memberMessage: string, memberName: string, memberRole: string } } };

export type TechStackFragment = { __typename?: 'ComponentHomeSectionsTechStack', row: Array<{ __typename?: 'ComponentHomeComponentsTechStackRow', pill: Array<{ __typename?: 'ComponentCommonComponentsImageWithCaption', caption: string, image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } } | null> } | null> };

export type CaseStudiesFragment = { __typename?: 'ComponentHomeSectionsCaseStudies', caseStudies?: { __typename?: 'CaseStudyRelationResponseCollection', data: Array<{ __typename?: 'CaseStudyEntity', id?: string | null, attributes?: { __typename?: 'CaseStudy', slug: string, doodleText?: string | null, title: string, description: string, position: number, image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null }, caseStudyCategory?: { __typename?: 'CaseStudyCategoryEntityResponse', data?: { __typename?: 'CaseStudyCategoryEntity', id?: string | null, attributes?: { __typename?: 'CaseStudyCategory', name: string } | null } | null } | null, caseStudyTags?: { __typename?: 'CaseStudyTagRelationResponseCollection', data: Array<{ __typename?: 'CaseStudyTagEntity', id?: string | null, attributes?: { __typename?: 'CaseStudyTag', name: string } | null }> } | null } | null }> } | null };

export type GetHomeQueryVariables = Exact<{
  locale: Scalars['I18NLocaleCode']['input'];
}>;


export type GetHomeQuery = { __typename?: 'Query', home?: { __typename?: 'HomeEntityResponse', data?: { __typename?: 'HomeEntity', attributes?: { __typename?: 'Home', metadata: { __typename?: 'ComponentMetaMetadata', metaTitle: string, metaDescription: string, ogImage: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } }, clutchScore: { __typename?: 'ComponentHomeSectionsClutchScore', firstReview: { __typename?: 'ComponentCommonComponentsClutchReviewCard', content: string, reviewerName: string, reviewerDescription: string, rating: number, reviewerAvatar: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } }, secondReview: { __typename?: 'ComponentCommonComponentsClutchReviewCard', content: string, reviewerName: string, reviewerDescription: string, rating: number, reviewerAvatar: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } }, thirdReview: { __typename?: 'ComponentCommonComponentsClutchReviewCard', content: string, reviewerName: string, reviewerDescription: string, rating: number, reviewerAvatar: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } } }, companyStatistics: { __typename?: 'ComponentHomeSectionsCompanyStatistics', cakeDoodle: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null }, companyStatisticsCard: Array<{ __typename?: 'ComponentHomeComponentsCompanyStatisticsCard', value: string, label: string, showBadge: boolean } | null> }, letsMeet: { __typename?: 'ComponentHomeSectionsLetsMeet', teamMemberOne: { __typename?: 'ComponentHomeComponentsLetsMeetTeamMember', doodle: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null }, avatar: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null }, chatBubble: { __typename?: 'ComponentHomeComponentsLetsMeetChatBubble', memberMessage: string, memberName: string, memberRole: string } }, teamMemberTwo: { __typename?: 'ComponentHomeComponentsLetsMeetTeamMember', doodle: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null }, avatar: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null }, chatBubble: { __typename?: 'ComponentHomeComponentsLetsMeetChatBubble', memberMessage: string, memberName: string, memberRole: string } }, teamMemberThree: { __typename?: 'ComponentHomeComponentsLetsMeetTeamMember', doodle: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null }, avatar: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null }, chatBubble: { __typename?: 'ComponentHomeComponentsLetsMeetChatBubble', memberMessage: string, memberName: string, memberRole: string } }, teamMemberFour: { __typename?: 'ComponentHomeComponentsLetsMeetTeamMember', doodle: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null }, avatar: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null }, chatBubble: { __typename?: 'ComponentHomeComponentsLetsMeetChatBubble', memberMessage: string, memberName: string, memberRole: string } }, teamMemberFive: { __typename?: 'ComponentHomeComponentsLetsMeetTeamMember', doodle: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null }, avatar: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null }, chatBubble: { __typename?: 'ComponentHomeComponentsLetsMeetChatBubble', memberMessage: string, memberName: string, memberRole: string } } }, techStack: { __typename?: 'ComponentHomeSectionsTechStack', row: Array<{ __typename?: 'ComponentHomeComponentsTechStackRow', pill: Array<{ __typename?: 'ComponentCommonComponentsImageWithCaption', caption: string, image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } } | null> } | null> }, caseStudies: { __typename?: 'ComponentHomeSectionsCaseStudies', caseStudies?: { __typename?: 'CaseStudyRelationResponseCollection', data: Array<{ __typename?: 'CaseStudyEntity', id?: string | null, attributes?: { __typename?: 'CaseStudy', slug: string, doodleText?: string | null, title: string, description: string, position: number, image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null }, caseStudyCategory?: { __typename?: 'CaseStudyCategoryEntityResponse', data?: { __typename?: 'CaseStudyCategoryEntity', id?: string | null, attributes?: { __typename?: 'CaseStudyCategory', name: string } | null } | null } | null, caseStudyTags?: { __typename?: 'CaseStudyTagRelationResponseCollection', data: Array<{ __typename?: 'CaseStudyTagEntity', id?: string | null, attributes?: { __typename?: 'CaseStudyTag', name: string } | null }> } | null } | null }> } | null }, partners?: { __typename?: 'PartnerRelationResponseCollection', data: Array<{ __typename?: 'PartnerEntity', attributes?: { __typename?: 'Partner', content: string, clientLogo: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null }, partnerTags?: { __typename?: 'PartnerTagRelationResponseCollection', data: Array<{ __typename?: 'PartnerTagEntity', id?: string | null, attributes?: { __typename?: 'PartnerTag', name: string } | null }> } | null } | null }> } | null, blocks: Array<{ __typename: 'ComponentDynamicBlocksBannerSection', id: string, bannerTitle: string, bannerDesc: string } | { __typename: 'ComponentDynamicBlocksCaseStudiesShowcase', id: string, title: string, subtitle: string, buttonText: string, caseStudySlugs: Array<{ __typename?: 'ComponentCommonComponentsShowcaseCaseStudySlugs', id: string, caseStudySlug: string } | null> } | { __typename: 'ComponentDynamicBlocksDynamicCaseStudiesPreview', id: string, bigBoxHeader: string, bigBoxButtonLabel: string, bigBoxButtonLink: string, middleBoxCaption: string, rightBoxCaption: string, bigBoxBackgroundImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } | null, middleBoxBackgroundImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } | null, rightBoxBackgroundImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } | null } | { __typename: 'ComponentDynamicBlocksDynamicChartSection', id: string, header: string, items: Array<{ __typename?: 'ComponentCommonComponentsChartPoint', id: string, heading: string, list: Array<{ __typename?: 'ComponentCommonComponentsTextListItem', id: string, textListItem: string } | null> } | null> } | { __typename: 'ComponentDynamicBlocksDynamicClientOpinions', id: string, title: string, subtitle: string, opinions: { __typename?: 'ComponentHomeSectionsClientOpinions', id: string, opinions: Array<{ __typename?: 'ComponentHomeComponentsClientOpinionsCard', id: string, clientName: string, clientDescription: string, clientDescriptionSecondLine?: string | null, content: string, clientLogo: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null }, clientAvatar: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } } | null>, awardLogo: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } }, decoratedTextImages?: { __typename: 'ComponentCommonComponentsDecoratedTextImage', id: string, circle?: Enum_Componentcommoncomponentsdecoratedtextimage_Circle | null, exclaim?: Enum_Componentcommoncomponentsdecoratedtextimage_Exclaim | null, highlight?: Enum_Componentcommoncomponentsdecoratedtextimage_Highlight | null, underline?: Enum_Componentcommoncomponentsdecoratedtextimage_Underline | null, isCircleDarkMode?: boolean | null } | null } | { __typename: 'ComponentDynamicBlocksDynamicConstantBlock', id: string, name: Enum_Componentdynamicblocksdynamicconstantblock_Name } | { __typename: 'ComponentDynamicBlocksDynamicDarkInfoDividerBlock', id: string, header: string, description?: string | null, buttonLink?: string | null, buttonCaption?: string | null } | { __typename: 'ComponentDynamicBlocksDynamicDividerWithPhotosBlock', id: string, multipleImages: { __typename?: 'UploadFileRelationResponseCollection', data: Array<{ __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null }> } } | { __typename: 'ComponentDynamicBlocksDynamicFaces', id: string, header: string, decoratedTextImages?: { __typename: 'ComponentCommonComponentsDecoratedTextImage', id: string, circle?: Enum_Componentcommoncomponentsdecoratedtextimage_Circle | null, exclaim?: Enum_Componentcommoncomponentsdecoratedtextimage_Exclaim | null, highlight?: Enum_Componentcommoncomponentsdecoratedtextimage_Highlight | null, underline?: Enum_Componentcommoncomponentsdecoratedtextimage_Underline | null, isCircleDarkMode?: boolean | null } | null, items: Array<{ __typename: 'ComponentCommonComponentsFaceItem', id: string, name: string, position: string, comment: string, image1: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null }, image2: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } } | null> } | { __typename: 'ComponentDynamicBlocksDynamicFaqBlock', id: string, header: string, decoratedTextImages?: { __typename: 'ComponentCommonComponentsDecoratedTextImage', id: string, circle?: Enum_Componentcommoncomponentsdecoratedtextimage_Circle | null, exclaim?: Enum_Componentcommoncomponentsdecoratedtextimage_Exclaim | null, highlight?: Enum_Componentcommoncomponentsdecoratedtextimage_Highlight | null, underline?: Enum_Componentcommoncomponentsdecoratedtextimage_Underline | null, isCircleDarkMode?: boolean | null } | null, items: Array<{ __typename?: 'ComponentCommonComponentsFaqItem', answer: string, question: string } | null> } | { __typename: 'ComponentDynamicBlocksDynamicFeatureListBlock', id: string, cta: string, largeImage: boolean, displayDigits: boolean, imagePosition: Enum_Componentdynamicblocksdynamicfeaturelistblock_Imageposition, buttonLabel?: string | null, buttonLink?: string | null, ctaImage: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null }, ctaImageMobile?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } | null, items: Array<{ __typename?: 'ComponentCommonComponentsFeatureWithDoodle', id: string, text: string, paragraph?: string | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } | null } | null> } | { __typename: 'ComponentDynamicBlocksDynamicGallerySection', id: string, topText?: string | null, middleText?: string | null, bottomText?: string | null } | { __typename: 'ComponentDynamicBlocksDynamicHeroBlock', id: string, title: string, description?: string | null, buttonCaption?: string | null, buttonLink?: string | null, decoratedTextImages?: { __typename: 'ComponentCommonComponentsDecoratedTextImage', id: string, circle?: Enum_Componentcommoncomponentsdecoratedtextimage_Circle | null, exclaim?: Enum_Componentcommoncomponentsdecoratedtextimage_Exclaim | null, highlight?: Enum_Componentcommoncomponentsdecoratedtextimage_Highlight | null, underline?: Enum_Componentcommoncomponentsdecoratedtextimage_Underline | null, isCircleDarkMode?: boolean | null } | null } | { __typename?: 'ComponentDynamicBlocksDynamicHeroDescription' } | { __typename: 'ComponentDynamicBlocksDynamicHeroWithContactBlock', id: string, ctaTop: string, ctaBottom?: string | null, contactCardTitle: string, contactCardLabel: string, formNameLabel: string, formEmailLabel: string, formPhoneLabel: string, formCompanyLabel: string, formPrivacyPolicyLabel: string, formSubmitLabel: string, formPrivacyPolicyLink?: string | null, contactCardAdditionalLabelText?: string | null, thanksInPolish?: boolean | null, withDoodleInBackground?: boolean | null, hideMobileButton?: boolean | null, backgroundImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } | null, contactCardImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } | null } | { __typename: 'ComponentDynamicBlocksDynamicHistorySection', id: string, header: string, items: Array<{ __typename?: 'ComponentCommonComponentsHistory', id: string, year: string, name: string, description: string } | null> } | { __typename: 'ComponentDynamicBlocksDynamicInfoGridBlock', id: string, header: string, mode: Enum_Componentdynamicblocksdynamicinfogridblock_Mode, items: Array<{ __typename?: 'ComponentCommonComponentsGridListItem', heading: string, description: string, buttonLabel?: string | null, buttonLink?: string | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } | null } | null>, decoratedTextImages?: { __typename: 'ComponentCommonComponentsDecoratedTextImage', id: string, circle?: Enum_Componentcommoncomponentsdecoratedtextimage_Circle | null, exclaim?: Enum_Componentcommoncomponentsdecoratedtextimage_Exclaim | null, highlight?: Enum_Componentcommoncomponentsdecoratedtextimage_Highlight | null, underline?: Enum_Componentcommoncomponentsdecoratedtextimage_Underline | null, isCircleDarkMode?: boolean | null } | null } | { __typename: 'ComponentDynamicBlocksDynamicInfoWithPhotoBlock', id: string, header: string, message: string, buttonLink?: string | null, buttonCaption?: string | null, photo: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } } | { __typename: 'ComponentDynamicBlocksDynamicLeadership', id: string, header: string, leaders: { __typename?: 'LeadershipRelationResponseCollection', data: Array<{ __typename?: 'LeadershipEntity', attributes?: { __typename?: 'Leadership', name: string, position: string, url: string, avatar: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } } | null }> } } | { __typename: 'ComponentDynamicBlocksDynamicLogosBlock', id: string, header: string, logos: { __typename?: 'UploadFileRelationResponseCollection', data: Array<{ __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null }> } } | { __typename: 'ComponentDynamicBlocksDynamicMedia', id: string, items: Array<{ __typename: 'ComponentCommonComponentsMediaItem', id: string, name: string, coverVideo: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null }, coverImageFallback: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } } | null> } | { __typename: 'ComponentDynamicBlocksDynamicPartners', id: string, header: string, partners: { __typename?: 'PartnerRelationResponseCollection', data: Array<{ __typename?: 'PartnerEntity', id?: string | null, attributes?: { __typename?: 'Partner', content: string, name: string, clientLogo: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null }, partnerTags?: { __typename?: 'PartnerTagRelationResponseCollection', data: Array<{ __typename?: 'PartnerTagEntity', id?: string | null, attributes?: { __typename?: 'PartnerTag', name: string } | null }> } | null } | null }> } } | { __typename: 'ComponentDynamicBlocksDynamicPointsWithPhotosBlock', id: string, header: string, elements: Array<{ __typename?: 'ComponentCommonComponentsPointWithPhoto', id: string, text: string, photo: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } } | null> } | { __typename: 'ComponentDynamicBlocksDynamicRichTextBlock', id: string, text: { __typename: 'ComponentCommonComponentsCkEditor', id: string, richText: string } } | { __typename: 'ComponentDynamicBlocksDynamicScrollSlider', id: string, badgeText: string, badgeImage: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null }, items: Array<{ __typename?: 'ComponentCommonComponentsSliderItem', imageAlt: string, url: string, slideImage: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } } | null> } | { __typename: 'ComponentDynamicBlocksDynamicSeeMoreBlock', id: string, header: string, buttonLabel?: string | null, buttonLink?: string | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } | null } | { __typename: 'ComponentDynamicBlocksDynamicSliderPointsBlock', id: string, header: string, subheader: string, items: Array<{ __typename?: 'ComponentCommonComponentsSliderPointsItem', header: string, paragraphOneTitle: string, paragraphTwoTitle?: string | null, paragraphThreeTitle?: string | null, paragraphOneDescription: string, paragraphTwoDescription?: string | null, paragraphThreeDescription?: string | null, buttonLabel?: string | null, buttonLink?: string | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } | null } | null> } | { __typename: 'ComponentDynamicBlocksDynamicStatistics', id: string, underlinedValues?: boolean | null, darkBackground?: boolean | null, statHeader?: string | null, statistics: Array<{ __typename?: 'ComponentAboutUsStatistics', value: string, description: string, descriptionAdd?: string | null } | null> } | { __typename: 'ComponentDynamicBlocksDynamicTeamInvolved', id: string, header: string, subheader: string, items: Array<{ __typename?: 'ComponentCommonComponentsImageWithCaption', id: string, caption: string, image1: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', width?: number | null, height?: number | null, url: string } | null } | null } } | null> } | { __typename: 'ComponentDynamicBlocksDynamicTeamInvolvedWithHover', id: string, header: string, items: Array<{ __typename?: 'ComponentCommonComponentsHoverImageWithCaption', imageCaptionFirstLine: string, imageCaptionSecondLine?: string | null, comment: string, hoverImage: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null }, afterImage: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } } | null> } | { __typename: 'ComponentDynamicBlocksDynamicTestimonialBlock', id: string, quote: string, person: string, position: string, decoratedTextImages?: { __typename: 'ComponentCommonComponentsDecoratedTextImage', id: string, circle?: Enum_Componentcommoncomponentsdecoratedtextimage_Circle | null, exclaim?: Enum_Componentcommoncomponentsdecoratedtextimage_Exclaim | null, highlight?: Enum_Componentcommoncomponentsdecoratedtextimage_Highlight | null, underline?: Enum_Componentcommoncomponentsdecoratedtextimage_Underline | null, isCircleDarkMode?: boolean | null } | null, photo: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } } | { __typename: 'ComponentDynamicBlocksDynamicTextWithPhotos', id: string, headerStartText?: string | null, headerMiddleText?: string | null, headerEndText?: string | null, desc?: string | null, button?: { __typename?: 'ComponentCommonComponentsButton', label: string, url: string, variant: Enum_Componentcommoncomponentsbutton_Variant } | null, firstAvatar?: { __typename?: 'ComponentCommonComponentsHoverAvatar', id: string, hoverText: string, name?: string | null, role?: string | null, image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } } | null, secondAvatar?: { __typename?: 'ComponentCommonComponentsHoverAvatar', id: string, hoverText: string, name?: string | null, role?: string | null, image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } } | null } | { __typename: 'ComponentDynamicBlocksDynamicVideoBanner', id: string, header: string, buttonLabel?: string | null, buttonLink?: string | null, coverImageFallback: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null }, coverVideoUrl: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null }, decoratedTextImages?: { __typename: 'ComponentCommonComponentsDecoratedTextImage', id: string, circle?: Enum_Componentcommoncomponentsdecoratedtextimage_Circle | null, exclaim?: Enum_Componentcommoncomponentsdecoratedtextimage_Exclaim | null, highlight?: Enum_Componentcommoncomponentsdecoratedtextimage_Highlight | null, underline?: Enum_Componentcommoncomponentsdecoratedtextimage_Underline | null, isCircleDarkMode?: boolean | null } | null } | { __typename: 'ComponentDynamicBlocksDynamicYourTurnSection', id: string, header: string, subheader: string, paragraph: string, buttonCaption?: string | null, buttonLink?: string | null, quote: string, person: string, position: string, photo: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null }, leaders: { __typename?: 'LeadershipRelationResponseCollection', data: Array<{ __typename?: 'LeadershipEntity', id?: string | null, attributes?: { __typename?: 'Leadership', name: string, position: string, url: string, avatar: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } } | null }> } } | { __typename: 'ComponentDynamicBlocksHowWeWork', id: string, heading: string, howWeWorkItem: Array<{ __typename?: 'ComponentCommonComponentsItems', id: string, text: string, image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } } | null> } | { __typename: 'ComponentDynamicBlocksLetsBuildBlock', id: string, ctaText: string } | { __typename: 'ComponentDynamicBlocksNewsletterBlock', id: string, info: string, emailPlaceholder: string, marketingText: string, marketingPrivacyLinkLabel: string, subscribe: string, successLabel: string } | { __typename: 'ComponentDynamicBlocksRecommendedArticles', id: string, header: string, decoratedTextImages?: { __typename: 'ComponentCommonComponentsDecoratedTextImage', id: string, circle?: Enum_Componentcommoncomponentsdecoratedtextimage_Circle | null, exclaim?: Enum_Componentcommoncomponentsdecoratedtextimage_Exclaim | null, highlight?: Enum_Componentcommoncomponentsdecoratedtextimage_Highlight | null, underline?: Enum_Componentcommoncomponentsdecoratedtextimage_Underline | null, isCircleDarkMode?: boolean | null } | null, tags: { __typename?: 'ArticleTagRelationResponseCollection', data: Array<{ __typename?: 'ArticleTagEntity', id?: string | null, attributes?: { __typename?: 'ArticleTag', name: string } | null }> } } | { __typename: 'ComponentDynamicBlocksStandaloneContactForm', id: string, contactCardTitle: string, contactCardLabel: string, formNameLabel: string, formEmailLabel: string, formPhoneLabel: string, formCompanyLabel: string, formPrivacyPolicyLabel: string, formSubmitLabel: string, formPrivacyPolicyLink?: string | null, contactCardAdditionalLabelText?: string | null, thanksInPolish?: boolean | null, contactCardImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } | null } | { __typename?: 'Error' } | null> } | null } | null } | null };

export type GetHotArticlesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetHotArticlesQuery = { __typename?: 'Query', featuredArticle?: { __typename?: 'ArticleEntityResponse', data?: { __typename?: 'ArticleEntity', id?: string | null, attributes?: { __typename?: 'Article', slug: string, title: string, lead: string, creationDate: DateLike, minutesOfRead?: number | null, tags: { __typename?: 'ArticleTagRelationResponseCollection', data: Array<{ __typename?: 'ArticleTagEntity', id?: string | null, attributes?: { __typename?: 'ArticleTag', name: string } | null }> }, coverImage: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null }, authors: { __typename?: 'UsersPermissionsUserRelationResponseCollection', data: Array<{ __typename?: 'UsersPermissionsUserEntity', id?: string | null, attributes?: { __typename?: 'UsersPermissionsUser', username: string, description?: string | null, avatar?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } | null } | null }> } } | null } | null } | null, resourcesPage?: { __typename?: 'ResourcesPageEntityResponse', data?: { __typename?: 'ResourcesPageEntity', attributes?: { __typename?: 'ResourcesPage', mostReadArticles: { __typename?: 'ArticleRelationResponseCollection', data: Array<{ __typename?: 'ArticleEntity', id?: string | null, attributes?: { __typename?: 'Article', slug: string, title: string, lead: string, creationDate: DateLike, minutesOfRead?: number | null, tags: { __typename?: 'ArticleTagRelationResponseCollection', data: Array<{ __typename?: 'ArticleTagEntity', id?: string | null, attributes?: { __typename?: 'ArticleTag', name: string } | null }> }, coverImage: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null }, authors: { __typename?: 'UsersPermissionsUserRelationResponseCollection', data: Array<{ __typename?: 'UsersPermissionsUserEntity', id?: string | null, attributes?: { __typename?: 'UsersPermissionsUser', username: string, description?: string | null, avatar?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } | null } | null }> } } | null }> } } | null } | null } | null };

export type GetInventoryAllQueryVariables = Exact<{
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
}>;


export type GetInventoryAllQuery = { __typename?: 'Query', inventoryAll?: { __typename?: 'InventoryAllEntityResponse', data?: { __typename?: 'InventoryAllEntity', attributes?: { __typename?: 'InventoryAll', metadata: { __typename?: 'ComponentMetaMetadata', metaTitle: string, metaDescription: string, ogImage: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } } } | null } | null } | null };

export type GetInventoryDefinitionsQueryVariables = Exact<{
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
}>;


export type GetInventoryDefinitionsQuery = { __typename?: 'Query', inventoryDefinitions?: { __typename?: 'InventoryDefinitionEntityResponseCollection', data: Array<{ __typename?: 'InventoryDefinitionEntity', attributes?: { __typename?: 'InventoryDefinition', title: string, slug: string, capitalLetter: Enum_Inventorydefinition_Capitalletter } | null }> } | null };

export type GetInventoryDefinitionsByLetterQueryVariables = Exact<{
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetInventoryDefinitionsByLetterQuery = { __typename?: 'Query', inventoryDefinitions?: { __typename?: 'InventoryDefinitionEntityResponseCollection', data: Array<{ __typename?: 'InventoryDefinitionEntity', attributes?: { __typename?: 'InventoryDefinition', title: string, slug: string } | null }> } | null };

export type GetInventoryDefinitionsFilteredBySlugQueryVariables = Exact<{
  slug: Scalars['String']['input'];
  publicationState: PublicationState;
  locale: Scalars['I18NLocaleCode']['input'];
}>;


export type GetInventoryDefinitionsFilteredBySlugQuery = { __typename?: 'Query', inventoryDefinitions?: { __typename?: 'InventoryDefinitionEntityResponseCollection', data: Array<{ __typename?: 'InventoryDefinitionEntity', attributes?: { __typename?: 'InventoryDefinition', title: string, slug: string, content: string, capitalLetter: Enum_Inventorydefinition_Capitalletter, metadata: { __typename?: 'ComponentMetaMetadata', metaTitle: string, metaDescription: string, ogImage: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } }, doodle?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } | null, articles?: { __typename?: 'ArticleRelationResponseCollection', data: Array<{ __typename?: 'ArticleEntity', attributes?: { __typename?: 'Article', title: string, slug: string, metadata: { __typename?: 'ComponentMetaMetadata', metaTitle: string, metaDescription: string, ogImage: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } } } | null }> } | null } | null }> } | null };

export type GetLibrariesQueryVariables = Exact<{
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
}>;


export type GetLibrariesQuery = { __typename?: 'Query', libraries?: { __typename?: 'LibraryEntityResponseCollection', data: Array<{ __typename?: 'LibraryEntity', attributes?: { __typename?: 'Library', slug: string, title: string, content: string, cover: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } } | null }> } | null };

export type GetLibrariesFilteredBySlugQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type GetLibrariesFilteredBySlugQuery = { __typename?: 'Query', libraries?: { __typename?: 'LibraryEntityResponseCollection', data: Array<{ __typename?: 'LibraryEntity', id?: string | null, attributes?: { __typename?: 'Library', slug: string, title: string, content: string, metadata: { __typename?: 'ComponentMetaMetadata', metaTitle: string, metaDescription: string, ogImage: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } }, cover: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null }, doodle?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } | null } | null }> } | null };

export type GetLibrariesPageQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLibrariesPageQuery = { __typename?: 'Query', guidesPage?: { __typename?: 'GuidesPageEntityResponse', data?: { __typename?: 'GuidesPageEntity', attributes?: { __typename?: 'GuidesPage', metadata: { __typename?: 'ComponentMetaMetadata', metaTitle: string, metaDescription: string, ogImage: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } } } | null } | null } | null };

export type GetPrivacyPolicyQueryVariables = Exact<{
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
}>;


export type GetPrivacyPolicyQuery = { __typename?: 'Query', privacyPolicy?: { __typename?: 'PrivacyPolicyEntityResponse', data?: { __typename?: 'PrivacyPolicyEntity', attributes?: { __typename?: 'PrivacyPolicy', privacyPolicy: { __typename?: 'ComponentPrivacyPolicySectionsPrivacyPolicy', intro: string, lastUpdated: { __typename?: 'ComponentCommonComponentsDateWithLabel', label: string, date: DateLike }, paragraph: Array<{ __typename?: 'ComponentCommonComponentsHeadingWithRichText', heading: string, content: string } | null> }, metadata: { __typename?: 'ComponentMetaMetadata', metaTitle: string, metaDescription: string, ogImage: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } } } | null } | null } | null };

export type GetProposedArticlesQueryVariables = Exact<{
  tags: Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>;
  slug: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
}>;


export type GetProposedArticlesQuery = { __typename?: 'Query', articles?: { __typename?: 'ArticleEntityResponseCollection', data: Array<{ __typename?: 'ArticleEntity', id?: string | null, attributes?: { __typename?: 'Article', slug: string, title: string, lead: string, creationDate: DateLike, minutesOfRead?: number | null, tags: { __typename?: 'ArticleTagRelationResponseCollection', data: Array<{ __typename?: 'ArticleTagEntity', id?: string | null, attributes?: { __typename?: 'ArticleTag', name: string } | null }> }, coverImage: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null }, authors: { __typename?: 'UsersPermissionsUserRelationResponseCollection', data: Array<{ __typename?: 'UsersPermissionsUserEntity', id?: string | null, attributes?: { __typename?: 'UsersPermissionsUser', username: string, description?: string | null, avatar?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } | null } | null }> } } | null }> } | null };

export type GetProposedArticlesNoTagsFilterQueryVariables = Exact<{
  slug: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
}>;


export type GetProposedArticlesNoTagsFilterQuery = { __typename?: 'Query', articles?: { __typename?: 'ArticleEntityResponseCollection', data: Array<{ __typename?: 'ArticleEntity', id?: string | null, attributes?: { __typename?: 'Article', slug: string, title: string, lead: string, creationDate: DateLike, minutesOfRead?: number | null, tags: { __typename?: 'ArticleTagRelationResponseCollection', data: Array<{ __typename?: 'ArticleTagEntity', id?: string | null, attributes?: { __typename?: 'ArticleTag', name: string } | null }> }, coverImage: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null }, authors: { __typename?: 'UsersPermissionsUserRelationResponseCollection', data: Array<{ __typename?: 'UsersPermissionsUserEntity', id?: string | null, attributes?: { __typename?: 'UsersPermissionsUser', username: string, description?: string | null, avatar?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } | null } | null }> } } | null }> } | null };

export type GetProposedCaseStudiesQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type GetProposedCaseStudiesQuery = { __typename?: 'Query', caseStudies?: { __typename?: 'CaseStudyEntityResponseCollection', data: Array<{ __typename?: 'CaseStudyEntity', id?: string | null, attributes?: { __typename?: 'CaseStudy', slug: string, doodleText?: string | null, title: string, description: string, position: number, image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null }, caseStudyCategory?: { __typename?: 'CaseStudyCategoryEntityResponse', data?: { __typename?: 'CaseStudyCategoryEntity', id?: string | null, attributes?: { __typename?: 'CaseStudyCategory', name: string } | null } | null } | null, caseStudyTags?: { __typename?: 'CaseStudyTagRelationResponseCollection', data: Array<{ __typename?: 'CaseStudyTagEntity', id?: string | null, attributes?: { __typename?: 'CaseStudyTag', name: string } | null }> } | null } | null }> } | null };

export type GetResourcesPageQueryVariables = Exact<{
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
}>;


export type GetResourcesPageQuery = { __typename?: 'Query', resourcesPage?: { __typename?: 'ResourcesPageEntityResponse', data?: { __typename?: 'ResourcesPageEntity', attributes?: { __typename?: 'ResourcesPage', metadata: { __typename?: 'ComponentMetaMetadata', metaTitle: string, metaDescription: string, ogImage: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, caption?: string | null, width?: number | null, height?: number | null, formats?: any | null, placeholder?: string | null, url: string } | null } | null } } } | null } | null } | null };

export const ArticleTagsFragmentDoc = `
    fragment articleTags on ArticleTagRelationResponseCollection {
  data {
    id
    attributes {
      name
    }
  }
}
    `;
export const ImageFragmentDoc = `
    fragment image on UploadFileEntityResponse {
  data {
    attributes {
      alternativeText
      caption
      width
      height
      formats
      placeholder
      url
    }
  }
}
    `;
export const UserFragmentDoc = `
    fragment user on UsersPermissionsUserEntity {
  id
  attributes {
    username
    avatar {
      ...image
    }
    description
  }
}
    `;
export const AuthorsFragmentDoc = `
    fragment authors on UsersPermissionsUserRelationResponseCollection {
  data {
    ...user
  }
}
    `;
export const ArticleCardFragmentDoc = `
    fragment articleCard on Article {
  slug
  tags {
    ...articleTags
  }
  title
  lead
  creationDate
  coverImage {
    ...image
  }
  minutesOfRead
  authors {
    ...authors
  }
}
    `;
export const ArticleCategoryFragmentDoc = `
    fragment articleCategory on ArticleCategoryEntityResponse {
  data {
    attributes {
      name
      topCategory
    }
  }
}
    `;
export const ClientOpinionCardFragmentDoc = `
    fragment clientOpinionCard on ComponentHomeComponentsClientOpinionsCard {
  clientAvatar {
    ...image
  }
  clientLogo {
    ...image
  }
  clientName
  content
  clientDescription
  clientDescriptionSecondLine
}
    `;
export const DecoratedTextImgFragmentDoc = `
    fragment decoratedTextImg on ComponentCommonComponentsDecoratedTextImage {
  __typename
  id
  circle
  exclaim
  highlight
  underline
  isCircleDarkMode
}
    `;
export const DynamicTestimonialFragmentDoc = `
    fragment dynamicTestimonial on ComponentDynamicBlocksDynamicTestimonialBlock {
  __typename
  id
  quote
  person
  decoratedTextImages {
    ...decoratedTextImg
  }
  position
  photo {
    ...image
  }
}
    `;
export const DynamicHeroFragmentDoc = `
    fragment dynamicHero on ComponentDynamicBlocksDynamicHeroBlock {
  __typename
  id
  title
  description
  buttonCaption
  buttonLink
  decoratedTextImages {
    ...decoratedTextImg
  }
}
    `;
export const DynamicConstantFragmentDoc = `
    fragment dynamicConstant on ComponentDynamicBlocksDynamicConstantBlock {
  __typename
  id
  name
}
    `;
export const DynamicFaqFragmentDoc = `
    fragment dynamicFAQ on ComponentDynamicBlocksDynamicFaqBlock {
  __typename
  id
  header
  decoratedTextImages {
    ...decoratedTextImg
  }
  items {
    answer
    question
  }
}
    `;
export const DynamicPointsWithPhotosFragmentDoc = `
    fragment dynamicPointsWithPhotos on ComponentDynamicBlocksDynamicPointsWithPhotosBlock {
  __typename
  id
  header
  elements {
    id
    text
    photo {
      ...image
    }
  }
}
    `;
export const DynamicDarkInfoDividerFragmentDoc = `
    fragment dynamicDarkInfoDivider on ComponentDynamicBlocksDynamicDarkInfoDividerBlock {
  __typename
  id
  header
  description
  buttonLink
  buttonCaption
}
    `;
export const DynamicInfoWithPhotoFragmentDoc = `
    fragment dynamicInfoWithPhoto on ComponentDynamicBlocksDynamicInfoWithPhotoBlock {
  __typename
  id
  header
  message
  buttonLink
  buttonCaption
  photo {
    ...image
  }
}
    `;
export const LogosFragmentDoc = `
    fragment logos on ArticleTagRelationResponseCollection {
  data {
    id
    attributes {
      name
    }
  }
}
    `;
export const ImagesFragmentDoc = `
    fragment images on UploadFileRelationResponseCollection {
  data {
    id
    attributes {
      alternativeText
      caption
      width
      height
      formats
      placeholder
      url
    }
  }
}
    `;
export const DynamicLogosFragmentDoc = `
    fragment dynamicLogos on ComponentDynamicBlocksDynamicLogosBlock {
  __typename
  id
  header
  logos {
    ...images
  }
}
    `;
export const RichTextBlockFragmentDoc = `
    fragment richTextBlock on ComponentCommonComponentsCkEditor {
  id
  richText
}
    `;
export const RichTextFragmentDoc = `
    fragment richText on CaseStudyContentBlocksDynamicZone {
  ... on ComponentCommonComponentsCkEditor {
    __typename
    ...richTextBlock
  }
}
    `;
export const DynamicRichTextFragmentDoc = `
    fragment dynamicRichText on ComponentDynamicBlocksDynamicRichTextBlock {
  __typename
  id
  text {
    ...richText
  }
}
    `;
export const DynamicInfoGridFragmentDoc = `
    fragment dynamicInfoGrid on ComponentDynamicBlocksDynamicInfoGridBlock {
  __typename
  id
  header
  items {
    heading
    description
    buttonLabel
    buttonLink
    image {
      ...image
    }
  }
  mode
  decoratedTextImages {
    ...decoratedTextImg
  }
}
    `;
export const DynamicSliderWithPointsFragmentDoc = `
    fragment dynamicSliderWithPoints on ComponentDynamicBlocksDynamicSliderPointsBlock {
  __typename
  id
  header
  subheader
  items {
    header
    paragraphOneTitle
    paragraphTwoTitle
    paragraphThreeTitle
    paragraphOneDescription
    paragraphTwoDescription
    paragraphThreeDescription
    buttonLabel
    buttonLink
    image {
      ...image
    }
  }
}
    `;
export const DynamicDividerWithPhotosFragmentDoc = `
    fragment dynamicDividerWithPhotos on ComponentDynamicBlocksDynamicDividerWithPhotosBlock {
  __typename
  id
  multipleImages {
    ...images
  }
}
    `;
export const DynamicGallerySectionFragmentDoc = `
    fragment dynamicGallerySection on ComponentDynamicBlocksDynamicGallerySection {
  __typename
  id
  topText
  middleText
  bottomText
}
    `;
export const ButtonFragmentDoc = `
    fragment button on ComponentCommonComponentsButton {
  label
  url
  variant
}
    `;
export const AvatarWithHoverFragmentDoc = `
    fragment avatarWithHover on ComponentCommonComponentsHoverAvatar {
  id
  hoverText
  name
  role
  image {
    ...image
  }
}
    `;
export const DynamicTextWithPhotosFragmentDoc = `
    fragment dynamicTextWithPhotos on ComponentDynamicBlocksDynamicTextWithPhotos {
  __typename
  id
  headerStartText
  headerMiddleText
  headerEndText
  desc
  button {
    ...button
  }
  firstAvatar {
    ...avatarWithHover
  }
  secondAvatar {
    ...avatarWithHover
  }
}
    `;
export const DynamicChartSectionFragmentDoc = `
    fragment dynamicChartSection on ComponentDynamicBlocksDynamicChartSection {
  __typename
  id
  header
  items {
    id
    heading
    list {
      id
      textListItem
    }
  }
}
    `;
export const DynamicHistorySectionFragmentDoc = `
    fragment dynamicHistorySection on ComponentDynamicBlocksDynamicHistorySection {
  __typename
  id
  header
  items {
    id
    year
    name
    description
  }
}
    `;
export const DynamicTeamInvolvedFragmentDoc = `
    fragment dynamicTeamInvolved on ComponentDynamicBlocksDynamicTeamInvolved {
  __typename
  id
  header
  subheader
  items {
    id
    image1: image {
      data {
        attributes {
          width
          height
          url
        }
      }
    }
    caption
  }
}
    `;
export const DynamicFeatureListFragmentDoc = `
    fragment dynamicFeatureList on ComponentDynamicBlocksDynamicFeatureListBlock {
  __typename
  id
  cta
  ctaImage {
    ...image
  }
  ctaImageMobile {
    ...image
  }
  items {
    id
    text
    paragraph
    image {
      ...image
    }
  }
  largeImage
  displayDigits
  imagePosition
  buttonLabel
  buttonLink
}
    `;
export const DynamicHeroWithContactFragmentDoc = `
    fragment dynamicHeroWithContact on ComponentDynamicBlocksDynamicHeroWithContactBlock {
  __typename
  id
  ctaTop
  ctaBottom
  backgroundImage {
    ...image
  }
  contactCardTitle
  contactCardImage {
    ...image
  }
  contactCardLabel
  formNameLabel
  formEmailLabel
  formPhoneLabel
  formCompanyLabel
  formPrivacyPolicyLabel
  formSubmitLabel
  formPrivacyPolicyLink
  contactCardAdditionalLabelText
  thanksInPolish
  withDoodleInBackground
  hideMobileButton
}
    `;
export const DynamicClientOpinionsFragmentDoc = `
    fragment dynamicClientOpinions on ComponentDynamicBlocksDynamicClientOpinions {
  __typename
  id
  title
  subtitle
  opinions {
    id
    opinions {
      id
      clientLogo {
        ...image
      }
      clientAvatar {
        ...image
      }
      clientName
      clientDescription
      clientDescriptionSecondLine
      content
    }
    awardLogo {
      ...image
    }
  }
  decoratedTextImages {
    ...decoratedTextImg
  }
}
    `;
export const DynamicSeeMoreBlockFragmentDoc = `
    fragment dynamicSeeMoreBlock on ComponentDynamicBlocksDynamicSeeMoreBlock {
  __typename
  id
  header
  image {
    ...image
  }
  buttonLabel
  buttonLink
}
    `;
export const DynamicPartnersBlockFragmentDoc = `
    fragment dynamicPartnersBlock on ComponentDynamicBlocksDynamicPartners {
  __typename
  id
  header
  partners {
    data {
      id
      attributes {
        content
        clientLogo {
          ...image
        }
        name
        partnerTags {
          data {
            id
            attributes {
              name
            }
          }
        }
      }
    }
  }
}
    `;
export const DynamicLeadershipFragmentDoc = `
    fragment dynamicLeadership on ComponentDynamicBlocksDynamicLeadership {
  __typename
  id
  header
  leaders {
    data {
      attributes {
        name
        position
        url
        avatar {
          ...image
        }
      }
    }
  }
}
    `;
export const DynamicStatisticsFragmentDoc = `
    fragment dynamicStatistics on ComponentDynamicBlocksDynamicStatistics {
  __typename
  id
  statHeader: header
  statistics {
    value
    description
    descriptionAdd
  }
  underlinedValues
  darkBackground
}
    `;
export const DynamicCaseStudiesPreviewFragmentDoc = `
    fragment dynamicCaseStudiesPreview on ComponentDynamicBlocksDynamicCaseStudiesPreview {
  __typename
  id
  bigBoxHeader
  bigBoxButtonLabel
  bigBoxButtonLink
  bigBoxBackgroundImage {
    ...image
  }
  middleBoxCaption
  middleBoxBackgroundImage {
    ...image
  }
  rightBoxCaption
  rightBoxBackgroundImage {
    ...image
  }
}
    `;
export const DynamicVideoBannerFragmentDoc = `
    fragment dynamicVideoBanner on ComponentDynamicBlocksDynamicVideoBanner {
  __typename
  id
  coverImageFallback {
    ...image
  }
  coverVideoUrl {
    ...image
  }
  header
  decoratedTextImages {
    ...decoratedTextImg
  }
  buttonLabel
  buttonLink
}
    `;
export const DynamicTeamInvolvedWithHoverFragmentDoc = `
    fragment dynamicTeamInvolvedWithHover on ComponentDynamicBlocksDynamicTeamInvolvedWithHover {
  __typename
  id
  header
  items {
    hoverImage {
      ...image
    }
    afterImage: image {
      ...image
    }
    imageCaptionFirstLine
    imageCaptionSecondLine
    comment
  }
}
    `;
export const HowWeWorkFragmentDoc = `
    fragment howWeWork on ComponentDynamicBlocksHowWeWork {
  __typename
  id
  heading
  howWeWorkItem {
    id
    text
    image {
      ...image
    }
  }
}
    `;
export const DynamicScrollSliderFragmentDoc = `
    fragment dynamicScrollSlider on ComponentDynamicBlocksDynamicScrollSlider {
  __typename
  id
  badgeImage {
    ...image
  }
  badgeText
  items {
    slideImage {
      ...image
    }
    imageAlt
    url
  }
}
    `;
export const DynamicMediaFragmentDoc = `
    fragment dynamicMedia on ComponentDynamicBlocksDynamicMedia {
  __typename
  id
  items {
    __typename
    id
    name
    coverVideo {
      ...image
    }
    coverImageFallback {
      ...image
    }
  }
}
    `;
export const StandaloneContactFormFragmentDoc = `
    fragment standaloneContactForm on ComponentDynamicBlocksStandaloneContactForm {
  __typename
  id
  contactCardTitle
  contactCardImage {
    ...image
  }
  contactCardLabel
  formNameLabel
  formEmailLabel
  formPhoneLabel
  formCompanyLabel
  formPrivacyPolicyLabel
  formSubmitLabel
  formPrivacyPolicyLink
  contactCardAdditionalLabelText
  thanksInPolish
}
    `;
export const DynamicFacesFragmentDoc = `
    fragment dynamicFaces on ComponentDynamicBlocksDynamicFaces {
  __typename
  id
  header
  decoratedTextImages {
    ...decoratedTextImg
  }
  items {
    __typename
    id
    name
    position
    comment
    image1 {
      ...image
    }
    image2 {
      ...image
    }
  }
}
    `;
export const DynamicRecommendedArticlesFragmentDoc = `
    fragment dynamicRecommendedArticles on ComponentDynamicBlocksRecommendedArticles {
  __typename
  id
  header
  decoratedTextImages {
    ...decoratedTextImg
  }
  tags {
    data {
      id
      attributes {
        name
      }
    }
  }
}
    `;
export const CaseStudiesShowcaseFragmentDoc = `
    fragment caseStudiesShowcase on ComponentDynamicBlocksCaseStudiesShowcase {
  __typename
  id
  title
  subtitle
  buttonText
  caseStudySlugs {
    id
    caseStudySlug
  }
}
    `;
export const LetsBuildBlockFragmentDoc = `
    fragment letsBuildBlock on ComponentDynamicBlocksLetsBuildBlock {
  id
  __typename
  ctaText
}
    `;
export const NewsletterBlockFragmentDoc = `
    fragment newsletterBlock on ComponentDynamicBlocksNewsletterBlock {
  id
  __typename
  info
  emailPlaceholder
  marketingText
  marketingPrivacyLinkLabel
  subscribe
  successLabel
}
    `;
export const BannerBlockFragmentDoc = `
    fragment bannerBlock on ComponentDynamicBlocksBannerSection {
  id
  __typename
  bannerTitle
  bannerDesc
}
    `;
export const DynamicYourTurnSectionFragmentDoc = `
    fragment dynamicYourTurnSection on ComponentDynamicBlocksDynamicYourTurnSection {
  __typename
  id
  header
  subheader
  paragraph
  buttonCaption
  buttonLink
  quote
  person
  position
  photo {
    ...image
  }
  leaders {
    data {
      id
      attributes {
        name
        position
        url
        avatar {
          ...image
        }
      }
    }
  }
}
    `;
export const FileFragmentDoc = `
    fragment file on UploadFileEntityResponse {
  data {
    id
    attributes {
      name
      url
    }
  }
}
    `;
export const LeadershipFragmentDoc = `
    fragment leadership on LeadershipEntity {
  attributes {
    name
    position
    url
    avatar {
      ...image
    }
  }
}
    `;
export const LinkFragmentDoc = `
    fragment link on ComponentCommonComponentsLink {
  label
  url
}
    `;
export const MetadataFragmentDoc = `
    fragment metadata on ComponentMetaMetadata {
  metaTitle
  metaDescription
  ogImage {
    ...image
  }
}
    `;
export const OurServicesCardFragmentDoc = `
    fragment ourServicesCard on ComponentHomeComponentsOurServiceCard {
  id
  heading
  description
  list {
    id
    emoji
    heading
    description
  }
  buttonHref
  buttonCaption
  priceFrom
}
    `;
export const PartnerFragmentDoc = `
    fragment partner on PartnerEntity {
  attributes {
    clientLogo {
      ...image
    }
    content
    partnerTags {
      data {
        id
        attributes {
          name
        }
      }
    }
  }
}
    `;
export const SocialItemFragmentDoc = `
    fragment socialItem on ComponentCommonComponentsSocialItem {
  url
  icon {
    ...image
  }
}
    `;
export const StickyCtaFragmentDoc = `
    fragment stickyCta on ComponentCommonComponentsStickyCta {
  title
  subttitle
  buttonCaption
  buttonLink
}
    `;
export const TextListFragmentDoc = `
    fragment textList on ComponentCommonComponentsTextList {
  textListItems {
    textListItem
  }
}
    `;
export const StatisticsFragmentDoc = `
    fragment statistics on ComponentAboutUsStatistics {
  value
  description
  descriptionAdd
}
    `;
export const ValuesFragmentDoc = `
    fragment values on ComponentAboutUsValues {
  header
  description
  coverImageFallback {
    ...image
  }
  coverVideo {
    ...image
  }
}
    `;
export const CaseStudyFragmentDoc = `
    fragment caseStudy on CaseStudyEntity {
  id
  attributes {
    slug
    doodleText
    title
    description
    image {
      ...image
    }
    caseStudyCategory {
      data {
        id
        attributes {
          name
        }
      }
    }
    caseStudyTags {
      data {
        id
        attributes {
          name
        }
      }
    }
    position
  }
}
    `;
export const FeaturedCaseStudyFragmentDoc = `
    fragment featuredCaseStudy on ComponentCaseStudyAllSectionsFeatured {
  heading
  descriptionOne
  descriptionTwo
  caseStudy {
    data {
      ...caseStudy
    }
  }
}
    `;
export const ClutchReviewFragmentDoc = `
    fragment clutchReview on ComponentCommonComponentsClutchReviewCard {
  content
  reviewerName
  reviewerDescription
  reviewerAvatar {
    ...image
  }
  rating
}
    `;
export const ClutchScoreFragmentDoc = `
    fragment clutchScore on ComponentHomeSectionsClutchScore {
  firstReview {
    ...clutchReview
  }
  secondReview {
    ...clutchReview
  }
  thirdReview {
    ...clutchReview
  }
}
    `;
export const CompanyStatisticsCardFragmentDoc = `
    fragment companyStatisticsCard on ComponentHomeComponentsCompanyStatisticsCard {
  value
  label
  showBadge
}
    `;
export const CompanyStatisticsFragmentDoc = `
    fragment companyStatistics on ComponentHomeSectionsCompanyStatistics {
  cakeDoodle {
    ...image
  }
  companyStatisticsCard {
    ...companyStatisticsCard
  }
}
    `;
export const ChatBubbleFragmentDoc = `
    fragment chatBubble on ComponentHomeComponentsLetsMeetChatBubble {
  memberMessage
  memberName
  memberRole
}
    `;
export const LetsMeetTeamMemberFragmentDoc = `
    fragment letsMeetTeamMember on ComponentHomeComponentsLetsMeetTeamMember {
  doodle {
    ...image
  }
  avatar {
    ...image
  }
  chatBubble {
    ...chatBubble
  }
}
    `;
export const LetsMeetFragmentDoc = `
    fragment letsMeet on ComponentHomeSectionsLetsMeet {
  teamMemberOne {
    ...letsMeetTeamMember
  }
  teamMemberTwo {
    ...letsMeetTeamMember
  }
  teamMemberThree {
    ...letsMeetTeamMember
  }
  teamMemberFour {
    ...letsMeetTeamMember
  }
  teamMemberFive {
    ...letsMeetTeamMember
  }
}
    `;
export const TechStackRowFragmentDoc = `
    fragment techStackRow on ComponentHomeComponentsTechStackRow {
  pill {
    image {
      ...image
    }
    caption
  }
}
    `;
export const TechStackFragmentDoc = `
    fragment techStack on ComponentHomeSectionsTechStack {
  row {
    ...techStackRow
  }
}
    `;
export const CaseStudiesFragmentDoc = `
    fragment caseStudies on ComponentHomeSectionsCaseStudies {
  caseStudies {
    data {
      ...caseStudy
    }
  }
}
    `;
export const AddSubscriberToNewsletterDocument = `
    mutation AddSubscriberToNewsletter($email: String!, $captchaToken: String!) {
  addContactToAudience(data: {email: $email, captchaToken: $captchaToken}) {
    ok
  }
}
    `;
export const useAddSubscriberToNewsletterMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AddSubscriberToNewsletterMutation, TError, AddSubscriberToNewsletterMutationVariables, TContext>) =>
    useMutation<AddSubscriberToNewsletterMutation, TError, AddSubscriberToNewsletterMutationVariables, TContext>(
      ['AddSubscriberToNewsletter'],
      (variables?: AddSubscriberToNewsletterMutationVariables) => fetcher<AddSubscriberToNewsletterMutation, AddSubscriberToNewsletterMutationVariables>(AddSubscriberToNewsletterDocument, variables)(),
      options
    );
useAddSubscriberToNewsletterMutation.getKey = () => ['AddSubscriberToNewsletter'];

useAddSubscriberToNewsletterMutation.fetcher = (variables: AddSubscriberToNewsletterMutationVariables, options?: RequestInit['headers']) => fetcher<AddSubscriberToNewsletterMutation, AddSubscriberToNewsletterMutationVariables>(AddSubscriberToNewsletterDocument, variables, options);
export const CreateLibraryRequestDocument = `
    mutation CreateLibraryRequest($data: LibraryRequestInput!) {
  createLibraryRequest(data: $data) {
    data {
      id
      attributes {
        library {
          data {
            attributes {
              asset {
                ...file
              }
            }
          }
        }
      }
    }
  }
}
    ${FileFragmentDoc}`;
export const useCreateLibraryRequestMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateLibraryRequestMutation, TError, CreateLibraryRequestMutationVariables, TContext>) =>
    useMutation<CreateLibraryRequestMutation, TError, CreateLibraryRequestMutationVariables, TContext>(
      ['CreateLibraryRequest'],
      (variables?: CreateLibraryRequestMutationVariables) => fetcher<CreateLibraryRequestMutation, CreateLibraryRequestMutationVariables>(CreateLibraryRequestDocument, variables)(),
      options
    );
useCreateLibraryRequestMutation.getKey = () => ['CreateLibraryRequest'];

useCreateLibraryRequestMutation.fetcher = (variables: CreateLibraryRequestMutationVariables, options?: RequestInit['headers']) => fetcher<CreateLibraryRequestMutation, CreateLibraryRequestMutationVariables>(CreateLibraryRequestDocument, variables, options);
export const GetAboutUsDocument = `
    query GetAboutUs($locale: I18NLocaleCode) {
  aboutUs(locale: $locale) {
    data {
      attributes {
        metadata {
          ...metadata
        }
        statistics {
          ...statistics
        }
        partners {
          data {
            ...partner
          }
        }
        leaderships {
          data {
            ...leadership
          }
        }
        blocks {
          ...dynamicSliderWithPoints
          ...dynamicInfoGrid
          ...dynamicTestimonial
          ...dynamicHero
          ...dynamicConstant
          ...dynamicFAQ
          ...dynamicPointsWithPhotos
          ...dynamicDarkInfoDivider
          ...dynamicInfoWithPhoto
          ...dynamicLogos
          ...dynamicRichText
          ...dynamicDividerWithPhotos
          ...dynamicGallerySection
          ...dynamicTextWithPhotos
          ...dynamicChartSection
          ...dynamicHistorySection
          ...dynamicTeamInvolved
          ...dynamicFeatureList
          ...dynamicHeroWithContact
          ...dynamicClientOpinions
          ...dynamicSeeMoreBlock
          ...dynamicPartnersBlock
          ...dynamicLeadership
          ...dynamicStatistics
          ...dynamicCaseStudiesPreview
          ...dynamicVideoBanner
          ...dynamicTeamInvolvedWithHover
          ...howWeWork
          ...dynamicScrollSlider
          ...dynamicMedia
          ...standaloneContactForm
          ...dynamicFaces
          ...dynamicRecommendedArticles
          ...caseStudiesShowcase
          ...letsBuildBlock
          ...newsletterBlock
          ...bannerBlock
        }
      }
    }
  }
}
    ${MetadataFragmentDoc}
${ImageFragmentDoc}
${StatisticsFragmentDoc}
${PartnerFragmentDoc}
${LeadershipFragmentDoc}
${DynamicSliderWithPointsFragmentDoc}
${DynamicInfoGridFragmentDoc}
${DecoratedTextImgFragmentDoc}
${DynamicTestimonialFragmentDoc}
${DynamicHeroFragmentDoc}
${DynamicConstantFragmentDoc}
${DynamicFaqFragmentDoc}
${DynamicPointsWithPhotosFragmentDoc}
${DynamicDarkInfoDividerFragmentDoc}
${DynamicInfoWithPhotoFragmentDoc}
${DynamicLogosFragmentDoc}
${ImagesFragmentDoc}
${DynamicRichTextFragmentDoc}
${RichTextFragmentDoc}
${RichTextBlockFragmentDoc}
${DynamicDividerWithPhotosFragmentDoc}
${DynamicGallerySectionFragmentDoc}
${DynamicTextWithPhotosFragmentDoc}
${ButtonFragmentDoc}
${AvatarWithHoverFragmentDoc}
${DynamicChartSectionFragmentDoc}
${DynamicHistorySectionFragmentDoc}
${DynamicTeamInvolvedFragmentDoc}
${DynamicFeatureListFragmentDoc}
${DynamicHeroWithContactFragmentDoc}
${DynamicClientOpinionsFragmentDoc}
${DynamicSeeMoreBlockFragmentDoc}
${DynamicPartnersBlockFragmentDoc}
${DynamicLeadershipFragmentDoc}
${DynamicStatisticsFragmentDoc}
${DynamicCaseStudiesPreviewFragmentDoc}
${DynamicVideoBannerFragmentDoc}
${DynamicTeamInvolvedWithHoverFragmentDoc}
${HowWeWorkFragmentDoc}
${DynamicScrollSliderFragmentDoc}
${DynamicMediaFragmentDoc}
${StandaloneContactFormFragmentDoc}
${DynamicFacesFragmentDoc}
${DynamicRecommendedArticlesFragmentDoc}
${CaseStudiesShowcaseFragmentDoc}
${LetsBuildBlockFragmentDoc}
${NewsletterBlockFragmentDoc}
${BannerBlockFragmentDoc}`;
export const useGetAboutUsQuery = <
      TData = GetAboutUsQuery,
      TError = unknown
    >(
      variables?: GetAboutUsQueryVariables,
      options?: UseQueryOptions<GetAboutUsQuery, TError, TData>
    ) =>
    useQuery<GetAboutUsQuery, TError, TData>(
      variables === undefined ? ['GetAboutUs'] : ['GetAboutUs', variables],
      fetcher<GetAboutUsQuery, GetAboutUsQueryVariables>(GetAboutUsDocument, variables),
      options
    );

useGetAboutUsQuery.getKey = (variables?: GetAboutUsQueryVariables) => variables === undefined ? ['GetAboutUs'] : ['GetAboutUs', variables];
;

useGetAboutUsQuery.fetcher = (variables?: GetAboutUsQueryVariables, options?: RequestInit['headers']) => fetcher<GetAboutUsQuery, GetAboutUsQueryVariables>(GetAboutUsDocument, variables, options);
export const GetArticleBySlugDocument = `
    query GetArticleBySlug($slug: String!, $isPreview: Boolean!, $locale: I18NLocaleCode!) {
  article(slug: $slug, isPreview: $isPreview, locale: $locale) {
    data {
      id
      attributes {
        slug
        title
        titleMarkdown
        metadata {
          ...metadata
        }
        stickyCta {
          title
          subttitle
          buttonCaption
          buttonLink
        }
        authors {
          ...authors
        }
        content
        creationDate
        coverImage {
          ...image
        }
        tags {
          ...articleTags
        }
        minutesOfRead
        dynamicBlocks {
          ...dynamicSliderWithPoints
          ...dynamicInfoGrid
          ...dynamicTestimonial
          ...dynamicHero
          ...dynamicConstant
          ...dynamicFAQ
          ...dynamicPointsWithPhotos
          ...dynamicDarkInfoDivider
          ...dynamicInfoWithPhoto
          ...dynamicLogos
          ...dynamicRichText
          ...dynamicDividerWithPhotos
          ...dynamicGallerySection
          ...dynamicTextWithPhotos
          ...dynamicChartSection
          ...dynamicHistorySection
          ...dynamicTeamInvolved
          ...dynamicFeatureList
          ...dynamicHeroWithContact
          ...dynamicClientOpinions
          ...dynamicSeeMoreBlock
          ...dynamicPartnersBlock
          ...dynamicLeadership
          ...dynamicStatistics
          ...dynamicCaseStudiesPreview
          ...dynamicVideoBanner
          ...dynamicTeamInvolvedWithHover
          ...howWeWork
          ...dynamicScrollSlider
          ...dynamicMedia
          ...standaloneContactForm
          ...dynamicFaces
          ...dynamicRecommendedArticles
          ...caseStudiesShowcase
          ...letsBuildBlock
          ...newsletterBlock
          ...bannerBlock
        }
        createdAt
        updatedAt
        category {
          data {
            id
          }
        }
      }
    }
  }
}
    ${MetadataFragmentDoc}
${ImageFragmentDoc}
${AuthorsFragmentDoc}
${UserFragmentDoc}
${ArticleTagsFragmentDoc}
${DynamicSliderWithPointsFragmentDoc}
${DynamicInfoGridFragmentDoc}
${DecoratedTextImgFragmentDoc}
${DynamicTestimonialFragmentDoc}
${DynamicHeroFragmentDoc}
${DynamicConstantFragmentDoc}
${DynamicFaqFragmentDoc}
${DynamicPointsWithPhotosFragmentDoc}
${DynamicDarkInfoDividerFragmentDoc}
${DynamicInfoWithPhotoFragmentDoc}
${DynamicLogosFragmentDoc}
${ImagesFragmentDoc}
${DynamicRichTextFragmentDoc}
${RichTextFragmentDoc}
${RichTextBlockFragmentDoc}
${DynamicDividerWithPhotosFragmentDoc}
${DynamicGallerySectionFragmentDoc}
${DynamicTextWithPhotosFragmentDoc}
${ButtonFragmentDoc}
${AvatarWithHoverFragmentDoc}
${DynamicChartSectionFragmentDoc}
${DynamicHistorySectionFragmentDoc}
${DynamicTeamInvolvedFragmentDoc}
${DynamicFeatureListFragmentDoc}
${DynamicHeroWithContactFragmentDoc}
${DynamicClientOpinionsFragmentDoc}
${DynamicSeeMoreBlockFragmentDoc}
${DynamicPartnersBlockFragmentDoc}
${DynamicLeadershipFragmentDoc}
${DynamicStatisticsFragmentDoc}
${DynamicCaseStudiesPreviewFragmentDoc}
${DynamicVideoBannerFragmentDoc}
${DynamicTeamInvolvedWithHoverFragmentDoc}
${HowWeWorkFragmentDoc}
${DynamicScrollSliderFragmentDoc}
${DynamicMediaFragmentDoc}
${StandaloneContactFormFragmentDoc}
${DynamicFacesFragmentDoc}
${DynamicRecommendedArticlesFragmentDoc}
${CaseStudiesShowcaseFragmentDoc}
${LetsBuildBlockFragmentDoc}
${NewsletterBlockFragmentDoc}
${BannerBlockFragmentDoc}`;
export const useGetArticleBySlugQuery = <
      TData = GetArticleBySlugQuery,
      TError = unknown
    >(
      variables: GetArticleBySlugQueryVariables,
      options?: UseQueryOptions<GetArticleBySlugQuery, TError, TData>
    ) =>
    useQuery<GetArticleBySlugQuery, TError, TData>(
      ['GetArticleBySlug', variables],
      fetcher<GetArticleBySlugQuery, GetArticleBySlugQueryVariables>(GetArticleBySlugDocument, variables),
      options
    );

useGetArticleBySlugQuery.getKey = (variables: GetArticleBySlugQueryVariables) => ['GetArticleBySlug', variables];
;

useGetArticleBySlugQuery.fetcher = (variables: GetArticleBySlugQueryVariables, options?: RequestInit['headers']) => fetcher<GetArticleBySlugQuery, GetArticleBySlugQueryVariables>(GetArticleBySlugDocument, variables, options);
export const GetArticleCardsDocument = `
    query GetArticleCards($publicationState: PublicationState!, $categoryId: ID, $page: Int!, $pageSize: Int!, $sort: [String], $title: String!, $locale: I18NLocaleCode) {
  articles(
    publicationState: $publicationState
    filters: {category: {id: {eq: $categoryId}}, title: {containsi: $title}}
    pagination: {page: $page, pageSize: $pageSize}
    sort: $sort
    locale: $locale
  ) {
    data {
      id
      attributes {
        ...articleCard
      }
    }
    meta {
      pagination {
        page
        pageSize
        pageCount
        total
      }
    }
  }
}
    ${ArticleCardFragmentDoc}
${ArticleTagsFragmentDoc}
${ImageFragmentDoc}
${AuthorsFragmentDoc}
${UserFragmentDoc}`;
export const useGetArticleCardsQuery = <
      TData = GetArticleCardsQuery,
      TError = unknown
    >(
      variables: GetArticleCardsQueryVariables,
      options?: UseQueryOptions<GetArticleCardsQuery, TError, TData>
    ) =>
    useQuery<GetArticleCardsQuery, TError, TData>(
      ['GetArticleCards', variables],
      fetcher<GetArticleCardsQuery, GetArticleCardsQueryVariables>(GetArticleCardsDocument, variables),
      options
    );

useGetArticleCardsQuery.getKey = (variables: GetArticleCardsQueryVariables) => ['GetArticleCards', variables];
;

useGetArticleCardsQuery.fetcher = (variables: GetArticleCardsQueryVariables, options?: RequestInit['headers']) => fetcher<GetArticleCardsQuery, GetArticleCardsQueryVariables>(GetArticleCardsDocument, variables, options);
export const GetArticleCategoriesDocument = `
    query GetArticleCategories($locale: I18NLocaleCode) {
  articleCategories(locale: $locale) {
    data {
      id
      attributes {
        name
      }
    }
  }
}
    `;
export const useGetArticleCategoriesQuery = <
      TData = GetArticleCategoriesQuery,
      TError = unknown
    >(
      variables?: GetArticleCategoriesQueryVariables,
      options?: UseQueryOptions<GetArticleCategoriesQuery, TError, TData>
    ) =>
    useQuery<GetArticleCategoriesQuery, TError, TData>(
      variables === undefined ? ['GetArticleCategories'] : ['GetArticleCategories', variables],
      fetcher<GetArticleCategoriesQuery, GetArticleCategoriesQueryVariables>(GetArticleCategoriesDocument, variables),
      options
    );

useGetArticleCategoriesQuery.getKey = (variables?: GetArticleCategoriesQueryVariables) => variables === undefined ? ['GetArticleCategories'] : ['GetArticleCategories', variables];
;

useGetArticleCategoriesQuery.fetcher = (variables?: GetArticleCategoriesQueryVariables, options?: RequestInit['headers']) => fetcher<GetArticleCategoriesQuery, GetArticleCategoriesQueryVariables>(GetArticleCategoriesDocument, variables, options);
export const GetArticlesDocument = `
    query GetArticles {
  articles {
    data {
      attributes {
        slug
      }
    }
  }
}
    `;
export const useGetArticlesQuery = <
      TData = GetArticlesQuery,
      TError = unknown
    >(
      variables?: GetArticlesQueryVariables,
      options?: UseQueryOptions<GetArticlesQuery, TError, TData>
    ) =>
    useQuery<GetArticlesQuery, TError, TData>(
      variables === undefined ? ['GetArticles'] : ['GetArticles', variables],
      fetcher<GetArticlesQuery, GetArticlesQueryVariables>(GetArticlesDocument, variables),
      options
    );

useGetArticlesQuery.getKey = (variables?: GetArticlesQueryVariables) => variables === undefined ? ['GetArticles'] : ['GetArticles', variables];
;

useGetArticlesQuery.fetcher = (variables?: GetArticlesQueryVariables, options?: RequestInit['headers']) => fetcher<GetArticlesQuery, GetArticlesQueryVariables>(GetArticlesDocument, variables, options);
export const GetCaseStudiesDocument = `
    query GetCaseStudies($locale: I18NLocaleCode) {
  caseStudies(locale: $locale) {
    data {
      ...caseStudy
    }
  }
}
    ${CaseStudyFragmentDoc}
${ImageFragmentDoc}`;
export const useGetCaseStudiesQuery = <
      TData = GetCaseStudiesQuery,
      TError = unknown
    >(
      variables?: GetCaseStudiesQueryVariables,
      options?: UseQueryOptions<GetCaseStudiesQuery, TError, TData>
    ) =>
    useQuery<GetCaseStudiesQuery, TError, TData>(
      variables === undefined ? ['GetCaseStudies'] : ['GetCaseStudies', variables],
      fetcher<GetCaseStudiesQuery, GetCaseStudiesQueryVariables>(GetCaseStudiesDocument, variables),
      options
    );

useGetCaseStudiesQuery.getKey = (variables?: GetCaseStudiesQueryVariables) => variables === undefined ? ['GetCaseStudies'] : ['GetCaseStudies', variables];
;

useGetCaseStudiesQuery.fetcher = (variables?: GetCaseStudiesQueryVariables, options?: RequestInit['headers']) => fetcher<GetCaseStudiesQuery, GetCaseStudiesQueryVariables>(GetCaseStudiesDocument, variables, options);
export const GetCaseStudiesBySlugArrayDocument = `
    query GetCaseStudiesBySlugArray($slugs: [String!], $locale: I18NLocaleCode!) {
  caseStudies(filters: {slug: {in: $slugs}}, locale: $locale) {
    data {
      ...caseStudy
    }
  }
}
    ${CaseStudyFragmentDoc}
${ImageFragmentDoc}`;
export const useGetCaseStudiesBySlugArrayQuery = <
      TData = GetCaseStudiesBySlugArrayQuery,
      TError = unknown
    >(
      variables: GetCaseStudiesBySlugArrayQueryVariables,
      options?: UseQueryOptions<GetCaseStudiesBySlugArrayQuery, TError, TData>
    ) =>
    useQuery<GetCaseStudiesBySlugArrayQuery, TError, TData>(
      ['GetCaseStudiesBySlugArray', variables],
      fetcher<GetCaseStudiesBySlugArrayQuery, GetCaseStudiesBySlugArrayQueryVariables>(GetCaseStudiesBySlugArrayDocument, variables),
      options
    );

useGetCaseStudiesBySlugArrayQuery.getKey = (variables: GetCaseStudiesBySlugArrayQueryVariables) => ['GetCaseStudiesBySlugArray', variables];
;

useGetCaseStudiesBySlugArrayQuery.fetcher = (variables: GetCaseStudiesBySlugArrayQueryVariables, options?: RequestInit['headers']) => fetcher<GetCaseStudiesBySlugArrayQuery, GetCaseStudiesBySlugArrayQueryVariables>(GetCaseStudiesBySlugArrayDocument, variables, options);
export const GetCaseStudyAllDocument = `
    query GetCaseStudyAll($locale: I18NLocaleCode) {
  caseStudyAll(locale: $locale) {
    data {
      attributes {
        featured {
          ...featuredCaseStudy
        }
        metadata {
          ...metadata
        }
      }
    }
  }
}
    ${FeaturedCaseStudyFragmentDoc}
${CaseStudyFragmentDoc}
${ImageFragmentDoc}
${MetadataFragmentDoc}`;
export const useGetCaseStudyAllQuery = <
      TData = GetCaseStudyAllQuery,
      TError = unknown
    >(
      variables?: GetCaseStudyAllQueryVariables,
      options?: UseQueryOptions<GetCaseStudyAllQuery, TError, TData>
    ) =>
    useQuery<GetCaseStudyAllQuery, TError, TData>(
      variables === undefined ? ['GetCaseStudyAll'] : ['GetCaseStudyAll', variables],
      fetcher<GetCaseStudyAllQuery, GetCaseStudyAllQueryVariables>(GetCaseStudyAllDocument, variables),
      options
    );

useGetCaseStudyAllQuery.getKey = (variables?: GetCaseStudyAllQueryVariables) => variables === undefined ? ['GetCaseStudyAll'] : ['GetCaseStudyAll', variables];
;

useGetCaseStudyAllQuery.fetcher = (variables?: GetCaseStudyAllQueryVariables, options?: RequestInit['headers']) => fetcher<GetCaseStudyAllQuery, GetCaseStudyAllQueryVariables>(GetCaseStudyAllDocument, variables, options);
export const GetCaseStudyBySlugDocument = `
    query GetCaseStudyBySlug($slug: String!, $publicationState: PublicationState!, $locale: I18NLocaleCode!) {
  caseStudies(
    filters: {slug: {eq: $slug}}
    publicationState: $publicationState
    locale: $locale
  ) {
    data {
      ...caseStudy
      attributes {
        metadata {
          ...metadata
        }
        title
        titleMarkdown
        description
        descriptionMarkdown
        client
        clientTooltip
        location
        website
        projectStatus
        projectStartDate
        contentBlocks {
          ...richText
          ...dynamicSliderWithPoints
          ...dynamicInfoGrid
          ...dynamicTestimonial
          ...dynamicHero
          ...dynamicConstant
          ...dynamicFAQ
          ...dynamicPointsWithPhotos
          ...dynamicDarkInfoDivider
          ...dynamicInfoWithPhoto
          ...dynamicLogos
          ...dynamicRichText
          ...dynamicDividerWithPhotos
          ...dynamicGallerySection
          ...dynamicTextWithPhotos
          ...dynamicChartSection
          ...dynamicHistorySection
          ...dynamicTeamInvolved
          ...dynamicFeatureList
          ...dynamicHeroWithContact
          ...dynamicClientOpinions
          ...dynamicSeeMoreBlock
          ...dynamicPartnersBlock
          ...dynamicLeadership
          ...dynamicStatistics
          ...dynamicCaseStudiesPreview
          ...dynamicVideoBanner
          ...dynamicTeamInvolvedWithHover
          ...howWeWork
          ...dynamicScrollSlider
          ...dynamicMedia
          ...standaloneContactForm
          ...dynamicFaces
          ...dynamicRecommendedArticles
          ...caseStudiesShowcase
          ...letsBuildBlock
          ...newsletterBlock
          ...bannerBlock
        }
      }
    }
  }
}
    ${CaseStudyFragmentDoc}
${ImageFragmentDoc}
${MetadataFragmentDoc}
${RichTextFragmentDoc}
${RichTextBlockFragmentDoc}
${DynamicSliderWithPointsFragmentDoc}
${DynamicInfoGridFragmentDoc}
${DecoratedTextImgFragmentDoc}
${DynamicTestimonialFragmentDoc}
${DynamicHeroFragmentDoc}
${DynamicConstantFragmentDoc}
${DynamicFaqFragmentDoc}
${DynamicPointsWithPhotosFragmentDoc}
${DynamicDarkInfoDividerFragmentDoc}
${DynamicInfoWithPhotoFragmentDoc}
${DynamicLogosFragmentDoc}
${ImagesFragmentDoc}
${DynamicRichTextFragmentDoc}
${DynamicDividerWithPhotosFragmentDoc}
${DynamicGallerySectionFragmentDoc}
${DynamicTextWithPhotosFragmentDoc}
${ButtonFragmentDoc}
${AvatarWithHoverFragmentDoc}
${DynamicChartSectionFragmentDoc}
${DynamicHistorySectionFragmentDoc}
${DynamicTeamInvolvedFragmentDoc}
${DynamicFeatureListFragmentDoc}
${DynamicHeroWithContactFragmentDoc}
${DynamicClientOpinionsFragmentDoc}
${DynamicSeeMoreBlockFragmentDoc}
${DynamicPartnersBlockFragmentDoc}
${DynamicLeadershipFragmentDoc}
${DynamicStatisticsFragmentDoc}
${DynamicCaseStudiesPreviewFragmentDoc}
${DynamicVideoBannerFragmentDoc}
${DynamicTeamInvolvedWithHoverFragmentDoc}
${HowWeWorkFragmentDoc}
${DynamicScrollSliderFragmentDoc}
${DynamicMediaFragmentDoc}
${StandaloneContactFormFragmentDoc}
${DynamicFacesFragmentDoc}
${DynamicRecommendedArticlesFragmentDoc}
${CaseStudiesShowcaseFragmentDoc}
${LetsBuildBlockFragmentDoc}
${NewsletterBlockFragmentDoc}
${BannerBlockFragmentDoc}`;
export const useGetCaseStudyBySlugQuery = <
      TData = GetCaseStudyBySlugQuery,
      TError = unknown
    >(
      variables: GetCaseStudyBySlugQueryVariables,
      options?: UseQueryOptions<GetCaseStudyBySlugQuery, TError, TData>
    ) =>
    useQuery<GetCaseStudyBySlugQuery, TError, TData>(
      ['GetCaseStudyBySlug', variables],
      fetcher<GetCaseStudyBySlugQuery, GetCaseStudyBySlugQueryVariables>(GetCaseStudyBySlugDocument, variables),
      options
    );

useGetCaseStudyBySlugQuery.getKey = (variables: GetCaseStudyBySlugQueryVariables) => ['GetCaseStudyBySlug', variables];
;

useGetCaseStudyBySlugQuery.fetcher = (variables: GetCaseStudyBySlugQueryVariables, options?: RequestInit['headers']) => fetcher<GetCaseStudyBySlugQuery, GetCaseStudyBySlugQueryVariables>(GetCaseStudyBySlugDocument, variables, options);
export const GetDynamicPageBySlugDocument = `
    query GetDynamicPageBySlug($slug: String!, $publicationState: PublicationState!, $locale: I18NLocaleCode!) {
  pages(
    filters: {slug: {eq: $slug}}
    publicationState: $publicationState
    locale: $locale
  ) {
    data {
      id
      attributes {
        metadata {
          ...metadata
        }
        showHeader
        showFooter
        breadcrumbs {
          position
          modeColor
        }
        blocks {
          ...dynamicSliderWithPoints
          ...dynamicInfoGrid
          ...dynamicTestimonial
          ...dynamicHero
          ...dynamicConstant
          ...dynamicFAQ
          ...dynamicPointsWithPhotos
          ...dynamicDarkInfoDivider
          ...dynamicInfoWithPhoto
          ...dynamicLogos
          ...dynamicRichText
          ...dynamicDividerWithPhotos
          ...dynamicGallerySection
          ...dynamicTextWithPhotos
          ...dynamicChartSection
          ...dynamicHistorySection
          ...dynamicTeamInvolved
          ...dynamicFeatureList
          ...dynamicHeroWithContact
          ...dynamicClientOpinions
          ...dynamicSeeMoreBlock
          ...dynamicPartnersBlock
          ...dynamicLeadership
          ...dynamicStatistics
          ...dynamicCaseStudiesPreview
          ...dynamicVideoBanner
          ...dynamicTeamInvolvedWithHover
          ...howWeWork
          ...dynamicScrollSlider
          ...dynamicMedia
          ...standaloneContactForm
          ...dynamicFaces
          ...dynamicRecommendedArticles
          ...caseStudiesShowcase
          ...letsBuildBlock
          ...newsletterBlock
          ...bannerBlock
        }
      }
    }
  }
}
    ${MetadataFragmentDoc}
${ImageFragmentDoc}
${DynamicSliderWithPointsFragmentDoc}
${DynamicInfoGridFragmentDoc}
${DecoratedTextImgFragmentDoc}
${DynamicTestimonialFragmentDoc}
${DynamicHeroFragmentDoc}
${DynamicConstantFragmentDoc}
${DynamicFaqFragmentDoc}
${DynamicPointsWithPhotosFragmentDoc}
${DynamicDarkInfoDividerFragmentDoc}
${DynamicInfoWithPhotoFragmentDoc}
${DynamicLogosFragmentDoc}
${ImagesFragmentDoc}
${DynamicRichTextFragmentDoc}
${RichTextFragmentDoc}
${RichTextBlockFragmentDoc}
${DynamicDividerWithPhotosFragmentDoc}
${DynamicGallerySectionFragmentDoc}
${DynamicTextWithPhotosFragmentDoc}
${ButtonFragmentDoc}
${AvatarWithHoverFragmentDoc}
${DynamicChartSectionFragmentDoc}
${DynamicHistorySectionFragmentDoc}
${DynamicTeamInvolvedFragmentDoc}
${DynamicFeatureListFragmentDoc}
${DynamicHeroWithContactFragmentDoc}
${DynamicClientOpinionsFragmentDoc}
${DynamicSeeMoreBlockFragmentDoc}
${DynamicPartnersBlockFragmentDoc}
${DynamicLeadershipFragmentDoc}
${DynamicStatisticsFragmentDoc}
${DynamicCaseStudiesPreviewFragmentDoc}
${DynamicVideoBannerFragmentDoc}
${DynamicTeamInvolvedWithHoverFragmentDoc}
${HowWeWorkFragmentDoc}
${DynamicScrollSliderFragmentDoc}
${DynamicMediaFragmentDoc}
${StandaloneContactFormFragmentDoc}
${DynamicFacesFragmentDoc}
${DynamicRecommendedArticlesFragmentDoc}
${CaseStudiesShowcaseFragmentDoc}
${LetsBuildBlockFragmentDoc}
${NewsletterBlockFragmentDoc}
${BannerBlockFragmentDoc}`;
export const useGetDynamicPageBySlugQuery = <
      TData = GetDynamicPageBySlugQuery,
      TError = unknown
    >(
      variables: GetDynamicPageBySlugQueryVariables,
      options?: UseQueryOptions<GetDynamicPageBySlugQuery, TError, TData>
    ) =>
    useQuery<GetDynamicPageBySlugQuery, TError, TData>(
      ['GetDynamicPageBySlug', variables],
      fetcher<GetDynamicPageBySlugQuery, GetDynamicPageBySlugQueryVariables>(GetDynamicPageBySlugDocument, variables),
      options
    );

useGetDynamicPageBySlugQuery.getKey = (variables: GetDynamicPageBySlugQueryVariables) => ['GetDynamicPageBySlug', variables];
;

useGetDynamicPageBySlugQuery.fetcher = (variables: GetDynamicPageBySlugQueryVariables, options?: RequestInit['headers']) => fetcher<GetDynamicPageBySlugQuery, GetDynamicPageBySlugQueryVariables>(GetDynamicPageBySlugDocument, variables, options);
export const GetGlobalDocument = `
    query GetGlobal($locale: I18NLocaleCode!) {
  global(locale: $locale) {
    data {
      id
      attributes {
        metadata {
          ...metadata
        }
      }
    }
  }
}
    ${MetadataFragmentDoc}
${ImageFragmentDoc}`;
export const useGetGlobalQuery = <
      TData = GetGlobalQuery,
      TError = unknown
    >(
      variables: GetGlobalQueryVariables,
      options?: UseQueryOptions<GetGlobalQuery, TError, TData>
    ) =>
    useQuery<GetGlobalQuery, TError, TData>(
      ['GetGlobal', variables],
      fetcher<GetGlobalQuery, GetGlobalQueryVariables>(GetGlobalDocument, variables),
      options
    );

useGetGlobalQuery.getKey = (variables: GetGlobalQueryVariables) => ['GetGlobal', variables];
;

useGetGlobalQuery.fetcher = (variables: GetGlobalQueryVariables, options?: RequestInit['headers']) => fetcher<GetGlobalQuery, GetGlobalQueryVariables>(GetGlobalDocument, variables, options);
export const GetHomeDocument = `
    query GetHome($locale: I18NLocaleCode!) {
  home(locale: $locale) {
    data {
      attributes {
        metadata {
          ...metadata
        }
        clutchScore {
          ...clutchScore
        }
        companyStatistics {
          ...companyStatistics
        }
        letsMeet {
          ...letsMeet
        }
        techStack {
          ...techStack
        }
        caseStudies {
          ...caseStudies
        }
        partners {
          data {
            ...partner
          }
        }
        blocks {
          ...dynamicSliderWithPoints
          ...dynamicInfoGrid
          ...dynamicTestimonial
          ...dynamicHero
          ...dynamicConstant
          ...dynamicFAQ
          ...dynamicPointsWithPhotos
          ...dynamicDarkInfoDivider
          ...dynamicInfoWithPhoto
          ...dynamicLogos
          ...dynamicRichText
          ...dynamicDividerWithPhotos
          ...dynamicGallerySection
          ...dynamicTextWithPhotos
          ...dynamicChartSection
          ...dynamicHistorySection
          ...dynamicTeamInvolved
          ...dynamicFeatureList
          ...dynamicHeroWithContact
          ...dynamicClientOpinions
          ...dynamicSeeMoreBlock
          ...dynamicPartnersBlock
          ...dynamicLeadership
          ...dynamicStatistics
          ...dynamicCaseStudiesPreview
          ...dynamicVideoBanner
          ...dynamicTeamInvolvedWithHover
          ...dynamicYourTurnSection
          ...howWeWork
          ...dynamicScrollSlider
          ...dynamicMedia
          ...standaloneContactForm
          ...dynamicFaces
          ...dynamicRecommendedArticles
          ...caseStudiesShowcase
          ...letsBuildBlock
          ...newsletterBlock
          ...bannerBlock
        }
      }
    }
  }
}
    ${MetadataFragmentDoc}
${ImageFragmentDoc}
${ClutchScoreFragmentDoc}
${ClutchReviewFragmentDoc}
${CompanyStatisticsFragmentDoc}
${CompanyStatisticsCardFragmentDoc}
${LetsMeetFragmentDoc}
${LetsMeetTeamMemberFragmentDoc}
${ChatBubbleFragmentDoc}
${TechStackFragmentDoc}
${TechStackRowFragmentDoc}
${CaseStudiesFragmentDoc}
${CaseStudyFragmentDoc}
${PartnerFragmentDoc}
${DynamicSliderWithPointsFragmentDoc}
${DynamicInfoGridFragmentDoc}
${DecoratedTextImgFragmentDoc}
${DynamicTestimonialFragmentDoc}
${DynamicHeroFragmentDoc}
${DynamicConstantFragmentDoc}
${DynamicFaqFragmentDoc}
${DynamicPointsWithPhotosFragmentDoc}
${DynamicDarkInfoDividerFragmentDoc}
${DynamicInfoWithPhotoFragmentDoc}
${DynamicLogosFragmentDoc}
${ImagesFragmentDoc}
${DynamicRichTextFragmentDoc}
${RichTextFragmentDoc}
${RichTextBlockFragmentDoc}
${DynamicDividerWithPhotosFragmentDoc}
${DynamicGallerySectionFragmentDoc}
${DynamicTextWithPhotosFragmentDoc}
${ButtonFragmentDoc}
${AvatarWithHoverFragmentDoc}
${DynamicChartSectionFragmentDoc}
${DynamicHistorySectionFragmentDoc}
${DynamicTeamInvolvedFragmentDoc}
${DynamicFeatureListFragmentDoc}
${DynamicHeroWithContactFragmentDoc}
${DynamicClientOpinionsFragmentDoc}
${DynamicSeeMoreBlockFragmentDoc}
${DynamicPartnersBlockFragmentDoc}
${DynamicLeadershipFragmentDoc}
${DynamicStatisticsFragmentDoc}
${DynamicCaseStudiesPreviewFragmentDoc}
${DynamicVideoBannerFragmentDoc}
${DynamicTeamInvolvedWithHoverFragmentDoc}
${DynamicYourTurnSectionFragmentDoc}
${HowWeWorkFragmentDoc}
${DynamicScrollSliderFragmentDoc}
${DynamicMediaFragmentDoc}
${StandaloneContactFormFragmentDoc}
${DynamicFacesFragmentDoc}
${DynamicRecommendedArticlesFragmentDoc}
${CaseStudiesShowcaseFragmentDoc}
${LetsBuildBlockFragmentDoc}
${NewsletterBlockFragmentDoc}
${BannerBlockFragmentDoc}`;
export const useGetHomeQuery = <
      TData = GetHomeQuery,
      TError = unknown
    >(
      variables: GetHomeQueryVariables,
      options?: UseQueryOptions<GetHomeQuery, TError, TData>
    ) =>
    useQuery<GetHomeQuery, TError, TData>(
      ['GetHome', variables],
      fetcher<GetHomeQuery, GetHomeQueryVariables>(GetHomeDocument, variables),
      options
    );

useGetHomeQuery.getKey = (variables: GetHomeQueryVariables) => ['GetHome', variables];
;

useGetHomeQuery.fetcher = (variables: GetHomeQueryVariables, options?: RequestInit['headers']) => fetcher<GetHomeQuery, GetHomeQueryVariables>(GetHomeDocument, variables, options);
export const GetHotArticlesDocument = `
    query GetHotArticles {
  featuredArticle {
    data {
      id
      attributes {
        ...articleCard
      }
    }
  }
  resourcesPage {
    data {
      attributes {
        mostReadArticles {
          data {
            id
            attributes {
              ...articleCard
            }
          }
        }
      }
    }
  }
}
    ${ArticleCardFragmentDoc}
${ArticleTagsFragmentDoc}
${ImageFragmentDoc}
${AuthorsFragmentDoc}
${UserFragmentDoc}`;
export const useGetHotArticlesQuery = <
      TData = GetHotArticlesQuery,
      TError = unknown
    >(
      variables?: GetHotArticlesQueryVariables,
      options?: UseQueryOptions<GetHotArticlesQuery, TError, TData>
    ) =>
    useQuery<GetHotArticlesQuery, TError, TData>(
      variables === undefined ? ['GetHotArticles'] : ['GetHotArticles', variables],
      fetcher<GetHotArticlesQuery, GetHotArticlesQueryVariables>(GetHotArticlesDocument, variables),
      options
    );

useGetHotArticlesQuery.getKey = (variables?: GetHotArticlesQueryVariables) => variables === undefined ? ['GetHotArticles'] : ['GetHotArticles', variables];
;

useGetHotArticlesQuery.fetcher = (variables?: GetHotArticlesQueryVariables, options?: RequestInit['headers']) => fetcher<GetHotArticlesQuery, GetHotArticlesQueryVariables>(GetHotArticlesDocument, variables, options);
export const GetInventoryAllDocument = `
    query GetInventoryAll($locale: I18NLocaleCode) {
  inventoryAll(locale: $locale) {
    data {
      attributes {
        metadata {
          ...metadata
        }
      }
    }
  }
}
    ${MetadataFragmentDoc}
${ImageFragmentDoc}`;
export const useGetInventoryAllQuery = <
      TData = GetInventoryAllQuery,
      TError = unknown
    >(
      variables?: GetInventoryAllQueryVariables,
      options?: UseQueryOptions<GetInventoryAllQuery, TError, TData>
    ) =>
    useQuery<GetInventoryAllQuery, TError, TData>(
      variables === undefined ? ['GetInventoryAll'] : ['GetInventoryAll', variables],
      fetcher<GetInventoryAllQuery, GetInventoryAllQueryVariables>(GetInventoryAllDocument, variables),
      options
    );

useGetInventoryAllQuery.getKey = (variables?: GetInventoryAllQueryVariables) => variables === undefined ? ['GetInventoryAll'] : ['GetInventoryAll', variables];
;

useGetInventoryAllQuery.fetcher = (variables?: GetInventoryAllQueryVariables, options?: RequestInit['headers']) => fetcher<GetInventoryAllQuery, GetInventoryAllQueryVariables>(GetInventoryAllDocument, variables, options);
export const GetInventoryDefinitionsDocument = `
    query GetInventoryDefinitions($locale: I18NLocaleCode) {
  inventoryDefinitions(locale: $locale, pagination: {limit: 4000}) {
    data {
      attributes {
        title
        slug
        capitalLetter
      }
    }
  }
}
    `;
export const useGetInventoryDefinitionsQuery = <
      TData = GetInventoryDefinitionsQuery,
      TError = unknown
    >(
      variables?: GetInventoryDefinitionsQueryVariables,
      options?: UseQueryOptions<GetInventoryDefinitionsQuery, TError, TData>
    ) =>
    useQuery<GetInventoryDefinitionsQuery, TError, TData>(
      variables === undefined ? ['GetInventoryDefinitions'] : ['GetInventoryDefinitions', variables],
      fetcher<GetInventoryDefinitionsQuery, GetInventoryDefinitionsQueryVariables>(GetInventoryDefinitionsDocument, variables),
      options
    );

useGetInventoryDefinitionsQuery.getKey = (variables?: GetInventoryDefinitionsQueryVariables) => variables === undefined ? ['GetInventoryDefinitions'] : ['GetInventoryDefinitions', variables];
;

useGetInventoryDefinitionsQuery.fetcher = (variables?: GetInventoryDefinitionsQueryVariables, options?: RequestInit['headers']) => fetcher<GetInventoryDefinitionsQuery, GetInventoryDefinitionsQueryVariables>(GetInventoryDefinitionsDocument, variables, options);
export const GetInventoryDefinitionsByLetterDocument = `
    query GetInventoryDefinitionsByLetter($locale: I18NLocaleCode, $startsWith: String) {
  inventoryDefinitions(
    locale: $locale
    pagination: {limit: 1000}
    filters: {capitalLetter: {eq: $startsWith}}
  ) {
    data {
      attributes {
        title
        slug
      }
    }
  }
}
    `;
export const useGetInventoryDefinitionsByLetterQuery = <
      TData = GetInventoryDefinitionsByLetterQuery,
      TError = unknown
    >(
      variables?: GetInventoryDefinitionsByLetterQueryVariables,
      options?: UseQueryOptions<GetInventoryDefinitionsByLetterQuery, TError, TData>
    ) =>
    useQuery<GetInventoryDefinitionsByLetterQuery, TError, TData>(
      variables === undefined ? ['GetInventoryDefinitionsByLetter'] : ['GetInventoryDefinitionsByLetter', variables],
      fetcher<GetInventoryDefinitionsByLetterQuery, GetInventoryDefinitionsByLetterQueryVariables>(GetInventoryDefinitionsByLetterDocument, variables),
      options
    );

useGetInventoryDefinitionsByLetterQuery.getKey = (variables?: GetInventoryDefinitionsByLetterQueryVariables) => variables === undefined ? ['GetInventoryDefinitionsByLetter'] : ['GetInventoryDefinitionsByLetter', variables];
;

useGetInventoryDefinitionsByLetterQuery.fetcher = (variables?: GetInventoryDefinitionsByLetterQueryVariables, options?: RequestInit['headers']) => fetcher<GetInventoryDefinitionsByLetterQuery, GetInventoryDefinitionsByLetterQueryVariables>(GetInventoryDefinitionsByLetterDocument, variables, options);
export const GetInventoryDefinitionsFilteredBySlugDocument = `
    query GetInventoryDefinitionsFilteredBySlug($slug: String!, $publicationState: PublicationState!, $locale: I18NLocaleCode!) {
  inventoryDefinitions(
    filters: {slug: {eq: $slug}}
    publicationState: $publicationState
    locale: $locale
  ) {
    data {
      attributes {
        metadata {
          ...metadata
        }
        title
        slug
        content
        doodle {
          ...image
        }
        capitalLetter
        articles {
          data {
            attributes {
              title
              slug
              metadata {
                ...metadata
              }
            }
          }
        }
      }
    }
  }
}
    ${MetadataFragmentDoc}
${ImageFragmentDoc}`;
export const useGetInventoryDefinitionsFilteredBySlugQuery = <
      TData = GetInventoryDefinitionsFilteredBySlugQuery,
      TError = unknown
    >(
      variables: GetInventoryDefinitionsFilteredBySlugQueryVariables,
      options?: UseQueryOptions<GetInventoryDefinitionsFilteredBySlugQuery, TError, TData>
    ) =>
    useQuery<GetInventoryDefinitionsFilteredBySlugQuery, TError, TData>(
      ['GetInventoryDefinitionsFilteredBySlug', variables],
      fetcher<GetInventoryDefinitionsFilteredBySlugQuery, GetInventoryDefinitionsFilteredBySlugQueryVariables>(GetInventoryDefinitionsFilteredBySlugDocument, variables),
      options
    );

useGetInventoryDefinitionsFilteredBySlugQuery.getKey = (variables: GetInventoryDefinitionsFilteredBySlugQueryVariables) => ['GetInventoryDefinitionsFilteredBySlug', variables];
;

useGetInventoryDefinitionsFilteredBySlugQuery.fetcher = (variables: GetInventoryDefinitionsFilteredBySlugQueryVariables, options?: RequestInit['headers']) => fetcher<GetInventoryDefinitionsFilteredBySlugQuery, GetInventoryDefinitionsFilteredBySlugQueryVariables>(GetInventoryDefinitionsFilteredBySlugDocument, variables, options);
export const GetLibrariesDocument = `
    query GetLibraries($locale: I18NLocaleCode) {
  libraries(locale: $locale) {
    data {
      attributes {
        slug
        cover {
          ...image
        }
        title
        content
      }
    }
  }
}
    ${ImageFragmentDoc}`;
export const useGetLibrariesQuery = <
      TData = GetLibrariesQuery,
      TError = unknown
    >(
      variables?: GetLibrariesQueryVariables,
      options?: UseQueryOptions<GetLibrariesQuery, TError, TData>
    ) =>
    useQuery<GetLibrariesQuery, TError, TData>(
      variables === undefined ? ['GetLibraries'] : ['GetLibraries', variables],
      fetcher<GetLibrariesQuery, GetLibrariesQueryVariables>(GetLibrariesDocument, variables),
      options
    );

useGetLibrariesQuery.getKey = (variables?: GetLibrariesQueryVariables) => variables === undefined ? ['GetLibraries'] : ['GetLibraries', variables];
;

useGetLibrariesQuery.fetcher = (variables?: GetLibrariesQueryVariables, options?: RequestInit['headers']) => fetcher<GetLibrariesQuery, GetLibrariesQueryVariables>(GetLibrariesDocument, variables, options);
export const GetLibrariesFilteredBySlugDocument = `
    query GetLibrariesFilteredBySlug($slug: String!) {
  libraries(filters: {slug: {eq: $slug}}) {
    data {
      id
      attributes {
        metadata {
          ...metadata
        }
        slug
        cover {
          ...image
        }
        doodle {
          ...image
        }
        title
        content
      }
    }
  }
}
    ${MetadataFragmentDoc}
${ImageFragmentDoc}`;
export const useGetLibrariesFilteredBySlugQuery = <
      TData = GetLibrariesFilteredBySlugQuery,
      TError = unknown
    >(
      variables: GetLibrariesFilteredBySlugQueryVariables,
      options?: UseQueryOptions<GetLibrariesFilteredBySlugQuery, TError, TData>
    ) =>
    useQuery<GetLibrariesFilteredBySlugQuery, TError, TData>(
      ['GetLibrariesFilteredBySlug', variables],
      fetcher<GetLibrariesFilteredBySlugQuery, GetLibrariesFilteredBySlugQueryVariables>(GetLibrariesFilteredBySlugDocument, variables),
      options
    );

useGetLibrariesFilteredBySlugQuery.getKey = (variables: GetLibrariesFilteredBySlugQueryVariables) => ['GetLibrariesFilteredBySlug', variables];
;

useGetLibrariesFilteredBySlugQuery.fetcher = (variables: GetLibrariesFilteredBySlugQueryVariables, options?: RequestInit['headers']) => fetcher<GetLibrariesFilteredBySlugQuery, GetLibrariesFilteredBySlugQueryVariables>(GetLibrariesFilteredBySlugDocument, variables, options);
export const GetLibrariesPageDocument = `
    query GetLibrariesPage {
  guidesPage {
    data {
      attributes {
        metadata {
          ...metadata
        }
      }
    }
  }
}
    ${MetadataFragmentDoc}
${ImageFragmentDoc}`;
export const useGetLibrariesPageQuery = <
      TData = GetLibrariesPageQuery,
      TError = unknown
    >(
      variables?: GetLibrariesPageQueryVariables,
      options?: UseQueryOptions<GetLibrariesPageQuery, TError, TData>
    ) =>
    useQuery<GetLibrariesPageQuery, TError, TData>(
      variables === undefined ? ['GetLibrariesPage'] : ['GetLibrariesPage', variables],
      fetcher<GetLibrariesPageQuery, GetLibrariesPageQueryVariables>(GetLibrariesPageDocument, variables),
      options
    );

useGetLibrariesPageQuery.getKey = (variables?: GetLibrariesPageQueryVariables) => variables === undefined ? ['GetLibrariesPage'] : ['GetLibrariesPage', variables];
;

useGetLibrariesPageQuery.fetcher = (variables?: GetLibrariesPageQueryVariables, options?: RequestInit['headers']) => fetcher<GetLibrariesPageQuery, GetLibrariesPageQueryVariables>(GetLibrariesPageDocument, variables, options);
export const GetPrivacyPolicyDocument = `
    query GetPrivacyPolicy($locale: I18NLocaleCode) {
  privacyPolicy(locale: $locale) {
    data {
      attributes {
        privacyPolicy {
          lastUpdated {
            label
            date
          }
          intro
          paragraph {
            heading
            content
          }
        }
        metadata {
          ...metadata
        }
      }
    }
  }
}
    ${MetadataFragmentDoc}
${ImageFragmentDoc}`;
export const useGetPrivacyPolicyQuery = <
      TData = GetPrivacyPolicyQuery,
      TError = unknown
    >(
      variables?: GetPrivacyPolicyQueryVariables,
      options?: UseQueryOptions<GetPrivacyPolicyQuery, TError, TData>
    ) =>
    useQuery<GetPrivacyPolicyQuery, TError, TData>(
      variables === undefined ? ['GetPrivacyPolicy'] : ['GetPrivacyPolicy', variables],
      fetcher<GetPrivacyPolicyQuery, GetPrivacyPolicyQueryVariables>(GetPrivacyPolicyDocument, variables),
      options
    );

useGetPrivacyPolicyQuery.getKey = (variables?: GetPrivacyPolicyQueryVariables) => variables === undefined ? ['GetPrivacyPolicy'] : ['GetPrivacyPolicy', variables];
;

useGetPrivacyPolicyQuery.fetcher = (variables?: GetPrivacyPolicyQueryVariables, options?: RequestInit['headers']) => fetcher<GetPrivacyPolicyQuery, GetPrivacyPolicyQueryVariables>(GetPrivacyPolicyDocument, variables, options);
export const GetProposedArticlesDocument = `
    query GetProposedArticles($tags: [String]!, $slug: String!, $locale: I18NLocaleCode) {
  articles(
    filters: {tags: {name: {in: $tags}}, and: {slug: {ne: $slug}}}
    pagination: {limit: 3}
    locale: $locale
    sort: "createdAt:desc"
  ) {
    data {
      id
      attributes {
        ...articleCard
      }
    }
  }
}
    ${ArticleCardFragmentDoc}
${ArticleTagsFragmentDoc}
${ImageFragmentDoc}
${AuthorsFragmentDoc}
${UserFragmentDoc}`;
export const useGetProposedArticlesQuery = <
      TData = GetProposedArticlesQuery,
      TError = unknown
    >(
      variables: GetProposedArticlesQueryVariables,
      options?: UseQueryOptions<GetProposedArticlesQuery, TError, TData>
    ) =>
    useQuery<GetProposedArticlesQuery, TError, TData>(
      ['GetProposedArticles', variables],
      fetcher<GetProposedArticlesQuery, GetProposedArticlesQueryVariables>(GetProposedArticlesDocument, variables),
      options
    );

useGetProposedArticlesQuery.getKey = (variables: GetProposedArticlesQueryVariables) => ['GetProposedArticles', variables];
;

useGetProposedArticlesQuery.fetcher = (variables: GetProposedArticlesQueryVariables, options?: RequestInit['headers']) => fetcher<GetProposedArticlesQuery, GetProposedArticlesQueryVariables>(GetProposedArticlesDocument, variables, options);
export const GetProposedArticlesNoTagsFilterDocument = `
    query GetProposedArticlesNoTagsFilter($slug: String!, $locale: I18NLocaleCode) {
  articles(filters: {slug: {ne: $slug}}, pagination: {limit: 3}, locale: $locale) {
    data {
      id
      attributes {
        ...articleCard
      }
    }
  }
}
    ${ArticleCardFragmentDoc}
${ArticleTagsFragmentDoc}
${ImageFragmentDoc}
${AuthorsFragmentDoc}
${UserFragmentDoc}`;
export const useGetProposedArticlesNoTagsFilterQuery = <
      TData = GetProposedArticlesNoTagsFilterQuery,
      TError = unknown
    >(
      variables: GetProposedArticlesNoTagsFilterQueryVariables,
      options?: UseQueryOptions<GetProposedArticlesNoTagsFilterQuery, TError, TData>
    ) =>
    useQuery<GetProposedArticlesNoTagsFilterQuery, TError, TData>(
      ['GetProposedArticlesNoTagsFilter', variables],
      fetcher<GetProposedArticlesNoTagsFilterQuery, GetProposedArticlesNoTagsFilterQueryVariables>(GetProposedArticlesNoTagsFilterDocument, variables),
      options
    );

useGetProposedArticlesNoTagsFilterQuery.getKey = (variables: GetProposedArticlesNoTagsFilterQueryVariables) => ['GetProposedArticlesNoTagsFilter', variables];
;

useGetProposedArticlesNoTagsFilterQuery.fetcher = (variables: GetProposedArticlesNoTagsFilterQueryVariables, options?: RequestInit['headers']) => fetcher<GetProposedArticlesNoTagsFilterQuery, GetProposedArticlesNoTagsFilterQueryVariables>(GetProposedArticlesNoTagsFilterDocument, variables, options);
export const GetProposedCaseStudiesDocument = `
    query GetProposedCaseStudies($slug: String!) {
  caseStudies(
    sort: "updatedAt:desc"
    pagination: {limit: 3}
    filters: {slug: {ne: $slug}}
  ) {
    data {
      ...caseStudy
    }
  }
}
    ${CaseStudyFragmentDoc}
${ImageFragmentDoc}`;
export const useGetProposedCaseStudiesQuery = <
      TData = GetProposedCaseStudiesQuery,
      TError = unknown
    >(
      variables: GetProposedCaseStudiesQueryVariables,
      options?: UseQueryOptions<GetProposedCaseStudiesQuery, TError, TData>
    ) =>
    useQuery<GetProposedCaseStudiesQuery, TError, TData>(
      ['GetProposedCaseStudies', variables],
      fetcher<GetProposedCaseStudiesQuery, GetProposedCaseStudiesQueryVariables>(GetProposedCaseStudiesDocument, variables),
      options
    );

useGetProposedCaseStudiesQuery.getKey = (variables: GetProposedCaseStudiesQueryVariables) => ['GetProposedCaseStudies', variables];
;

useGetProposedCaseStudiesQuery.fetcher = (variables: GetProposedCaseStudiesQueryVariables, options?: RequestInit['headers']) => fetcher<GetProposedCaseStudiesQuery, GetProposedCaseStudiesQueryVariables>(GetProposedCaseStudiesDocument, variables, options);
export const GetResourcesPageDocument = `
    query GetResourcesPage($locale: I18NLocaleCode) {
  resourcesPage(locale: $locale) {
    data {
      attributes {
        metadata {
          ...metadata
        }
      }
    }
  }
}
    ${MetadataFragmentDoc}
${ImageFragmentDoc}`;
export const useGetResourcesPageQuery = <
      TData = GetResourcesPageQuery,
      TError = unknown
    >(
      variables?: GetResourcesPageQueryVariables,
      options?: UseQueryOptions<GetResourcesPageQuery, TError, TData>
    ) =>
    useQuery<GetResourcesPageQuery, TError, TData>(
      variables === undefined ? ['GetResourcesPage'] : ['GetResourcesPage', variables],
      fetcher<GetResourcesPageQuery, GetResourcesPageQueryVariables>(GetResourcesPageDocument, variables),
      options
    );

useGetResourcesPageQuery.getKey = (variables?: GetResourcesPageQueryVariables) => variables === undefined ? ['GetResourcesPage'] : ['GetResourcesPage', variables];
;

useGetResourcesPageQuery.fetcher = (variables?: GetResourcesPageQueryVariables, options?: RequestInit['headers']) => fetcher<GetResourcesPageQuery, GetResourcesPageQueryVariables>(GetResourcesPageDocument, variables, options);